(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],2:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":1,"buffer":2,"ieee754":3}],3:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],4:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],5:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":4,"timers":5}],6:[function(require,module,exports){
module.exports = require('./lib/heap');

},{"./lib/heap":7}],7:[function(require,module,exports){
// Generated by CoffeeScript 1.8.0
(function() {
  var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;

  floor = Math.floor, min = Math.min;


  /*
  Default comparison function to be used
   */

  defaultCmp = function(x, y) {
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  };


  /*
  Insert item x in list a, and keep it sorted assuming a is sorted.
  
  If x is already in a, insert it to the right of the rightmost x.
  
  Optional args lo (default 0) and hi (default a.length) bound the slice
  of a to be searched.
   */

  insort = function(a, x, lo, hi, cmp) {
    var mid;
    if (lo == null) {
      lo = 0;
    }
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (lo < 0) {
      throw new Error('lo must be non-negative');
    }
    if (hi == null) {
      hi = a.length;
    }
    while (lo < hi) {
      mid = floor((lo + hi) / 2);
      if (cmp(x, a[mid]) < 0) {
        hi = mid;
      } else {
        lo = mid + 1;
      }
    }
    return ([].splice.apply(a, [lo, lo - lo].concat(x)), x);
  };


  /*
  Push item onto heap, maintaining the heap invariant.
   */

  heappush = function(array, item, cmp) {
    if (cmp == null) {
      cmp = defaultCmp;
    }
    array.push(item);
    return _siftdown(array, 0, array.length - 1, cmp);
  };


  /*
  Pop the smallest item off the heap, maintaining the heap invariant.
   */

  heappop = function(array, cmp) {
    var lastelt, returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    lastelt = array.pop();
    if (array.length) {
      returnitem = array[0];
      array[0] = lastelt;
      _siftup(array, 0, cmp);
    } else {
      returnitem = lastelt;
    }
    return returnitem;
  };


  /*
  Pop and return the current smallest value, and add the new item.
  
  This is more efficient than heappop() followed by heappush(), and can be
  more appropriate when using a fixed size heap. Note that the value
  returned may be larger than item! That constrains reasonable use of
  this routine unless written as part of a conditional replacement:
      if item > array[0]
        item = heapreplace(array, item)
   */

  heapreplace = function(array, item, cmp) {
    var returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    returnitem = array[0];
    array[0] = item;
    _siftup(array, 0, cmp);
    return returnitem;
  };


  /*
  Fast version of a heappush followed by a heappop.
   */

  heappushpop = function(array, item, cmp) {
    var _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (array.length && cmp(array[0], item) < 0) {
      _ref = [array[0], item], item = _ref[0], array[0] = _ref[1];
      _siftup(array, 0, cmp);
    }
    return item;
  };


  /*
  Transform list into a heap, in-place, in O(array.length) time.
   */

  heapify = function(array, cmp) {
    var i, _i, _j, _len, _ref, _ref1, _results, _results1;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    _ref1 = (function() {
      _results1 = [];
      for (var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--){ _results1.push(_j); }
      return _results1;
    }).apply(this).reverse();
    _results = [];
    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
      i = _ref1[_i];
      _results.push(_siftup(array, i, cmp));
    }
    return _results;
  };


  /*
  Update the position of the given item in the heap.
  This function should be called every time the item is being modified.
   */

  updateItem = function(array, item, cmp) {
    var pos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    pos = array.indexOf(item);
    if (pos === -1) {
      return;
    }
    _siftdown(array, 0, pos, cmp);
    return _siftup(array, pos, cmp);
  };


  /*
  Find the n largest elements in a dataset.
   */

  nlargest = function(array, n, cmp) {
    var elem, result, _i, _len, _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    result = array.slice(0, n);
    if (!result.length) {
      return result;
    }
    heapify(result, cmp);
    _ref = array.slice(n);
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      elem = _ref[_i];
      heappushpop(result, elem, cmp);
    }
    return result.sort(cmp).reverse();
  };


  /*
  Find the n smallest elements in a dataset.
   */

  nsmallest = function(array, n, cmp) {
    var elem, i, los, result, _i, _j, _len, _ref, _ref1, _results;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (n * 10 <= array.length) {
      result = array.slice(0, n).sort(cmp);
      if (!result.length) {
        return result;
      }
      los = result[result.length - 1];
      _ref = array.slice(n);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elem = _ref[_i];
        if (cmp(elem, los) < 0) {
          insort(result, elem, 0, null, cmp);
          result.pop();
          los = result[result.length - 1];
        }
      }
      return result;
    }
    heapify(array, cmp);
    _results = [];
    for (i = _j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; i = 0 <= _ref1 ? ++_j : --_j) {
      _results.push(heappop(array, cmp));
    }
    return _results;
  };

  _siftdown = function(array, startpos, pos, cmp) {
    var newitem, parent, parentpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    newitem = array[pos];
    while (pos > startpos) {
      parentpos = (pos - 1) >> 1;
      parent = array[parentpos];
      if (cmp(newitem, parent) < 0) {
        array[pos] = parent;
        pos = parentpos;
        continue;
      }
      break;
    }
    return array[pos] = newitem;
  };

  _siftup = function(array, pos, cmp) {
    var childpos, endpos, newitem, rightpos, startpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    endpos = array.length;
    startpos = pos;
    newitem = array[pos];
    childpos = 2 * pos + 1;
    while (childpos < endpos) {
      rightpos = childpos + 1;
      if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) {
        childpos = rightpos;
      }
      array[pos] = array[childpos];
      pos = childpos;
      childpos = 2 * pos + 1;
    }
    array[pos] = newitem;
    return _siftdown(array, startpos, pos, cmp);
  };

  Heap = (function() {
    Heap.push = heappush;

    Heap.pop = heappop;

    Heap.replace = heapreplace;

    Heap.pushpop = heappushpop;

    Heap.heapify = heapify;

    Heap.updateItem = updateItem;

    Heap.nlargest = nlargest;

    Heap.nsmallest = nsmallest;

    function Heap(cmp) {
      this.cmp = cmp != null ? cmp : defaultCmp;
      this.nodes = [];
    }

    Heap.prototype.push = function(x) {
      return heappush(this.nodes, x, this.cmp);
    };

    Heap.prototype.pop = function() {
      return heappop(this.nodes, this.cmp);
    };

    Heap.prototype.peek = function() {
      return this.nodes[0];
    };

    Heap.prototype.contains = function(x) {
      return this.nodes.indexOf(x) !== -1;
    };

    Heap.prototype.replace = function(x) {
      return heapreplace(this.nodes, x, this.cmp);
    };

    Heap.prototype.pushpop = function(x) {
      return heappushpop(this.nodes, x, this.cmp);
    };

    Heap.prototype.heapify = function() {
      return heapify(this.nodes, this.cmp);
    };

    Heap.prototype.updateItem = function(x) {
      return updateItem(this.nodes, x, this.cmp);
    };

    Heap.prototype.clear = function() {
      return this.nodes = [];
    };

    Heap.prototype.empty = function() {
      return this.nodes.length === 0;
    };

    Heap.prototype.size = function() {
      return this.nodes.length;
    };

    Heap.prototype.clone = function() {
      var heap;
      heap = new Heap();
      heap.nodes = this.nodes.slice(0);
      return heap;
    };

    Heap.prototype.toArray = function() {
      return this.nodes.slice(0);
    };

    Heap.prototype.insert = Heap.prototype.push;

    Heap.prototype.top = Heap.prototype.peek;

    Heap.prototype.front = Heap.prototype.peek;

    Heap.prototype.has = Heap.prototype.contains;

    Heap.prototype.copy = Heap.prototype.clone;

    return Heap;

  })();

  if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
    module.exports = Heap;
  } else {
    window.Heap = Heap;
  }

}).call(this);

},{}],8:[function(require,module,exports){
/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */

(function(global){

  // Passing in seed will seed this Noise instance
  function Noise(seed) {
    function Grad(x, y, z) {
      this.x = x; this.y = y; this.z = z;
    }

    Grad.prototype.dot2 = function(x, y) {
      return this.x*x + this.y*y;
    };

    Grad.prototype.dot3 = function(x, y, z) {
      return this.x*x + this.y*y + this.z*z;
    };

    this.grad3 = [new Grad(1,1,0),new Grad(-1,1,0),new Grad(1,-1,0),new Grad(-1,-1,0),
                 new Grad(1,0,1),new Grad(-1,0,1),new Grad(1,0,-1),new Grad(-1,0,-1),
                 new Grad(0,1,1),new Grad(0,-1,1),new Grad(0,1,-1),new Grad(0,-1,-1)];

    this.p = [151,160,137,91,90,15,
    131,13,201,95,96,53,194,233,7,225,140,36,103,30,69,142,8,99,37,240,21,10,23,
    190, 6,148,247,120,234,75,0,26,197,62,94,252,219,203,117,35,11,32,57,177,33,
    88,237,149,56,87,174,20,125,136,171,168, 68,175,74,165,71,134,139,48,27,166,
    77,146,158,231,83,111,229,122,60,211,133,230,220,105,92,41,55,46,245,40,244,
    102,143,54, 65,25,63,161, 1,216,80,73,209,76,132,187,208, 89,18,169,200,196,
    135,130,116,188,159,86,164,100,109,198,173,186, 3,64,52,217,226,250,124,123,
    5,202,38,147,118,126,255,82,85,212,207,206,59,227,47,16,58,17,182,189,28,42,
    223,183,170,213,119,248,152, 2,44,154,163, 70,221,153,101,155,167, 43,172,9,
    129,22,39,253, 19,98,108,110,79,113,224,232,178,185, 112,104,218,246,97,228,
    251,34,242,193,238,210,144,12,191,179,162,241, 81,51,145,235,249,14,239,107,
    49,192,214, 31,181,199,106,157,184, 84,204,176,115,121,50,45,127, 4,150,254,
    138,236,205,93,222,114,67,29,24,72,243,141,128,195,78,66,215,61,156,180];
    // To remove the need for index wrapping, double the permutation table length
    this.perm = new Array(512);
    this.gradP = new Array(512);

    this.seed(seed || 0);
  }

  // This isn't a very good seeding function, but it works ok. It supports 2^16
  // different seed values. Write something better if you need more seeds.
  Noise.prototype.seed = function(seed) {
    if(seed > 0 && seed < 1) {
      // Scale the seed out
      seed *= 65536;
    }

    seed = Math.floor(seed);
    if(seed < 256) {
      seed |= seed << 8;
    }

    var p = this.p;
    for(var i = 0; i < 256; i++) {
      var v;
      if (i & 1) {
        v = p[i] ^ (seed & 255);
      } else {
        v = p[i] ^ ((seed>>8) & 255);
      }

      var perm = this.perm;
      var gradP = this.gradP;
      perm[i] = perm[i + 256] = v;
      gradP[i] = gradP[i + 256] = this.grad3[v % 12];
    }
  };

  /*
  for(var i=0; i<256; i++) {
    perm[i] = perm[i + 256] = p[i];
    gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
  }*/

  // Skewing and unskewing factors for 2, 3, and 4 dimensions
  var F2 = 0.5*(Math.sqrt(3)-1);
  var G2 = (3-Math.sqrt(3))/6;

  var F3 = 1/3;
  var G3 = 1/6;

  // 2D simplex noise
  Noise.prototype.simplex2 = function(xin, yin) {
    var n0, n1, n2; // Noise contributions from the three corners
    // Skew the input space to determine which simplex cell we're in
    var s = (xin+yin)*F2; // Hairy factor for 2D
    var i = Math.floor(xin+s);
    var j = Math.floor(yin+s);
    var t = (i+j)*G2;
    var x0 = xin-i+t; // The x,y distances from the cell origin, unskewed.
    var y0 = yin-j+t;
    // For the 2D case, the simplex shape is an equilateral triangle.
    // Determine which simplex we are in.
    var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
    if(x0>y0) { // lower triangle, XY order: (0,0)->(1,0)->(1,1)
      i1=1; j1=0;
    } else {    // upper triangle, YX order: (0,0)->(0,1)->(1,1)
      i1=0; j1=1;
    }
    // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
    // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
    // c = (3-sqrt(3))/6
    var x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
    var y1 = y0 - j1 + G2;
    var x2 = x0 - 1 + 2 * G2; // Offsets for last corner in (x,y) unskewed coords
    var y2 = y0 - 1 + 2 * G2;
    // Work out the hashed gradient indices of the three simplex corners
    i &= 255;
    j &= 255;

    var perm = this.perm;
    var gradP = this.gradP;
    var gi0 = gradP[i+perm[j]];
    var gi1 = gradP[i+i1+perm[j+j1]];
    var gi2 = gradP[i+1+perm[j+1]];
    // Calculate the contribution from the three corners
    var t0 = 0.5 - x0*x0-y0*y0;
    if(t0<0) {
      n0 = 0;
    } else {
      t0 *= t0;
      n0 = t0 * t0 * gi0.dot2(x0, y0);  // (x,y) of grad3 used for 2D gradient
    }
    var t1 = 0.5 - x1*x1-y1*y1;
    if(t1<0) {
      n1 = 0;
    } else {
      t1 *= t1;
      n1 = t1 * t1 * gi1.dot2(x1, y1);
    }
    var t2 = 0.5 - x2*x2-y2*y2;
    if(t2<0) {
      n2 = 0;
    } else {
      t2 *= t2;
      n2 = t2 * t2 * gi2.dot2(x2, y2);
    }
    // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 70 * (n0 + n1 + n2);
  };

  // 3D simplex noise
  Noise.prototype.simplex3 = function(xin, yin, zin) {
    var n0, n1, n2, n3; // Noise contributions from the four corners

    // Skew the input space to determine which simplex cell we're in
    var s = (xin+yin+zin)*F3; // Hairy factor for 2D
    var i = Math.floor(xin+s);
    var j = Math.floor(yin+s);
    var k = Math.floor(zin+s);

    var t = (i+j+k)*G3;
    var x0 = xin-i+t; // The x,y distances from the cell origin, unskewed.
    var y0 = yin-j+t;
    var z0 = zin-k+t;

    // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
    // Determine which simplex we are in.
    var i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
    var i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
    if(x0 >= y0) {
      if(y0 >= z0)      { i1=1; j1=0; k1=0; i2=1; j2=1; k2=0; }
      else if(x0 >= z0) { i1=1; j1=0; k1=0; i2=1; j2=0; k2=1; }
      else              { i1=0; j1=0; k1=1; i2=1; j2=0; k2=1; }
    } else {
      if(y0 < z0)      { i1=0; j1=0; k1=1; i2=0; j2=1; k2=1; }
      else if(x0 < z0) { i1=0; j1=1; k1=0; i2=0; j2=1; k2=1; }
      else             { i1=0; j1=1; k1=0; i2=1; j2=1; k2=0; }
    }
    // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
    // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
    // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
    // c = 1/6.
    var x1 = x0 - i1 + G3; // Offsets for second corner
    var y1 = y0 - j1 + G3;
    var z1 = z0 - k1 + G3;

    var x2 = x0 - i2 + 2 * G3; // Offsets for third corner
    var y2 = y0 - j2 + 2 * G3;
    var z2 = z0 - k2 + 2 * G3;

    var x3 = x0 - 1 + 3 * G3; // Offsets for fourth corner
    var y3 = y0 - 1 + 3 * G3;
    var z3 = z0 - 1 + 3 * G3;

    // Work out the hashed gradient indices of the four simplex corners
    i &= 255;
    j &= 255;
    k &= 255;

    var perm = this.perm;
    var gradP = this.gradP;
    var gi0 = gradP[i+   perm[j+   perm[k   ]]];
    var gi1 = gradP[i+i1+perm[j+j1+perm[k+k1]]];
    var gi2 = gradP[i+i2+perm[j+j2+perm[k+k2]]];
    var gi3 = gradP[i+ 1+perm[j+ 1+perm[k+ 1]]];

    // Calculate the contribution from the four corners
    var t0 = 0.5 - x0*x0-y0*y0-z0*z0;
    if(t0<0) {
      n0 = 0;
    } else {
      t0 *= t0;
      n0 = t0 * t0 * gi0.dot3(x0, y0, z0);  // (x,y) of grad3 used for 2D gradient
    }
    var t1 = 0.5 - x1*x1-y1*y1-z1*z1;
    if(t1<0) {
      n1 = 0;
    } else {
      t1 *= t1;
      n1 = t1 * t1 * gi1.dot3(x1, y1, z1);
    }
    var t2 = 0.5 - x2*x2-y2*y2-z2*z2;
    if(t2<0) {
      n2 = 0;
    } else {
      t2 *= t2;
      n2 = t2 * t2 * gi2.dot3(x2, y2, z2);
    }
    var t3 = 0.5 - x3*x3-y3*y3-z3*z3;
    if(t3<0) {
      n3 = 0;
    } else {
      t3 *= t3;
      n3 = t3 * t3 * gi3.dot3(x3, y3, z3);
    }
    // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 32 * (n0 + n1 + n2 + n3);

  };

  // ##### Perlin noise stuff

  function fade(t) {
    return t*t*t*(t*(t*6-15)+10);
  }

  function lerp(a, b, t) {
    return (1-t)*a + t*b;
  }

  // 2D Perlin Noise
  Noise.prototype.perlin2 = function(x, y) {
    // Find unit grid cell containing point
    var X = Math.floor(x), Y = Math.floor(y);
    // Get relative xy coordinates of point within that cell
    x = x - X; y = y - Y;
    // Wrap the integer cells at 255 (smaller integer period can be introduced here)
    X = X & 255; Y = Y & 255;

    // Calculate noise contributions from each of the four corners
    var perm = this.perm;
    var gradP = this.gradP;
    var n00 = gradP[X+perm[Y]].dot2(x, y);
    var n01 = gradP[X+perm[Y+1]].dot2(x, y-1);
    var n10 = gradP[X+1+perm[Y]].dot2(x-1, y);
    var n11 = gradP[X+1+perm[Y+1]].dot2(x-1, y-1);

    // Compute the fade curve value for x
    var u = fade(x);

    // Interpolate the four results
    return lerp(
        lerp(n00, n10, u),
        lerp(n01, n11, u),
       fade(y));
  };

  // 3D Perlin Noise
  Noise.prototype.perlin3 = function(x, y, z) {
    // Find unit grid cell containing point
    var X = Math.floor(x), Y = Math.floor(y), Z = Math.floor(z);
    // Get relative xyz coordinates of point within that cell
    x = x - X; y = y - Y; z = z - Z;
    // Wrap the integer cells at 255 (smaller integer period can be introduced here)
    X = X & 255; Y = Y & 255; Z = Z & 255;

    // Calculate noise contributions from each of the eight corners
    var perm = this.perm;
    var gradP = this.gradP;
    var n000 = gradP[X+  perm[Y+  perm[Z  ]]].dot3(x,   y,     z);
    var n001 = gradP[X+  perm[Y+  perm[Z+1]]].dot3(x,   y,   z-1);
    var n010 = gradP[X+  perm[Y+1+perm[Z  ]]].dot3(x,   y-1,   z);
    var n011 = gradP[X+  perm[Y+1+perm[Z+1]]].dot3(x,   y-1, z-1);
    var n100 = gradP[X+1+perm[Y+  perm[Z  ]]].dot3(x-1,   y,   z);
    var n101 = gradP[X+1+perm[Y+  perm[Z+1]]].dot3(x-1,   y, z-1);
    var n110 = gradP[X+1+perm[Y+1+perm[Z  ]]].dot3(x-1, y-1,   z);
    var n111 = gradP[X+1+perm[Y+1+perm[Z+1]]].dot3(x-1, y-1, z-1);

    // Compute the fade curve value for x, y, z
    var u = fade(x);
    var v = fade(y);
    var w = fade(z);

    // Interpolate
    return lerp(
        lerp(
          lerp(n000, n100, u),
          lerp(n001, n101, u), w),
        lerp(
          lerp(n010, n110, u),
          lerp(n011, n111, u), w),
       v);
  };

  global.Noise = Noise;

})(typeof module === "undefined" ? this : module.exports);

},{}],9:[function(require,module,exports){
module.exports = require('./src/PathFinding');

},{"./src/PathFinding":10}],10:[function(require,module,exports){
module.exports = {
    'Heap'                      : require('heap'),
    'Node'                      : require('./core/Node'),
    'Grid'                      : require('./core/Grid'),
    'Util'                      : require('./core/Util'),
    'DiagonalMovement'          : require('./core/DiagonalMovement'),
    'Heuristic'                 : require('./core/Heuristic'),
    'AStarFinder'               : require('./finders/AStarFinder'),
    'BestFirstFinder'           : require('./finders/BestFirstFinder'),
    'BreadthFirstFinder'        : require('./finders/BreadthFirstFinder'),
    'DijkstraFinder'            : require('./finders/DijkstraFinder'),
    'BiAStarFinder'             : require('./finders/BiAStarFinder'),
    'BiBestFirstFinder'         : require('./finders/BiBestFirstFinder'),
    'BiBreadthFirstFinder'      : require('./finders/BiBreadthFirstFinder'),
    'BiDijkstraFinder'          : require('./finders/BiDijkstraFinder'),
    'IDAStarFinder'             : require('./finders/IDAStarFinder'),
    'JumpPointFinder'           : require('./finders/JumpPointFinder'),
};

},{"./core/DiagonalMovement":11,"./core/Grid":12,"./core/Heuristic":13,"./core/Node":14,"./core/Util":15,"./finders/AStarFinder":16,"./finders/BestFirstFinder":17,"./finders/BiAStarFinder":18,"./finders/BiBestFirstFinder":19,"./finders/BiBreadthFirstFinder":20,"./finders/BiDijkstraFinder":21,"./finders/BreadthFirstFinder":22,"./finders/DijkstraFinder":23,"./finders/IDAStarFinder":24,"./finders/JumpPointFinder":29,"heap":6}],11:[function(require,module,exports){
var DiagonalMovement = {
    Always: 1,
    Never: 2,
    IfAtMostOneObstacle: 3,
    OnlyWhenNoObstacles: 4
};

module.exports = DiagonalMovement;
},{}],12:[function(require,module,exports){
var Node = require('./Node');
var DiagonalMovement = require('./DiagonalMovement');

/**
 * The Grid class, which serves as the encapsulation of the layout of the nodes.
 * @constructor
 * @param {number|Array<Array<(number|boolean)>>} width_or_matrix Number of columns of the grid, or matrix
 * @param {number} height Number of rows of the grid.
 * @param {Array<Array<(number|boolean)>>} [matrix] - A 0-1 matrix
 *     representing the walkable status of the nodes(0 or false for walkable).
 *     If the matrix is not supplied, all the nodes will be walkable.  */
function Grid(width_or_matrix, height, matrix) {
    var width;

    if (typeof width_or_matrix !== 'object') {
        width = width_or_matrix;
    } else {
        height = width_or_matrix.length;
        width = width_or_matrix[0].length;
        matrix = width_or_matrix;
    }

    /**
     * The number of columns of the grid.
     * @type number
     */
    this.width = width;
    /**
     * The number of rows of the grid.
     * @type number
     */
    this.height = height;

    /**
     * A 2D array of nodes.
     */
    this.nodes = this._buildNodes(width, height, matrix);
}

/**
 * Build and return the nodes.
 * @private
 * @param {number} width
 * @param {number} height
 * @param {Array<Array<number|boolean>>} [matrix] - A 0-1 matrix representing
 *     the walkable status of the nodes.
 * @see Grid
 */
Grid.prototype._buildNodes = function(width, height, matrix) {
    var i, j,
        nodes = new Array(height);

    for (i = 0; i < height; ++i) {
        nodes[i] = new Array(width);
        for (j = 0; j < width; ++j) {
            nodes[i][j] = new Node(j, i);
        }
    }


    if (matrix === undefined) {
        return nodes;
    }

    if (matrix.length !== height || matrix[0].length !== width) {
        throw new Error('Matrix size does not fit');
    }

    for (i = 0; i < height; ++i) {
        for (j = 0; j < width; ++j) {
            if (matrix[i][j]) {
                // 0, false, null will be walkable
                // while others will be un-walkable
                nodes[i][j].walkable = false;
            }
        }
    }

    return nodes;
};


Grid.prototype.getNodeAt = function(x, y) {
    return this.nodes[y][x];
};


/**
 * Determine whether the node at the given position is walkable.
 * (Also returns false if the position is outside the grid.)
 * @param {number} x - The x coordinate of the node.
 * @param {number} y - The y coordinate of the node.
 * @return {boolean} - The walkability of the node.
 */
Grid.prototype.isWalkableAt = function(x, y) {
    return this.isInside(x, y) && this.nodes[y][x].walkable;
};


/**
 * Determine whether the position is inside the grid.
 * XXX: `grid.isInside(x, y)` is wierd to read.
 * It should be `(x, y) is inside grid`, but I failed to find a better
 * name for this method.
 * @param {number} x
 * @param {number} y
 * @return {boolean}
 */
Grid.prototype.isInside = function(x, y) {
    return (x >= 0 && x < this.width) && (y >= 0 && y < this.height);
};


/**
 * Set whether the node on the given position is walkable.
 * NOTE: throws exception if the coordinate is not inside the grid.
 * @param {number} x - The x coordinate of the node.
 * @param {number} y - The y coordinate of the node.
 * @param {boolean} walkable - Whether the position is walkable.
 */
Grid.prototype.setWalkableAt = function(x, y, walkable) {
    this.nodes[y][x].walkable = walkable;
};


/**
 * Get the neighbors of the given node.
 *
 *     offsets      diagonalOffsets:
 *  +---+---+---+    +---+---+---+
 *  |   | 0 |   |    | 0 |   | 1 |
 *  +---+---+---+    +---+---+---+
 *  | 3 |   | 1 |    |   |   |   |
 *  +---+---+---+    +---+---+---+
 *  |   | 2 |   |    | 3 |   | 2 |
 *  +---+---+---+    +---+---+---+
 *
 *  When allowDiagonal is true, if offsets[i] is valid, then
 *  diagonalOffsets[i] and
 *  diagonalOffsets[(i + 1) % 4] is valid.
 * @param {Node} node
 * @param {DiagonalMovement} diagonalMovement
 */
Grid.prototype.getNeighbors = function(node, diagonalMovement) {
    var x = node.x,
        y = node.y,
        neighbors = [],
        s0 = false, d0 = false,
        s1 = false, d1 = false,
        s2 = false, d2 = false,
        s3 = false, d3 = false,
        nodes = this.nodes;

    // ↑
    if (this.isWalkableAt(x, y - 1)) {
        neighbors.push(nodes[y - 1][x]);
        s0 = true;
    }
    // →
    if (this.isWalkableAt(x + 1, y)) {
        neighbors.push(nodes[y][x + 1]);
        s1 = true;
    }
    // ↓
    if (this.isWalkableAt(x, y + 1)) {
        neighbors.push(nodes[y + 1][x]);
        s2 = true;
    }
    // ←
    if (this.isWalkableAt(x - 1, y)) {
        neighbors.push(nodes[y][x - 1]);
        s3 = true;
    }

    if (diagonalMovement === DiagonalMovement.Never) {
        return neighbors;
    }

    if (diagonalMovement === DiagonalMovement.OnlyWhenNoObstacles) {
        d0 = s3 && s0;
        d1 = s0 && s1;
        d2 = s1 && s2;
        d3 = s2 && s3;
    } else if (diagonalMovement === DiagonalMovement.IfAtMostOneObstacle) {
        d0 = s3 || s0;
        d1 = s0 || s1;
        d2 = s1 || s2;
        d3 = s2 || s3;
    } else if (diagonalMovement === DiagonalMovement.Always) {
        d0 = true;
        d1 = true;
        d2 = true;
        d3 = true;
    } else {
        throw new Error('Incorrect value of diagonalMovement');
    }

    // ↖
    if (d0 && this.isWalkableAt(x - 1, y - 1)) {
        neighbors.push(nodes[y - 1][x - 1]);
    }
    // ↗
    if (d1 && this.isWalkableAt(x + 1, y - 1)) {
        neighbors.push(nodes[y - 1][x + 1]);
    }
    // ↘
    if (d2 && this.isWalkableAt(x + 1, y + 1)) {
        neighbors.push(nodes[y + 1][x + 1]);
    }
    // ↙
    if (d3 && this.isWalkableAt(x - 1, y + 1)) {
        neighbors.push(nodes[y + 1][x - 1]);
    }

    return neighbors;
};


/**
 * Get a clone of this grid.
 * @return {Grid} Cloned grid.
 */
Grid.prototype.clone = function() {
    var i, j,

        width = this.width,
        height = this.height,
        thisNodes = this.nodes,

        newGrid = new Grid(width, height),
        newNodes = new Array(height);

    for (i = 0; i < height; ++i) {
        newNodes[i] = new Array(width);
        for (j = 0; j < width; ++j) {
            newNodes[i][j] = new Node(j, i, thisNodes[i][j].walkable);
        }
    }

    newGrid.nodes = newNodes;

    return newGrid;
};

module.exports = Grid;

},{"./DiagonalMovement":11,"./Node":14}],13:[function(require,module,exports){
/**
 * @namespace PF.Heuristic
 * @description A collection of heuristic functions.
 */
module.exports = {

  /**
   * Manhattan distance.
   * @param {number} dx - Difference in x.
   * @param {number} dy - Difference in y.
   * @return {number} dx + dy
   */
  manhattan: function(dx, dy) {
      return dx + dy;
  },

  /**
   * Euclidean distance.
   * @param {number} dx - Difference in x.
   * @param {number} dy - Difference in y.
   * @return {number} sqrt(dx * dx + dy * dy)
   */
  euclidean: function(dx, dy) {
      return Math.sqrt(dx * dx + dy * dy);
  },

  /**
   * Octile distance.
   * @param {number} dx - Difference in x.
   * @param {number} dy - Difference in y.
   * @return {number} sqrt(dx * dx + dy * dy) for grids
   */
  octile: function(dx, dy) {
      var F = Math.SQRT2 - 1;
      return (dx < dy) ? F * dx + dy : F * dy + dx;
  },

  /**
   * Chebyshev distance.
   * @param {number} dx - Difference in x.
   * @param {number} dy - Difference in y.
   * @return {number} max(dx, dy)
   */
  chebyshev: function(dx, dy) {
      return Math.max(dx, dy);
  }

};

},{}],14:[function(require,module,exports){
/**
 * A node in grid. 
 * This class holds some basic information about a node and custom 
 * attributes may be added, depending on the algorithms' needs.
 * @constructor
 * @param {number} x - The x coordinate of the node on the grid.
 * @param {number} y - The y coordinate of the node on the grid.
 * @param {boolean} [walkable] - Whether this node is walkable.
 */
function Node(x, y, walkable) {
    /**
     * The x coordinate of the node on the grid.
     * @type number
     */
    this.x = x;
    /**
     * The y coordinate of the node on the grid.
     * @type number
     */
    this.y = y;
    /**
     * Whether this node can be walked through.
     * @type boolean
     */
    this.walkable = (walkable === undefined ? true : walkable);
}

module.exports = Node;

},{}],15:[function(require,module,exports){
/**
 * Backtrace according to the parent records and return the path.
 * (including both start and end nodes)
 * @param {Node} node End node
 * @return {Array<Array<number>>} the path
 */
function backtrace(node) {
    var path = [[node.x, node.y]];
    while (node.parent) {
        node = node.parent;
        path.push([node.x, node.y]);
    }
    return path.reverse();
}
exports.backtrace = backtrace;

/**
 * Backtrace from start and end node, and return the path.
 * (including both start and end nodes)
 * @param {Node}
 * @param {Node}
 */
function biBacktrace(nodeA, nodeB) {
    var pathA = backtrace(nodeA),
        pathB = backtrace(nodeB);
    return pathA.concat(pathB.reverse());
}
exports.biBacktrace = biBacktrace;

/**
 * Compute the length of the path.
 * @param {Array<Array<number>>} path The path
 * @return {number} The length of the path
 */
function pathLength(path) {
    var i, sum = 0, a, b, dx, dy;
    for (i = 1; i < path.length; ++i) {
        a = path[i - 1];
        b = path[i];
        dx = a[0] - b[0];
        dy = a[1] - b[1];
        sum += Math.sqrt(dx * dx + dy * dy);
    }
    return sum;
}
exports.pathLength = pathLength;


/**
 * Given the start and end coordinates, return all the coordinates lying
 * on the line formed by these coordinates, based on Bresenham's algorithm.
 * http://en.wikipedia.org/wiki/Bresenham's_line_algorithm#Simplification
 * @param {number} x0 Start x coordinate
 * @param {number} y0 Start y coordinate
 * @param {number} x1 End x coordinate
 * @param {number} y1 End y coordinate
 * @return {Array<Array<number>>} The coordinates on the line
 */
function interpolate(x0, y0, x1, y1) {
    var abs = Math.abs,
        line = [],
        sx, sy, dx, dy, err, e2;

    dx = abs(x1 - x0);
    dy = abs(y1 - y0);

    sx = (x0 < x1) ? 1 : -1;
    sy = (y0 < y1) ? 1 : -1;

    err = dx - dy;

    while (true) {
        line.push([x0, y0]);

        if (x0 === x1 && y0 === y1) {
            break;
        }
        
        e2 = 2 * err;
        if (e2 > -dy) {
            err = err - dy;
            x0 = x0 + sx;
        }
        if (e2 < dx) {
            err = err + dx;
            y0 = y0 + sy;
        }
    }

    return line;
}
exports.interpolate = interpolate;


/**
 * Given a compressed path, return a new path that has all the segments
 * in it interpolated.
 * @param {Array<Array<number>>} path The path
 * @return {Array<Array<number>>} expanded path
 */
function expandPath(path) {
    var expanded = [],
        len = path.length,
        coord0, coord1,
        interpolated,
        interpolatedLen,
        i, j;

    if (len < 2) {
        return expanded;
    }

    for (i = 0; i < len - 1; ++i) {
        coord0 = path[i];
        coord1 = path[i + 1];

        interpolated = interpolate(coord0[0], coord0[1], coord1[0], coord1[1]);
        interpolatedLen = interpolated.length;
        for (j = 0; j < interpolatedLen - 1; ++j) {
            expanded.push(interpolated[j]);
        }
    }
    expanded.push(path[len - 1]);

    return expanded;
}
exports.expandPath = expandPath;


/**
 * Smoothen the give path.
 * The original path will not be modified; a new path will be returned.
 * @param {PF.Grid} grid
 * @param {Array<Array<number>>} path The path
 */
function smoothenPath(grid, path) {
    var len = path.length,
        x0 = path[0][0],        // path start x
        y0 = path[0][1],        // path start y
        x1 = path[len - 1][0],  // path end x
        y1 = path[len - 1][1],  // path end y
        sx, sy,                 // current start coordinate
        ex, ey,                 // current end coordinate
        newPath,
        i, j, coord, line, testCoord, blocked;

    sx = x0;
    sy = y0;
    newPath = [[sx, sy]];

    for (i = 2; i < len; ++i) {
        coord = path[i];
        ex = coord[0];
        ey = coord[1];
        line = interpolate(sx, sy, ex, ey);

        blocked = false;
        for (j = 1; j < line.length; ++j) {
            testCoord = line[j];

            if (!grid.isWalkableAt(testCoord[0], testCoord[1])) {
                blocked = true;
                break;
            }
        }
        if (blocked) {
            lastValidCoord = path[i - 1];
            newPath.push(lastValidCoord);
            sx = lastValidCoord[0];
            sy = lastValidCoord[1];
        }
    }
    newPath.push([x1, y1]);

    return newPath;
}
exports.smoothenPath = smoothenPath;


/**
 * Compress a path, remove redundant nodes without altering the shape
 * The original path is not modified
 * @param {Array<Array<number>>} path The path
 * @return {Array<Array<number>>} The compressed path
 */
function compressPath(path) {

    // nothing to compress
    if(path.length < 3) {
        return path;
    }

    var compressed = [],
        sx = path[0][0], // start x
        sy = path[0][1], // start y
        px = path[1][0], // second point x
        py = path[1][1], // second point y
        dx = px - sx, // direction between the two points
        dy = py - sy, // direction between the two points
        lx, ly,
        ldx, ldy,
        sq, i;

    // normalize the direction
    sq = Math.sqrt(dx*dx + dy*dy);
    dx /= sq;
    dy /= sq;

    // start the new path
    compressed.push([sx,sy]);

    for(i = 2; i < path.length; i++) {

        // store the last point
        lx = px;
        ly = py;

        // store the last direction
        ldx = dx;
        ldy = dy;

        // next point
        px = path[i][0];
        py = path[i][1];

        // next direction
        dx = px - lx;
        dy = py - ly;

        // normalize
        sq = Math.sqrt(dx*dx + dy*dy);
        dx /= sq;
        dy /= sq;

        // if the direction has changed, store the point
        if ( dx !== ldx || dy !== ldy ) {
            compressed.push([lx,ly]);
        }
    }

    // store the last point
    compressed.push([px,py]);

    return compressed;
}
exports.compressPath = compressPath;

},{}],16:[function(require,module,exports){
var Heap       = require('heap');
var Util       = require('../core/Util');
var Heuristic  = require('../core/Heuristic');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * A* path-finder. Based upon https://github.com/bgrins/javascript-astar
 * @constructor
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching 
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 * @param {number} opt.weight Weight to apply to the heuristic to allow for
 *     suboptimal paths, in order to speed up the search.
 */
function AStarFinder(opt) {
    opt = opt || {};
    this.allowDiagonal = opt.allowDiagonal;
    this.dontCrossCorners = opt.dontCrossCorners;
    this.heuristic = opt.heuristic || Heuristic.manhattan;
    this.weight = opt.weight || 1;
    this.diagonalMovement = opt.diagonalMovement;

    if (!this.diagonalMovement) {
        if (!this.allowDiagonal) {
            this.diagonalMovement = DiagonalMovement.Never;
        } else {
            if (this.dontCrossCorners) {
                this.diagonalMovement = DiagonalMovement.OnlyWhenNoObstacles;
            } else {
                this.diagonalMovement = DiagonalMovement.IfAtMostOneObstacle;
            }
        }
    }

    // When diagonal movement is allowed the manhattan heuristic is not
    //admissible. It should be octile instead
    if (this.diagonalMovement === DiagonalMovement.Never) {
        this.heuristic = opt.heuristic || Heuristic.manhattan;
    } else {
        this.heuristic = opt.heuristic || Heuristic.octile;
    }
}

/**
 * Find and return the the path.
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
AStarFinder.prototype.findPath = function(startX, startY, endX, endY, grid) {
    var openList = new Heap(function(nodeA, nodeB) {
            return nodeA.f - nodeB.f;
        }),
        startNode = grid.getNodeAt(startX, startY),
        endNode = grid.getNodeAt(endX, endY),
        heuristic = this.heuristic,
        diagonalMovement = this.diagonalMovement,
        weight = this.weight,
        abs = Math.abs, SQRT2 = Math.SQRT2,
        node, neighbors, neighbor, i, l, x, y, ng;

    // set the `g` and `f` value of the start node to be 0
    startNode.g = 0;
    startNode.f = 0;

    // push the start node into the open list
    openList.push(startNode);
    startNode.opened = true;

    // while the open list is not empty
    while (!openList.empty()) {
        // pop the position of node which has the minimum `f` value.
        node = openList.pop();
        node.closed = true;

        // if reached the end position, construct the path and return it
        if (node === endNode) {
            return Util.backtrace(endNode);
        }

        // get neigbours of the current node
        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            if (neighbor.closed) {
                continue;
            }

            x = neighbor.x;
            y = neighbor.y;

            // get the distance between current node and the neighbor
            // and calculate the next g score
            ng = node.g + ((x - node.x === 0 || y - node.y === 0) ? 1 : SQRT2);

            // check if the neighbor has not been inspected yet, or
            // can be reached with smaller cost from the current node
            if (!neighbor.opened || ng < neighbor.g) {
                neighbor.g = ng;
                neighbor.h = neighbor.h || weight * heuristic(abs(x - endX), abs(y - endY));
                neighbor.f = neighbor.g + neighbor.h;
                neighbor.parent = node;

                if (!neighbor.opened) {
                    openList.push(neighbor);
                    neighbor.opened = true;
                } else {
                    // the neighbor can be reached with smaller cost.
                    // Since its f value has been updated, we have to
                    // update its position in the open list
                    openList.updateItem(neighbor);
                }
            }
        } // end for each neighbor
    } // end while not open list empty

    // fail to find the path
    return [];
};

module.exports = AStarFinder;

},{"../core/DiagonalMovement":11,"../core/Heuristic":13,"../core/Util":15,"heap":6}],17:[function(require,module,exports){
var AStarFinder = require('./AStarFinder');

/**
 * Best-First-Search path-finder.
 * @constructor
 * @extends AStarFinder
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 */
function BestFirstFinder(opt) {
    AStarFinder.call(this, opt);

    var orig = this.heuristic;
    this.heuristic = function(dx, dy) {
        return orig(dx, dy) * 1000000;
    };
}

BestFirstFinder.prototype = new AStarFinder();
BestFirstFinder.prototype.constructor = BestFirstFinder;

module.exports = BestFirstFinder;

},{"./AStarFinder":16}],18:[function(require,module,exports){
var Heap       = require('heap');
var Util       = require('../core/Util');
var Heuristic  = require('../core/Heuristic');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * A* path-finder.
 * based upon https://github.com/bgrins/javascript-astar
 * @constructor
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 * @param {number} opt.weight Weight to apply to the heuristic to allow for
 *     suboptimal paths, in order to speed up the search.
 */
function BiAStarFinder(opt) {
    opt = opt || {};
    this.allowDiagonal = opt.allowDiagonal;
    this.dontCrossCorners = opt.dontCrossCorners;
    this.diagonalMovement = opt.diagonalMovement;
    this.heuristic = opt.heuristic || Heuristic.manhattan;
    this.weight = opt.weight || 1;

    if (!this.diagonalMovement) {
        if (!this.allowDiagonal) {
            this.diagonalMovement = DiagonalMovement.Never;
        } else {
            if (this.dontCrossCorners) {
                this.diagonalMovement = DiagonalMovement.OnlyWhenNoObstacles;
            } else {
                this.diagonalMovement = DiagonalMovement.IfAtMostOneObstacle;
            }
        }
    }

    //When diagonal movement is allowed the manhattan heuristic is not admissible
    //It should be octile instead
    if (this.diagonalMovement === DiagonalMovement.Never) {
        this.heuristic = opt.heuristic || Heuristic.manhattan;
    } else {
        this.heuristic = opt.heuristic || Heuristic.octile;
    }
}

/**
 * Find and return the the path.
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
BiAStarFinder.prototype.findPath = function(startX, startY, endX, endY, grid) {
    var cmp = function(nodeA, nodeB) {
            return nodeA.f - nodeB.f;
        },
        startOpenList = new Heap(cmp),
        endOpenList = new Heap(cmp),
        startNode = grid.getNodeAt(startX, startY),
        endNode = grid.getNodeAt(endX, endY),
        heuristic = this.heuristic,
        diagonalMovement = this.diagonalMovement,
        weight = this.weight,
        abs = Math.abs, SQRT2 = Math.SQRT2,
        node, neighbors, neighbor, i, l, x, y, ng,
        BY_START = 1, BY_END = 2;

    // set the `g` and `f` value of the start node to be 0
    // and push it into the start open list
    startNode.g = 0;
    startNode.f = 0;
    startOpenList.push(startNode);
    startNode.opened = BY_START;

    // set the `g` and `f` value of the end node to be 0
    // and push it into the open open list
    endNode.g = 0;
    endNode.f = 0;
    endOpenList.push(endNode);
    endNode.opened = BY_END;

    // while both the open lists are not empty
    while (!startOpenList.empty() && !endOpenList.empty()) {

        // pop the position of start node which has the minimum `f` value.
        node = startOpenList.pop();
        node.closed = true;

        // get neigbours of the current node
        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            if (neighbor.closed) {
                continue;
            }
            if (neighbor.opened === BY_END) {
                return Util.biBacktrace(node, neighbor);
            }

            x = neighbor.x;
            y = neighbor.y;

            // get the distance between current node and the neighbor
            // and calculate the next g score
            ng = node.g + ((x - node.x === 0 || y - node.y === 0) ? 1 : SQRT2);

            // check if the neighbor has not been inspected yet, or
            // can be reached with smaller cost from the current node
            if (!neighbor.opened || ng < neighbor.g) {
                neighbor.g = ng;
                neighbor.h = neighbor.h ||
                    weight * heuristic(abs(x - endX), abs(y - endY));
                neighbor.f = neighbor.g + neighbor.h;
                neighbor.parent = node;

                if (!neighbor.opened) {
                    startOpenList.push(neighbor);
                    neighbor.opened = BY_START;
                } else {
                    // the neighbor can be reached with smaller cost.
                    // Since its f value has been updated, we have to
                    // update its position in the open list
                    startOpenList.updateItem(neighbor);
                }
            }
        } // end for each neighbor


        // pop the position of end node which has the minimum `f` value.
        node = endOpenList.pop();
        node.closed = true;

        // get neigbours of the current node
        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            if (neighbor.closed) {
                continue;
            }
            if (neighbor.opened === BY_START) {
                return Util.biBacktrace(neighbor, node);
            }

            x = neighbor.x;
            y = neighbor.y;

            // get the distance between current node and the neighbor
            // and calculate the next g score
            ng = node.g + ((x - node.x === 0 || y - node.y === 0) ? 1 : SQRT2);

            // check if the neighbor has not been inspected yet, or
            // can be reached with smaller cost from the current node
            if (!neighbor.opened || ng < neighbor.g) {
                neighbor.g = ng;
                neighbor.h = neighbor.h ||
                    weight * heuristic(abs(x - startX), abs(y - startY));
                neighbor.f = neighbor.g + neighbor.h;
                neighbor.parent = node;

                if (!neighbor.opened) {
                    endOpenList.push(neighbor);
                    neighbor.opened = BY_END;
                } else {
                    // the neighbor can be reached with smaller cost.
                    // Since its f value has been updated, we have to
                    // update its position in the open list
                    endOpenList.updateItem(neighbor);
                }
            }
        } // end for each neighbor
    } // end while not open list empty

    // fail to find the path
    return [];
};

module.exports = BiAStarFinder;

},{"../core/DiagonalMovement":11,"../core/Heuristic":13,"../core/Util":15,"heap":6}],19:[function(require,module,exports){
var BiAStarFinder = require('./BiAStarFinder');

/**
 * Bi-direcitional Best-First-Search path-finder.
 * @constructor
 * @extends BiAStarFinder
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 */
function BiBestFirstFinder(opt) {
    BiAStarFinder.call(this, opt);

    var orig = this.heuristic;
    this.heuristic = function(dx, dy) {
        return orig(dx, dy) * 1000000;
    };
}

BiBestFirstFinder.prototype = new BiAStarFinder();
BiBestFirstFinder.prototype.constructor = BiBestFirstFinder;

module.exports = BiBestFirstFinder;

},{"./BiAStarFinder":18}],20:[function(require,module,exports){
var Util = require('../core/Util');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Bi-directional Breadth-First-Search path finder.
 * @constructor
 * @param {object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 */
function BiBreadthFirstFinder(opt) {
    opt = opt || {};
    this.allowDiagonal = opt.allowDiagonal;
    this.dontCrossCorners = opt.dontCrossCorners;
    this.diagonalMovement = opt.diagonalMovement;

    if (!this.diagonalMovement) {
        if (!this.allowDiagonal) {
            this.diagonalMovement = DiagonalMovement.Never;
        } else {
            if (this.dontCrossCorners) {
                this.diagonalMovement = DiagonalMovement.OnlyWhenNoObstacles;
            } else {
                this.diagonalMovement = DiagonalMovement.IfAtMostOneObstacle;
            }
        }
    }
}


/**
 * Find and return the the path.
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
BiBreadthFirstFinder.prototype.findPath = function(startX, startY, endX, endY, grid) {
    var startNode = grid.getNodeAt(startX, startY),
        endNode = grid.getNodeAt(endX, endY),
        startOpenList = [], endOpenList = [],
        neighbors, neighbor, node,
        diagonalMovement = this.diagonalMovement,
        BY_START = 0, BY_END = 1,
        i, l;

    // push the start and end nodes into the queues
    startOpenList.push(startNode);
    startNode.opened = true;
    startNode.by = BY_START;

    endOpenList.push(endNode);
    endNode.opened = true;
    endNode.by = BY_END;

    // while both the queues are not empty
    while (startOpenList.length && endOpenList.length) {

        // expand start open list

        node = startOpenList.shift();
        node.closed = true;

        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            if (neighbor.closed) {
                continue;
            }
            if (neighbor.opened) {
                // if this node has been inspected by the reversed search,
                // then a path is found.
                if (neighbor.by === BY_END) {
                    return Util.biBacktrace(node, neighbor);
                }
                continue;
            }
            startOpenList.push(neighbor);
            neighbor.parent = node;
            neighbor.opened = true;
            neighbor.by = BY_START;
        }

        // expand end open list

        node = endOpenList.shift();
        node.closed = true;

        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            if (neighbor.closed) {
                continue;
            }
            if (neighbor.opened) {
                if (neighbor.by === BY_START) {
                    return Util.biBacktrace(neighbor, node);
                }
                continue;
            }
            endOpenList.push(neighbor);
            neighbor.parent = node;
            neighbor.opened = true;
            neighbor.by = BY_END;
        }
    }

    // fail to find the path
    return [];
};

module.exports = BiBreadthFirstFinder;

},{"../core/DiagonalMovement":11,"../core/Util":15}],21:[function(require,module,exports){
var BiAStarFinder = require('./BiAStarFinder');

/**
 * Bi-directional Dijkstra path-finder.
 * @constructor
 * @extends BiAStarFinder
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 */
function BiDijkstraFinder(opt) {
    BiAStarFinder.call(this, opt);
    this.heuristic = function(dx, dy) {
        return 0;
    };
}

BiDijkstraFinder.prototype = new BiAStarFinder();
BiDijkstraFinder.prototype.constructor = BiDijkstraFinder;

module.exports = BiDijkstraFinder;

},{"./BiAStarFinder":18}],22:[function(require,module,exports){
var Util = require('../core/Util');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Breadth-First-Search path finder.
 * @constructor
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 */
function BreadthFirstFinder(opt) {
    opt = opt || {};
    this.allowDiagonal = opt.allowDiagonal;
    this.dontCrossCorners = opt.dontCrossCorners;
    this.diagonalMovement = opt.diagonalMovement;

    if (!this.diagonalMovement) {
        if (!this.allowDiagonal) {
            this.diagonalMovement = DiagonalMovement.Never;
        } else {
            if (this.dontCrossCorners) {
                this.diagonalMovement = DiagonalMovement.OnlyWhenNoObstacles;
            } else {
                this.diagonalMovement = DiagonalMovement.IfAtMostOneObstacle;
            }
        }
    }
}

/**
 * Find and return the the path.
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
BreadthFirstFinder.prototype.findPath = function(startX, startY, endX, endY, grid) {
    var openList = [],
        diagonalMovement = this.diagonalMovement,
        startNode = grid.getNodeAt(startX, startY),
        endNode = grid.getNodeAt(endX, endY),
        neighbors, neighbor, node, i, l;

    // push the start pos into the queue
    openList.push(startNode);
    startNode.opened = true;

    // while the queue is not empty
    while (openList.length) {
        // take the front node from the queue
        node = openList.shift();
        node.closed = true;

        // reached the end position
        if (node === endNode) {
            return Util.backtrace(endNode);
        }

        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            // skip this neighbor if it has been inspected before
            if (neighbor.closed || neighbor.opened) {
                continue;
            }

            openList.push(neighbor);
            neighbor.opened = true;
            neighbor.parent = node;
        }
    }
    
    // fail to find the path
    return [];
};

module.exports = BreadthFirstFinder;

},{"../core/DiagonalMovement":11,"../core/Util":15}],23:[function(require,module,exports){
var AStarFinder = require('./AStarFinder');

/**
 * Dijkstra path-finder.
 * @constructor
 * @extends AStarFinder
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 */
function DijkstraFinder(opt) {
    AStarFinder.call(this, opt);
    this.heuristic = function(dx, dy) {
        return 0;
    };
}

DijkstraFinder.prototype = new AStarFinder();
DijkstraFinder.prototype.constructor = DijkstraFinder;

module.exports = DijkstraFinder;

},{"./AStarFinder":16}],24:[function(require,module,exports){
var Util       = require('../core/Util');
var Heuristic  = require('../core/Heuristic');
var Node       = require('../core/Node');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Iterative Deeping A Star (IDA*) path-finder.
 *
 * Recursion based on:
 *   http://www.apl.jhu.edu/~hall/AI-Programming/IDA-Star.html
 *
 * Path retracing based on:
 *  V. Nageshwara Rao, Vipin Kumar and K. Ramesh
 *  "A Parallel Implementation of Iterative-Deeping-A*", January 1987.
 *  ftp://ftp.cs.utexas.edu/.snapshot/hourly.1/pub/AI-Lab/tech-reports/UT-AI-TR-87-46.pdf
 *
 * @author Gerard Meier (www.gerardmeier.com)
 *
 * @constructor
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 * @param {number} opt.weight Weight to apply to the heuristic to allow for
 *     suboptimal paths, in order to speed up the search.
 * @param {boolean} opt.trackRecursion Whether to track recursion for
 *     statistical purposes.
 * @param {number} opt.timeLimit Maximum execution time. Use <= 0 for infinite.
 */
function IDAStarFinder(opt) {
    opt = opt || {};
    this.allowDiagonal = opt.allowDiagonal;
    this.dontCrossCorners = opt.dontCrossCorners;
    this.diagonalMovement = opt.diagonalMovement;
    this.heuristic = opt.heuristic || Heuristic.manhattan;
    this.weight = opt.weight || 1;
    this.trackRecursion = opt.trackRecursion || false;
    this.timeLimit = opt.timeLimit || Infinity; // Default: no time limit.

    if (!this.diagonalMovement) {
        if (!this.allowDiagonal) {
            this.diagonalMovement = DiagonalMovement.Never;
        } else {
            if (this.dontCrossCorners) {
                this.diagonalMovement = DiagonalMovement.OnlyWhenNoObstacles;
            } else {
                this.diagonalMovement = DiagonalMovement.IfAtMostOneObstacle;
            }
        }
    }

    // When diagonal movement is allowed the manhattan heuristic is not
    // admissible, it should be octile instead
    if (this.diagonalMovement === DiagonalMovement.Never) {
        this.heuristic = opt.heuristic || Heuristic.manhattan;
    } else {
        this.heuristic = opt.heuristic || Heuristic.octile;
    }
}

/**
 * Find and return the the path. When an empty array is returned, either
 * no path is possible, or the maximum execution time is reached.
 *
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
IDAStarFinder.prototype.findPath = function(startX, startY, endX, endY, grid) {
    // Used for statistics:
    var nodesVisited = 0;

    // Execution time limitation:
    var startTime = new Date().getTime();

    // Heuristic helper:
    var h = function(a, b) {
        return this.heuristic(Math.abs(b.x - a.x), Math.abs(b.y - a.y));
    }.bind(this);

    // Step cost from a to b:
    var cost = function(a, b) {
        return (a.x === b.x || a.y === b.y) ? 1 : Math.SQRT2;
    };

    /**
     * IDA* search implementation.
     *
     * @param {Node} The node currently expanding from.
     * @param {number} Cost to reach the given node.
     * @param {number} Maximum search depth (cut-off value).
     * @param {Array<Array<number>>} The found route.
     * @param {number} Recursion depth.
     *
     * @return {Object} either a number with the new optimal cut-off depth,
     * or a valid node instance, in which case a path was found.
     */
    var search = function(node, g, cutoff, route, depth) {
        nodesVisited++;

        // Enforce timelimit:
        if (this.timeLimit > 0 &&
            new Date().getTime() - startTime > this.timeLimit * 1000) {
            // Enforced as "path-not-found".
            return Infinity;
        }

        var f = g + h(node, end) * this.weight;

        // We've searched too deep for this iteration.
        if (f > cutoff) {
            return f;
        }

        if (node == end) {
            route[depth] = [node.x, node.y];
            return node;
        }

        var min, t, k, neighbour;

        var neighbours = grid.getNeighbors(node, this.diagonalMovement);

        // Sort the neighbours, gives nicer paths. But, this deviates
        // from the original algorithm - so I left it out.
        //neighbours.sort(function(a, b){
        //    return h(a, end) - h(b, end);
        //});

        
        /*jshint -W084 *///Disable warning: Expected a conditional expression and instead saw an assignment
        for (k = 0, min = Infinity; neighbour = neighbours[k]; ++k) {
        /*jshint +W084 *///Enable warning: Expected a conditional expression and instead saw an assignment
            if (this.trackRecursion) {
                // Retain a copy for visualisation. Due to recursion, this
                // node may be part of other paths too.
                neighbour.retainCount = neighbour.retainCount + 1 || 1;

                if(neighbour.tested !== true) {
                    neighbour.tested = true;
                }
            }

            t = search(neighbour, g + cost(node, neighbour), cutoff, route, depth + 1);

            if (t instanceof Node) {
                route[depth] = [node.x, node.y];

                // For a typical A* linked list, this would work:
                // neighbour.parent = node;
                return t;
            }

            // Decrement count, then determine whether it's actually closed.
            if (this.trackRecursion && (--neighbour.retainCount) === 0) {
                neighbour.tested = false;
            }

            if (t < min) {
                min = t;
            }
        }

        return min;

    }.bind(this);

    // Node instance lookups:
    var start = grid.getNodeAt(startX, startY);
    var end   = grid.getNodeAt(endX, endY);

    // Initial search depth, given the typical heuristic contraints,
    // there should be no cheaper route possible.
    var cutOff = h(start, end);

    var j, route, t;

    // With an overflow protection.
    for (j = 0; true; ++j) {

        route = [];

        // Search till cut-off depth:
        t = search(start, 0, cutOff, route, 0);

        // Route not possible, or not found in time limit.
        if (t === Infinity) {
            return [];
        }

        // If t is a node, it's also the end node. Route is now
        // populated with a valid path to the end node.
        if (t instanceof Node) {
            return route;
        }

        // Try again, this time with a deeper cut-off. The t score
        // is the closest we got to the end node.
        cutOff = t;
    }

    // This _should_ never to be reached.
    return [];
};

module.exports = IDAStarFinder;

},{"../core/DiagonalMovement":11,"../core/Heuristic":13,"../core/Node":14,"../core/Util":15}],25:[function(require,module,exports){
/**
 * @author imor / https://github.com/imor
 */
var JumpPointFinderBase = require('./JumpPointFinderBase');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Path finder using the Jump Point Search algorithm which always moves
 * diagonally irrespective of the number of obstacles.
 */
function JPFAlwaysMoveDiagonally(opt) {
    JumpPointFinderBase.call(this, opt);
}

JPFAlwaysMoveDiagonally.prototype = new JumpPointFinderBase();
JPFAlwaysMoveDiagonally.prototype.constructor = JPFAlwaysMoveDiagonally;

/**
 * Search recursively in the direction (parent -> child), stopping only when a
 * jump point is found.
 * @protected
 * @return {Array<Array<number>>} The x, y coordinate of the jump point
 *     found, or null if not found
 */
JPFAlwaysMoveDiagonally.prototype._jump = function(x, y, px, py) {
    var grid = this.grid,
        dx = x - px, dy = y - py;

    if (!grid.isWalkableAt(x, y)) {
        return null;
    }

    if(this.trackJumpRecursion === true) {
        grid.getNodeAt(x, y).tested = true;
    }

    if (grid.getNodeAt(x, y) === this.endNode) {
        return [x, y];
    }

    // check for forced neighbors
    // along the diagonal
    if (dx !== 0 && dy !== 0) {
        if ((grid.isWalkableAt(x - dx, y + dy) && !grid.isWalkableAt(x - dx, y)) ||
            (grid.isWalkableAt(x + dx, y - dy) && !grid.isWalkableAt(x, y - dy))) {
            return [x, y];
        }
        // when moving diagonally, must check for vertical/horizontal jump points
        if (this._jump(x + dx, y, x, y) || this._jump(x, y + dy, x, y)) {
            return [x, y];
        }
    }
    // horizontally/vertically
    else {
        if( dx !== 0 ) { // moving along x
            if((grid.isWalkableAt(x + dx, y + 1) && !grid.isWalkableAt(x, y + 1)) ||
               (grid.isWalkableAt(x + dx, y - 1) && !grid.isWalkableAt(x, y - 1))) {
                return [x, y];
            }
        }
        else {
            if((grid.isWalkableAt(x + 1, y + dy) && !grid.isWalkableAt(x + 1, y)) ||
               (grid.isWalkableAt(x - 1, y + dy) && !grid.isWalkableAt(x - 1, y))) {
                return [x, y];
            }
        }
    }

    return this._jump(x + dx, y + dy, x, y);
};

/**
 * Find the neighbors for the given node. If the node has a parent,
 * prune the neighbors based on the jump point search algorithm, otherwise
 * return all available neighbors.
 * @return {Array<Array<number>>} The neighbors found.
 */
JPFAlwaysMoveDiagonally.prototype._findNeighbors = function(node) {
    var parent = node.parent,
        x = node.x, y = node.y,
        grid = this.grid,
        px, py, nx, ny, dx, dy,
        neighbors = [], neighborNodes, neighborNode, i, l;

    // directed pruning: can ignore most neighbors, unless forced.
    if (parent) {
        px = parent.x;
        py = parent.y;
        // get the normalized direction of travel
        dx = (x - px) / Math.max(Math.abs(x - px), 1);
        dy = (y - py) / Math.max(Math.abs(y - py), 1);

        // search diagonally
        if (dx !== 0 && dy !== 0) {
            if (grid.isWalkableAt(x, y + dy)) {
                neighbors.push([x, y + dy]);
            }
            if (grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y]);
            }
            if (grid.isWalkableAt(x + dx, y + dy)) {
                neighbors.push([x + dx, y + dy]);
            }
            if (!grid.isWalkableAt(x - dx, y)) {
                neighbors.push([x - dx, y + dy]);
            }
            if (!grid.isWalkableAt(x, y - dy)) {
                neighbors.push([x + dx, y - dy]);
            }
        }
        // search horizontally/vertically
        else {
            if(dx === 0) {
                if (grid.isWalkableAt(x, y + dy)) {
                    neighbors.push([x, y + dy]);
                }
                if (!grid.isWalkableAt(x + 1, y)) {
                    neighbors.push([x + 1, y + dy]);
                }
                if (!grid.isWalkableAt(x - 1, y)) {
                    neighbors.push([x - 1, y + dy]);
                }
            }
            else {
                if (grid.isWalkableAt(x + dx, y)) {
                    neighbors.push([x + dx, y]);
                }
                if (!grid.isWalkableAt(x, y + 1)) {
                    neighbors.push([x + dx, y + 1]);
                }
                if (!grid.isWalkableAt(x, y - 1)) {
                    neighbors.push([x + dx, y - 1]);
                }
            }
        }
    }
    // return all neighbors
    else {
        neighborNodes = grid.getNeighbors(node, DiagonalMovement.Always);
        for (i = 0, l = neighborNodes.length; i < l; ++i) {
            neighborNode = neighborNodes[i];
            neighbors.push([neighborNode.x, neighborNode.y]);
        }
    }

    return neighbors;
};

module.exports = JPFAlwaysMoveDiagonally;

},{"../core/DiagonalMovement":11,"./JumpPointFinderBase":30}],26:[function(require,module,exports){
/**
 * @author imor / https://github.com/imor
 */
var JumpPointFinderBase = require('./JumpPointFinderBase');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Path finder using the Jump Point Search algorithm which moves
 * diagonally only when there is at most one obstacle.
 */
function JPFMoveDiagonallyIfAtMostOneObstacle(opt) {
    JumpPointFinderBase.call(this, opt);
}

JPFMoveDiagonallyIfAtMostOneObstacle.prototype = new JumpPointFinderBase();
JPFMoveDiagonallyIfAtMostOneObstacle.prototype.constructor = JPFMoveDiagonallyIfAtMostOneObstacle;

/**
 * Search recursively in the direction (parent -> child), stopping only when a
 * jump point is found.
 * @protected
 * @return {Array<Array<number>>} The x, y coordinate of the jump point
 *     found, or null if not found
 */
JPFMoveDiagonallyIfAtMostOneObstacle.prototype._jump = function(x, y, px, py) {
    var grid = this.grid,
        dx = x - px, dy = y - py;

    if (!grid.isWalkableAt(x, y)) {
        return null;
    }

    if(this.trackJumpRecursion === true) {
        grid.getNodeAt(x, y).tested = true;
    }

    if (grid.getNodeAt(x, y) === this.endNode) {
        return [x, y];
    }

    // check for forced neighbors
    // along the diagonal
    if (dx !== 0 && dy !== 0) {
        if ((grid.isWalkableAt(x - dx, y + dy) && !grid.isWalkableAt(x - dx, y)) ||
            (grid.isWalkableAt(x + dx, y - dy) && !grid.isWalkableAt(x, y - dy))) {
            return [x, y];
        }
        // when moving diagonally, must check for vertical/horizontal jump points
        if (this._jump(x + dx, y, x, y) || this._jump(x, y + dy, x, y)) {
            return [x, y];
        }
    }
    // horizontally/vertically
    else {
        if( dx !== 0 ) { // moving along x
            if((grid.isWalkableAt(x + dx, y + 1) && !grid.isWalkableAt(x, y + 1)) ||
               (grid.isWalkableAt(x + dx, y - 1) && !grid.isWalkableAt(x, y - 1))) {
                return [x, y];
            }
        }
        else {
            if((grid.isWalkableAt(x + 1, y + dy) && !grid.isWalkableAt(x + 1, y)) ||
               (grid.isWalkableAt(x - 1, y + dy) && !grid.isWalkableAt(x - 1, y))) {
                return [x, y];
            }
        }
    }

    // moving diagonally, must make sure one of the vertical/horizontal
    // neighbors is open to allow the path
    if (grid.isWalkableAt(x + dx, y) || grid.isWalkableAt(x, y + dy)) {
        return this._jump(x + dx, y + dy, x, y);
    } else {
        return null;
    }
};

/**
 * Find the neighbors for the given node. If the node has a parent,
 * prune the neighbors based on the jump point search algorithm, otherwise
 * return all available neighbors.
 * @return {Array<Array<number>>} The neighbors found.
 */
JPFMoveDiagonallyIfAtMostOneObstacle.prototype._findNeighbors = function(node) {
    var parent = node.parent,
        x = node.x, y = node.y,
        grid = this.grid,
        px, py, nx, ny, dx, dy,
        neighbors = [], neighborNodes, neighborNode, i, l;

    // directed pruning: can ignore most neighbors, unless forced.
    if (parent) {
        px = parent.x;
        py = parent.y;
        // get the normalized direction of travel
        dx = (x - px) / Math.max(Math.abs(x - px), 1);
        dy = (y - py) / Math.max(Math.abs(y - py), 1);

        // search diagonally
        if (dx !== 0 && dy !== 0) {
            if (grid.isWalkableAt(x, y + dy)) {
                neighbors.push([x, y + dy]);
            }
            if (grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y]);
            }
            if (grid.isWalkableAt(x, y + dy) || grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y + dy]);
            }
            if (!grid.isWalkableAt(x - dx, y) && grid.isWalkableAt(x, y + dy)) {
                neighbors.push([x - dx, y + dy]);
            }
            if (!grid.isWalkableAt(x, y - dy) && grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y - dy]);
            }
        }
        // search horizontally/vertically
        else {
            if(dx === 0) {
                if (grid.isWalkableAt(x, y + dy)) {
                    neighbors.push([x, y + dy]);
                    if (!grid.isWalkableAt(x + 1, y)) {
                        neighbors.push([x + 1, y + dy]);
                    }
                    if (!grid.isWalkableAt(x - 1, y)) {
                        neighbors.push([x - 1, y + dy]);
                    }
                }
            }
            else {
                if (grid.isWalkableAt(x + dx, y)) {
                    neighbors.push([x + dx, y]);
                    if (!grid.isWalkableAt(x, y + 1)) {
                        neighbors.push([x + dx, y + 1]);
                    }
                    if (!grid.isWalkableAt(x, y - 1)) {
                        neighbors.push([x + dx, y - 1]);
                    }
                }
            }
        }
    }
    // return all neighbors
    else {
        neighborNodes = grid.getNeighbors(node, DiagonalMovement.IfAtMostOneObstacle);
        for (i = 0, l = neighborNodes.length; i < l; ++i) {
            neighborNode = neighborNodes[i];
            neighbors.push([neighborNode.x, neighborNode.y]);
        }
    }

    return neighbors;
};

module.exports = JPFMoveDiagonallyIfAtMostOneObstacle;

},{"../core/DiagonalMovement":11,"./JumpPointFinderBase":30}],27:[function(require,module,exports){
/**
 * @author imor / https://github.com/imor
 */
var JumpPointFinderBase = require('./JumpPointFinderBase');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Path finder using the Jump Point Search algorithm which moves
 * diagonally only when there are no obstacles.
 */
function JPFMoveDiagonallyIfNoObstacles(opt) {
    JumpPointFinderBase.call(this, opt);
}

JPFMoveDiagonallyIfNoObstacles.prototype = new JumpPointFinderBase();
JPFMoveDiagonallyIfNoObstacles.prototype.constructor = JPFMoveDiagonallyIfNoObstacles;

/**
 * Search recursively in the direction (parent -> child), stopping only when a
 * jump point is found.
 * @protected
 * @return {Array<Array<number>>} The x, y coordinate of the jump point
 *     found, or null if not found
 */
JPFMoveDiagonallyIfNoObstacles.prototype._jump = function(x, y, px, py) {
    var grid = this.grid,
        dx = x - px, dy = y - py;

    if (!grid.isWalkableAt(x, y)) {
        return null;
    }

    if(this.trackJumpRecursion === true) {
        grid.getNodeAt(x, y).tested = true;
    }

    if (grid.getNodeAt(x, y) === this.endNode) {
        return [x, y];
    }

    // check for forced neighbors
    // along the diagonal
    if (dx !== 0 && dy !== 0) {
        // if ((grid.isWalkableAt(x - dx, y + dy) && !grid.isWalkableAt(x - dx, y)) ||
            // (grid.isWalkableAt(x + dx, y - dy) && !grid.isWalkableAt(x, y - dy))) {
            // return [x, y];
        // }
        // when moving diagonally, must check for vertical/horizontal jump points
        if (this._jump(x + dx, y, x, y) || this._jump(x, y + dy, x, y)) {
            return [x, y];
        }
    }
    // horizontally/vertically
    else {
        if (dx !== 0) {
            if ((grid.isWalkableAt(x, y - 1) && !grid.isWalkableAt(x - dx, y - 1)) ||
                (grid.isWalkableAt(x, y + 1) && !grid.isWalkableAt(x - dx, y + 1))) {
                return [x, y];
            }
        }
        else if (dy !== 0) {
            if ((grid.isWalkableAt(x - 1, y) && !grid.isWalkableAt(x - 1, y - dy)) ||
                (grid.isWalkableAt(x + 1, y) && !grid.isWalkableAt(x + 1, y - dy))) {
                return [x, y];
            }
            // When moving vertically, must check for horizontal jump points
            // if (this._jump(x + 1, y, x, y) || this._jump(x - 1, y, x, y)) {
                // return [x, y];
            // }
        }
    }

    // moving diagonally, must make sure one of the vertical/horizontal
    // neighbors is open to allow the path
    if (grid.isWalkableAt(x + dx, y) && grid.isWalkableAt(x, y + dy)) {
        return this._jump(x + dx, y + dy, x, y);
    } else {
        return null;
    }
};

/**
 * Find the neighbors for the given node. If the node has a parent,
 * prune the neighbors based on the jump point search algorithm, otherwise
 * return all available neighbors.
 * @return {Array<Array<number>>} The neighbors found.
 */
JPFMoveDiagonallyIfNoObstacles.prototype._findNeighbors = function(node) {
    var parent = node.parent,
        x = node.x, y = node.y,
        grid = this.grid,
        px, py, nx, ny, dx, dy,
        neighbors = [], neighborNodes, neighborNode, i, l;

    // directed pruning: can ignore most neighbors, unless forced.
    if (parent) {
        px = parent.x;
        py = parent.y;
        // get the normalized direction of travel
        dx = (x - px) / Math.max(Math.abs(x - px), 1);
        dy = (y - py) / Math.max(Math.abs(y - py), 1);

        // search diagonally
        if (dx !== 0 && dy !== 0) {
            if (grid.isWalkableAt(x, y + dy)) {
                neighbors.push([x, y + dy]);
            }
            if (grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y]);
            }
            if (grid.isWalkableAt(x, y + dy) && grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y + dy]);
            }
        }
        // search horizontally/vertically
        else {
            var isNextWalkable;
            if (dx !== 0) {
                isNextWalkable = grid.isWalkableAt(x + dx, y);
                var isTopWalkable = grid.isWalkableAt(x, y + 1);
                var isBottomWalkable = grid.isWalkableAt(x, y - 1);

                if (isNextWalkable) {
                    neighbors.push([x + dx, y]);
                    if (isTopWalkable) {
                        neighbors.push([x + dx, y + 1]);
                    }
                    if (isBottomWalkable) {
                        neighbors.push([x + dx, y - 1]);
                    }
                }
                if (isTopWalkable) {
                    neighbors.push([x, y + 1]);
                }
                if (isBottomWalkable) {
                    neighbors.push([x, y - 1]);
                }
            }
            else if (dy !== 0) {
                isNextWalkable = grid.isWalkableAt(x, y + dy);
                var isRightWalkable = grid.isWalkableAt(x + 1, y);
                var isLeftWalkable = grid.isWalkableAt(x - 1, y);

                if (isNextWalkable) {
                    neighbors.push([x, y + dy]);
                    if (isRightWalkable) {
                        neighbors.push([x + 1, y + dy]);
                    }
                    if (isLeftWalkable) {
                        neighbors.push([x - 1, y + dy]);
                    }
                }
                if (isRightWalkable) {
                    neighbors.push([x + 1, y]);
                }
                if (isLeftWalkable) {
                    neighbors.push([x - 1, y]);
                }
            }
        }
    }
    // return all neighbors
    else {
        neighborNodes = grid.getNeighbors(node, DiagonalMovement.OnlyWhenNoObstacles);
        for (i = 0, l = neighborNodes.length; i < l; ++i) {
            neighborNode = neighborNodes[i];
            neighbors.push([neighborNode.x, neighborNode.y]);
        }
    }

    return neighbors;
};

module.exports = JPFMoveDiagonallyIfNoObstacles;

},{"../core/DiagonalMovement":11,"./JumpPointFinderBase":30}],28:[function(require,module,exports){
/**
 * @author imor / https://github.com/imor
 */
var JumpPointFinderBase = require('./JumpPointFinderBase');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Path finder using the Jump Point Search algorithm allowing only horizontal
 * or vertical movements.
 */
function JPFNeverMoveDiagonally(opt) {
    JumpPointFinderBase.call(this, opt);
}

JPFNeverMoveDiagonally.prototype = new JumpPointFinderBase();
JPFNeverMoveDiagonally.prototype.constructor = JPFNeverMoveDiagonally;

/**
 * Search recursively in the direction (parent -> child), stopping only when a
 * jump point is found.
 * @protected
 * @return {Array<Array<number>>} The x, y coordinate of the jump point
 *     found, or null if not found
 */
JPFNeverMoveDiagonally.prototype._jump = function(x, y, px, py) {
    var grid = this.grid,
        dx = x - px, dy = y - py;

    if (!grid.isWalkableAt(x, y)) {
        return null;
    }

    if(this.trackJumpRecursion === true) {
        grid.getNodeAt(x, y).tested = true;
    }

    if (grid.getNodeAt(x, y) === this.endNode) {
        return [x, y];
    }

    if (dx !== 0) {
        if ((grid.isWalkableAt(x, y - 1) && !grid.isWalkableAt(x - dx, y - 1)) ||
            (grid.isWalkableAt(x, y + 1) && !grid.isWalkableAt(x - dx, y + 1))) {
            return [x, y];
        }
    }
    else if (dy !== 0) {
        if ((grid.isWalkableAt(x - 1, y) && !grid.isWalkableAt(x - 1, y - dy)) ||
            (grid.isWalkableAt(x + 1, y) && !grid.isWalkableAt(x + 1, y - dy))) {
            return [x, y];
        }
        //When moving vertically, must check for horizontal jump points
        if (this._jump(x + 1, y, x, y) || this._jump(x - 1, y, x, y)) {
            return [x, y];
        }
    }
    else {
        throw new Error("Only horizontal and vertical movements are allowed");
    }

    return this._jump(x + dx, y + dy, x, y);
};

/**
 * Find the neighbors for the given node. If the node has a parent,
 * prune the neighbors based on the jump point search algorithm, otherwise
 * return all available neighbors.
 * @return {Array<Array<number>>} The neighbors found.
 */
JPFNeverMoveDiagonally.prototype._findNeighbors = function(node) {
    var parent = node.parent,
        x = node.x, y = node.y,
        grid = this.grid,
        px, py, nx, ny, dx, dy,
        neighbors = [], neighborNodes, neighborNode, i, l;

    // directed pruning: can ignore most neighbors, unless forced.
    if (parent) {
        px = parent.x;
        py = parent.y;
        // get the normalized direction of travel
        dx = (x - px) / Math.max(Math.abs(x - px), 1);
        dy = (y - py) / Math.max(Math.abs(y - py), 1);

        if (dx !== 0) {
            if (grid.isWalkableAt(x, y - 1)) {
                neighbors.push([x, y - 1]);
            }
            if (grid.isWalkableAt(x, y + 1)) {
                neighbors.push([x, y + 1]);
            }
            if (grid.isWalkableAt(x + dx, y)) {
                neighbors.push([x + dx, y]);
            }
        }
        else if (dy !== 0) {
            if (grid.isWalkableAt(x - 1, y)) {
                neighbors.push([x - 1, y]);
            }
            if (grid.isWalkableAt(x + 1, y)) {
                neighbors.push([x + 1, y]);
            }
            if (grid.isWalkableAt(x, y + dy)) {
                neighbors.push([x, y + dy]);
            }
        }
    }
    // return all neighbors
    else {
        neighborNodes = grid.getNeighbors(node, DiagonalMovement.Never);
        for (i = 0, l = neighborNodes.length; i < l; ++i) {
            neighborNode = neighborNodes[i];
            neighbors.push([neighborNode.x, neighborNode.y]);
        }
    }

    return neighbors;
};

module.exports = JPFNeverMoveDiagonally;

},{"../core/DiagonalMovement":11,"./JumpPointFinderBase":30}],29:[function(require,module,exports){
/**
 * @author aniero / https://github.com/aniero
 */
var DiagonalMovement = require('../core/DiagonalMovement');
var JPFNeverMoveDiagonally = require('./JPFNeverMoveDiagonally');
var JPFAlwaysMoveDiagonally = require('./JPFAlwaysMoveDiagonally');
var JPFMoveDiagonallyIfNoObstacles = require('./JPFMoveDiagonallyIfNoObstacles');
var JPFMoveDiagonallyIfAtMostOneObstacle = require('./JPFMoveDiagonallyIfAtMostOneObstacle');

/**
 * Path finder using the Jump Point Search algorithm
 * @param {Object} opt
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 * @param {DiagonalMovement} opt.diagonalMovement Condition under which diagonal
 *      movement will be allowed.
 */
function JumpPointFinder(opt) {
    opt = opt || {};
    if (opt.diagonalMovement === DiagonalMovement.Never) {
        return new JPFNeverMoveDiagonally(opt);
    } else if (opt.diagonalMovement === DiagonalMovement.Always) {
        return new JPFAlwaysMoveDiagonally(opt);
    } else if (opt.diagonalMovement === DiagonalMovement.OnlyWhenNoObstacles) {
        return new JPFMoveDiagonallyIfNoObstacles(opt);
    } else {
        return new JPFMoveDiagonallyIfAtMostOneObstacle(opt);
    }
}

module.exports = JumpPointFinder;

},{"../core/DiagonalMovement":11,"./JPFAlwaysMoveDiagonally":25,"./JPFMoveDiagonallyIfAtMostOneObstacle":26,"./JPFMoveDiagonallyIfNoObstacles":27,"./JPFNeverMoveDiagonally":28}],30:[function(require,module,exports){
/**
 * @author imor / https://github.com/imor
 */
var Heap       = require('heap');
var Util       = require('../core/Util');
var Heuristic  = require('../core/Heuristic');
var DiagonalMovement = require('../core/DiagonalMovement');

/**
 * Base class for the Jump Point Search algorithm
 * @param {object} opt
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 */
function JumpPointFinderBase(opt) {
    opt = opt || {};
    this.heuristic = opt.heuristic || Heuristic.manhattan;
    this.trackJumpRecursion = opt.trackJumpRecursion || false;
}

/**
 * Find and return the path.
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
JumpPointFinderBase.prototype.findPath = function(startX, startY, endX, endY, grid) {
    var openList = this.openList = new Heap(function(nodeA, nodeB) {
            return nodeA.f - nodeB.f;
        }),
        startNode = this.startNode = grid.getNodeAt(startX, startY),
        endNode = this.endNode = grid.getNodeAt(endX, endY), node;

    this.grid = grid;


    // set the `g` and `f` value of the start node to be 0
    startNode.g = 0;
    startNode.f = 0;

    // push the start node into the open list
    openList.push(startNode);
    startNode.opened = true;

    // while the open list is not empty
    while (!openList.empty()) {
        // pop the position of node which has the minimum `f` value.
        node = openList.pop();
        node.closed = true;

        if (node === endNode) {
            return Util.expandPath(Util.backtrace(endNode));
        }

        this._identifySuccessors(node);
    }

    // fail to find the path
    return [];
};

/**
 * Identify successors for the given node. Runs a jump point search in the
 * direction of each available neighbor, adding any points found to the open
 * list.
 * @protected
 */
JumpPointFinderBase.prototype._identifySuccessors = function(node) {
    var grid = this.grid,
        heuristic = this.heuristic,
        openList = this.openList,
        endX = this.endNode.x,
        endY = this.endNode.y,
        neighbors, neighbor,
        jumpPoint, i, l,
        x = node.x, y = node.y,
        jx, jy, dx, dy, d, ng, jumpNode,
        abs = Math.abs, max = Math.max;

    neighbors = this._findNeighbors(node);
    for(i = 0, l = neighbors.length; i < l; ++i) {
        neighbor = neighbors[i];
        jumpPoint = this._jump(neighbor[0], neighbor[1], x, y);
        if (jumpPoint) {

            jx = jumpPoint[0];
            jy = jumpPoint[1];
            jumpNode = grid.getNodeAt(jx, jy);

            if (jumpNode.closed) {
                continue;
            }

            // include distance, as parent may not be immediately adjacent:
            d = Heuristic.octile(abs(jx - x), abs(jy - y));
            ng = node.g + d; // next `g` value

            if (!jumpNode.opened || ng < jumpNode.g) {
                jumpNode.g = ng;
                jumpNode.h = jumpNode.h || heuristic(abs(jx - endX), abs(jy - endY));
                jumpNode.f = jumpNode.g + jumpNode.h;
                jumpNode.parent = node;

                if (!jumpNode.opened) {
                    openList.push(jumpNode);
                    jumpNode.opened = true;
                } else {
                    openList.updateItem(jumpNode);
                }
            }
        }
    }
};

module.exports = JumpPointFinderBase;

},{"../core/DiagonalMovement":11,"../core/Heuristic":13,"../core/Util":15,"heap":6}],31:[function(require,module,exports){
module.exports = function(type, subtype, x, y, z, width, height, team, startingNetData) {
    const server = this;
    let entity = {
        id: server.lastEntityId++,
        x: x,
        y: y,
        z: z,
        lastX: x,
        lastY: y,
        lastZ: z,
        width: width,
        height: height,
        team: team,
        rotation: 0,
        dx: 0,
        dy: 0,
        energy: 100,
        collisionLayer: 1,
        type: type,
        subtype: subtype,
        valid: true,
        maxHealth: 100,
        netData: {
            alive: true,
            health: 100
        }
    };

    if (startingNetData) {
        Object.assign(entity.netData, startingNetData);
    }

    entity.tick = () => {
        if (Math.abs(entity.dx) <= 0.001) {
            entity.dx = 0;
        }
        if (Math.abs(entity.dy) <= 0.001) {
            entity.dy = 0;
        }

        entity.x += entity.dx;
        entity.y += entity.dy;

        entity.sendMoveUpdate = (entity.x !== entity.lastX || entity.y !== entity.lastY || entity.rotation !== entity.lastRotation || entity.currentPlayer);

        if (entity.netData.name !== entity.lastName) {
            entity.lastName = entity.netData.name;
            entity.sendRPC('changeName', {
                name: entity.netData.name,
                isDev: entity.netData.isDev,
                settings: entity.netData.settings
            });
        }

        if (entity.kill && entity.netData.alive && !entity.isAI && (entity.x <= 0 || entity.y <= 0 || entity.x >= server.MAP_SIZE * server.TILE_SIZE || entity.y >= server.MAP_SIZE * server.TILE_SIZE)) {
            entity.kill();
        }

        entity.lastX = entity.x;
        entity.lastY = entity.y;
        entity.lastZ = entity.z;
        entity.lastRotation = entity.rotation;
    };

    entity.remove = () => {
        entity.valid = false;
    };

    entity.onRemove = () => {

    };

    entity.setHungry = (val) => {
        entity.netData.hungry = val;
        entity.sendRPC('setHungry', entity.netData.hungry);

        if (entity.subtype === 'ant_queen') {
            server.updateTeamInfo(entity.team);
        }
    };

    entity.lastRequestTime = server.getModifiedTime();
    entity.checkRequestTask = () => {
        if (entity.valid && entity.netData.alive && server.getModifiedTime() >= entity.lastRequestTime) {
            if (entity.netData.hungry) {
                let worker = server.getNearbyWorker(entity);
                if (worker) {
                    worker.target = entity;
                    worker.setAIState('feed');
                    entity.lastRequestTime = server.getModifiedTime() + 15000;
                } else {
                    entity.lastRequestTime = server.getModifiedTime() + (entity.subtype === 'ant_queen' ? 2000 : 10000);
                }
            } else {
                entity.lastRequestTime = server.getModifiedTime() + 1000;
            }
        }
    };

    entity.eat = (eaten, feeder) => {
        if (entity.subtype === 'ant_queen' && !entity.netData.hungry) {
            let foodType = null;
            if (eaten) {
                foodType = eaten.netData.foodType;
            }
            if (feeder) {
                foodType = feeder.lastEatenFoodType;
            }

            if (foodType) {
                entity.applyFoodToBroodQueue(foodType);
            }
            return;
        }

        entity.hasEaten = true;
        entity.netData.health = entity.maxHealth;
        if (eaten && !entity.netData.hungry && entity.hasSocialStomach && entity.socialFoodStorage <= 0) {
            entity.socialFoodStorage = 1;
            entity.lastEatenFoodType = eaten.netData.foodType;
        }
        entity.energy = 100;
        entity.setHungry(false);

        if (eaten && eaten.netData.foodType === 'blue') {
            entity.netData.isSuper = true;
            if (entity.hasSocialStomach) {
                entity.socialFoodStorage += 1;
            }
            entity.superTime = server.getModifiedTime();
        }
    };

    entity.getCreateData = () => {
        return {
            id: entity.id,
            x: entity.x,
            y: entity.y,
            z: entity.z,
            width: width,
            height: height,
            rotation: entity.rotation,
            type: entity.type,
            team: entity.team,
            subtype: entity.subtype,
            netData: entity.netData
        };
    };

    entity.sendRPC = (name, data) => {
        server.sendLocalMessage(entity, 'entityrpc', {
            id: entity.id,
            name: name,
            data: data
        });
    };

    if (entity.netData.delayServerAddEntity) {
        delete entity.netData.delayServerAddEntity;
    } else {
        server.addEntity(entity);
    }
    return entity;
};
},{}],32:[function(require,module,exports){
const PF = require('pathfinding');
const TileFinder = require('../tilefinder');

module.exports = function(subtype, x, y, z, width, height, team, netData) {
    const server = this;

    if (subtype === 'ant_queen' && team === -1) {
        let newTeam = server.createTeam();
        team = newTeam.id;
    }

    if (netData && netData.bugType === 'centipede' && !netData.zOffset) {
        netData.zOffset = 0;
    }

    let entity = server.createEntity('insect', subtype, x, y, z, width, height, team, netData);
    entity.isAI = true;
    entity.radius = 14;
    entity.carriedObject = null;
    entity.leader = null;
    entity.path = [];
    entity.aiState = 'idle';
    entity.lastAITeamThink = server.getModifiedTime();
    entity.stateChangeTime = server.getModifiedTime();
    entity.aiReturnPos = null;
    entity.griefCount = 0;
    entity.dataAI = {
        greetList: {},
        roleEncounters: {},
        role: 'nurse',
        lastRoleCheck: Date.now() - (30000 + Math.round(10000 * Math.random()))
    };

    let nearbyFriendly = 0;
    let nearbyEnemy = 0;

    if (subtype === 'ant_queen') {
        entity.collisionLayer = 3;
        server.teamData[team].queen = entity;
        if (server.teamData[team] && server.teamData[team].queens) {
            server.teamData[team].queens.push(entity);
        }
        entity.createTime = Date.now();
        entity.broodQueue = [];

        server.updateTeamInfo(entity.team);
    }

    entity.socialFoodStorage = 0;

    entity.stuckTicker = 0;
    entity.stuckCheckTicker = 0;
    entity.stuckCheckPos = {
        x: 0,
        y: 0
    };

    let attackTimeCoolDown = 1000;
    let lastAttackTime = 0;
    let currentDigData = null;
    let damage = 8;
    let speed = 6;
    let moveToDist = 28;
    let canMoveAfterAttack = false;
    let removeBodyTime = 10000;
    let attackDistance = 5;
    entity.weapon = 'jaws';
    if (subtype === 'ant_queen') {
        damage = 15;
        entity.radius = 20;
        entity.maxHealth = 125;
        entity.antType = 'queen';
    } else if (subtype === 'ant_worker' && !entity.netData.soldier) {
        entity.hasSocialStomach = true;
        entity.antType = 'worker';
        if (entity.netData.isNanitic) {
            entity.maxHealth = 40;
            speed = 6.5;
            damage = 5;
            entity.antType = 'nanitic';
        } else if (width === 85) {
            entity.maxHealth = 50;
            entity.radius = 16;
            entity.antType = 'acid';
            entity.weapon = 'acid';
            speed = 4.5;
            attackDistance = 400;
            attackTimeCoolDown = 1500 + Math.round(Math.random() * 250);
            damage = 23;
        }
    } else if (subtype === 'ant_worker' && entity.netData.soldier) {
        entity.hasSocialStomach = true;
        let mod = 1;
        let invmod = 1;
        if (width === 110) {
            mod = 1.15;
            invmod = 0.85;
            entity.radius = 22;
            entity.antType = 'major';
        } else {
            entity.radius = 14;
            entity.antType = 'soldier';
        }
        damage = 22 * mod;
        speed = 5 * invmod;
        moveToDist = 28;
        entity.maxHealth = 130 * mod;
    } else if (subtype === 'spider') {
        speed = 5.25;
        entity.radius = 35;
        moveToDist = 50;
        attackTimeCoolDown = 1200;
        damage = 60;
        removeBodyTime = 160000;
    } else if (subtype === 'bug') {
        if (netData && netData.bugType === 'centipede') {
            canMoveAfterAttack = true;
            let mod = width/120;
            let invmod = 1 + (1-mod);
            speed = 6 * invmod;
            entity.radius = (width/6) * mod;
            moveToDist = entity.radius-2;
            attackTimeCoolDown = 800 * invmod;
            damage = 40 * mod;
            if (netData.centipedeType === 'head') {
                entity.maxHealth = 90 * mod;
                moveToDist = 50;
                let lastBody = entity;
                let segments = 15 + Math.round(Math.random() * 15);
                if (entity.z >= 1) {
                    segments -= 8;
                }
                for (let i=0; i<segments; i++) {
                    let body = server.createInsect('bug', x, y + ((i+1)*18), entity.z, width, height, -1, {
                        bugType: 'centipede',
                        centipedeType: i >= segments-1 ? 'tail' : 'body',
                        zOffset: (i+1) * 25
                    });
                    body.mainEntity = entity;
                    body.attach(lastBody, lastBody.netData.centipedeType === 'head' ? 10 : 14);
                    lastBody = body;
                }
            } else {
                entity.maxHealth = 60 * mod;
                speed = 2 * invmod;
            }
        } else {
            speed = 3.0;
            entity.radius = 30;
            moveToDist = 50;
            attackTimeCoolDown = 1800;
            damage = 10;
        }
        removeBodyTime = 160000;
    } else if (subtype === 'beetle') {
        speed = 2.8;
        entity.radius = 45;
        moveToDist = 50;
        attackTimeCoolDown = 1800;
        damage = 10;
        removeBodyTime = 160000;
    } else if (subtype === 'grub') {
        entity.rotation = Math.random()*Math.PI*2;
        entity.maxHealth = 60;
    }
    entity.netData.health = entity.maxHealth;

    entity.parent = null;
    let parentDist = 12;
    entity.attach = function(p, dist) {
        entity.parent = p;
        parentDist = dist;
    };

    let broodTick = 100;
    let moveTick = Math.round(Math.random() * 40);
    let oldTick = entity.tick;
    if (subtype === 'grub') {
        entity.tick = () => {
            entity.dx *= 0.5;
            entity.dy *= 0.5;

            oldTick();
        };
    } else {
        entity.tick = () => {
            if (entity.netData.alive) {
                if (entity.team !== -1 && !server.teamData[entity.team]) {
                    entity.kill();
                    return;
                }
                if (entity.netData.isSuper && entity.superTime) {
                    if (server.getModifiedTime() - entity.superTime > 90000) {
                        entity.netData.isSuper = false;
                    }
                }

                if (entity.subtype === 'ant_worker' || entity.subtype === 'ant_queen') {
                    if (entity.energy <= 0) {
                        entity.kill();
                    } else {
                        if (entity.energy > 100) {
                            entity.energy = 100;
                        }
                        entity.energy -= 0.018;

                        if (Math.abs(entity.dx) >= 1 || Math.abs(entity.dy) >= 1) {
                            entity.energy -= 0.001;
                        }

                        if (entity.netData.soldier || entity.antType === 'acid') {
                            entity.energy -= 0.002;
                        }

                        if (entity.energy <= 40 && !entity.netData.hungry) {
                            if (entity.socialFoodStorage > 0) {
                                entity.socialFoodStorage--;
                                entity.eat();
                            } else {
                                entity.setHungry(true);
                            }
                        }
                    }
                }

                if (!entity.isAI && entity.target) {
                    if (entity.target.valid && entity.target.netData && entity.target.netData.alive && entity.z === entity.target.z) {
                        entity.moveToPos = {
                            x: entity.target.x,
                            y: entity.target.y
                        };
                        let dist = Math.distanceBetween(entity, entity.target);
                        if (dist < entity.radius + entity.target.radius + attackDistance + 5) {
                            entity.performAttack(entity.target);
                        }
                    } else {
                        entity.target = null;
                    }
                }

                if (entity.subtype === 'ant_queen' && !entity.netData.hungry && !entity.netData.newQueen && entity.z >= 1) {
                    if (broodTick <= 0) {
                        if (server.teamData[entity.team].aliveAntCount < 0) {
                            server.teamData[entity.team].aliveAntCount = 1;
                        }
                        broodTick = 150;
                        let aliveAnts = server.teamData[entity.team].aliveAntCount;
                        if (aliveAnts < 100) {
                            if (entity.broodQueue.length >= 1) {
                                let bq = entity.broodQueue[0];

                                if (bq) {
                                    entity.setCurrentBroodCost(bq.cost);
                                    let foodType = entity.getNeededFoodType();
                                    if (foodType) {
                                        let worker = server.getNearbyWorker(entity, (worker) => {
                                            return worker.socialFoodStorage > 0 && worker.lastEatenFoodType === foodType;
                                        }, true);

                                        if (!worker) {
                                            worker = server.getNearbyWorker(entity, null, true);
                                        }

                                        if (worker) {
                                            worker.target = entity;
                                            worker.returnToLastStateAfterStateChange();
                                            worker.setAIState('craft');
                                            entity.lastRequestTime = server.getModifiedTime() + 15000;
                                        }
                                    } else {
                                        entity.broodQueue.shift();
                                        let ox = entity.x + Math.random();
                                        let oy = entity.y + Math.random();
                                        let size = 45;
                                        switch(bq.type) {
                                            case 'nanitic':
                                                size -= 6;
                                                break;
                                            case 'soldier':
                                                size += 6;
                                                break;
                                            case 'major':
                                                size += 12;
                                                break;
                                            case 'acid':
                                                size += 8;
                                                break;
                                            case 'queen':
                                                size += 18;
                                                break;
                                        }
                                        ox += Math.cos(entity.rotation + Math.PI / 2) * 8;
                                        oy += Math.sin(entity.rotation + Math.PI / 2) * 8;
                                        let brood = server.createObject('brood', ox, oy, entity.z, size, size, entity.team);
                                        brood.broodType = bq.type;
                                        brood.queen = entity;
                                        server.openQueenMenu(entity, true);
                                        broodTick = 25;
                                    }
                                }
                            }

                            if (server.teamData[entity.team].isAI && server.config.isSingleplayer) {
                                if (entity.broodQueue.length <= 0) {
                                    let candidates = server.quadtrees[entity.z].retrieve({x: entity.x, y: entity.y, width: 3000, height: 3000});
                                    let nearbyBlue = false;
                                    for (let i = 0; i < candidates.length; i++) {
                                        let entity2 = candidates[i];
                                        if (entity.z === entity2.z && entity.team === entity2.team && entity2.valid && entity2.subtype === 'food' && entity2.netData.foodType === 'blue') {
                                            nearbyBlue = true;
                                            break;
                                        }
                                    }

                                    if (nearbyBlue) {
                                        let broodType = JSON.parse(JSON.stringify(server.broodTypes['soldier']));
                                        entity.broodQueue.push(broodType);
                                    } else {
                                        let broodType = JSON.parse(JSON.stringify(server.broodTypes['worker']));
                                        broodType.cost = {};
                                        entity.broodQueue.push(broodType);
                                    }
                                    broodTick = 400 + (aliveAnts * aliveAnts);
                                }
                            }
                        }

                        /*
                        let aliveAnts = server.teamData[entity.team].aliveAntCount;
                        if (entity.netData.isSuper) {
                            broodTick = 325 + (aliveAnts * aliveAnts);
                        } else {
                            broodTick = 425 + (aliveAnts * aliveAnts);
                        }

                        if (aliveAnts < 100 && server.currentSeason.type !== 'winter') {
                            let ox = entity.x + Math.random();
                            let oy = entity.y + Math.random();
                            ox += Math.cos(entity.rotation + Math.PI / 2) * 6;
                            oy += Math.sin(entity.rotation + Math.PI / 2) * 6;
                            let broodType = 'normal';
                            let size = 45;
                            if (entity.valid && entity.birthCount >= 25 && server.teamData[entity.team].queens.length < 3) {
                                entity.birthCount = 0;
                                size = 75;
                                broodType = 'queen';
                            }
                            let brood = server.createObject('brood', ox, oy, entity.z, size, size, entity.team);
                            brood.broodType = broodType;
                            brood.queen = entity;
                        }
                        */
                    } else {
                        broodTick--;
                    }
                }

                if (entity.moveToPos && (entity.netData && !entity.netData.digging) && (canMoveAfterAttack || server.getModifiedTime() - lastAttackTime > attackTimeCoolDown)) {
                    let dist = Math.distanceBetween(entity, entity.moveToPos);
                    let angle = Math.angleBetween(entity, entity.moveToPos);
                    if (entity.moveToPos.angle !== undefined) {
                        dist = 256;
                        angle = entity.moveToPos.angle;
                    }
                    entity.rotation = angle + Math.PI / 2;

                    let curSpeed = speed * 2.5;
                    if (entity.leader && entity.isAI && entity.aiState === 'follow') {
                        curSpeed *= 1.2;
                    }
                    if (entity.netData.flying) {
                        curSpeed *= 3;
                    }
                    if (entity.carriedObject) {
                        curSpeed *= 0.82;
                    }
                    if (entity.netData.isSuper) {
                        curSpeed *= 1.25;
                    }
                    if (entity.subtype === 'ant_queen') {
                        if (entity.netData.newQueen) {
                            curSpeed *= 1.15;
                        } else {
                            if (entity.z <= 0) {
                                curSpeed *= 0.5;
                            }
                        }
                    }
                    if (entity.lastDamageTime && server.getModifiedTime() - entity.lastDamageTime <= 2500) {
                        let speedDamage = entity.netData.health / (entity.maxHealth + 20);
                        if (speedDamage > 0.8) {
                            speedDamage = 0.8;
                        }
                        if (speedDamage < 0) {
                            speedDamage = 0;
                        }
                        curSpeed *= speedDamage;
                    }
                    if (entity.z <= 0) {
                        if (server.currentWeather && server.currentWeather.type === 'rain') {
                            curSpeed *= 0.85;
                        }
                        if (server.currentWeather && server.currentWeather.type === 'snow') {
                            curSpeed *= 0.8;
                        }

                        if (server.currentSeason.type === 'summer') {
                            curSpeed *= 1.15;
                        } else if (server.currentSeason.type === 'fall') {
                            if (server.isNight()) {
                                curSpeed *= 0.85;
                            }
                        } else if (server.currentSeason.type === 'winter') {
                            curSpeed *= 0.85;

                            if (server.isNight()) {
                                curSpeed *= 0.85;
                            }

                            if (server.currentWeather && server.currentWeather.type === 'rain') {
                                curSpeed *= 0.85;
                            }
                        }
                    }
                    entity.dx += Math.cos(angle) * curSpeed;
                    entity.dy += Math.sin(angle) * curSpeed;

                    let curMoveToDist = moveToDist;
                    if (entity.moveToPos.action && entity.carriedObject && entity.carriedObject.subtype === 'dirt') {
                        curMoveToDist += 30;
                    }
                    if (dist < curMoveToDist) {
                        if (entity.moveToPos.action) {
                            entity.performAction();
                        }
                        entity.moveToPos = null;
                    }

                    if (entity.moveToPos) {
                        if (entity.moveToPos.stuckTick === undefined) {
                            entity.moveToPos.stuckTick = 100;
                        } else {
                            entity.moveToPos.stuckTick--;
                            if (entity.moveToPos.stuckTick <= 0) {
                                entity.moveToPos = null;
                            }
                        }
                    }
                }

                if (entity.netData.digging) {
                    if (currentDigData) {
                        if (currentDigData.amount < 15) {
                            currentDigData.amount++;
                        } else {
                            entity.changeGrabbedObject({subtype: 'dirt'});
                            server.updateTile(currentDigData.tx, currentDigData.ty, 0);
                            entity.stopDig();
                        }
                    } else {
                        entity.stopDig();
                    }
                }

                if (entity.z >= 1) {
                    let tx = parseInt(entity.x / server.TILE_SIZE);
                    let ty = parseInt(entity.y / server.TILE_SIZE);
                    server.decreaseTileDamage(tx, ty);
                }

                if (entity.isAI) {
                    if (entity.subtype === 'ant_worker' && entity.queen) {
                        if (!entity.queen.valid || !entity.queen.netData || !entity.queen.netData.alive) {
                            if (server.teamData[entity.team] && server.teamData[entity.team].queens && server.teamData[entity.team].queens.length) {
                                entity.queen = server.getClosestQueen(entity, entity.team);
                            } else {
                                entity.queen = null;
                                entity.kill();
                                return;
                            }
                        }
                    }

                    entity.tickAI();
                    if (entity.target) {
                        entity.tickTargetAI();
                    }

                    if (server.config.enableAiDebugging) {
                        let newTargetId = entity.target ? entity.target.id : -1;
                        if (!entity.lastTargetId || entity.lastTargetId !== newTargetId) {
                            entity.sendRPC('setAIState', {
                                state: entity.aiState,
                                targetId: newTargetId
                            });
                            entity.lastTargetId = newTargetId;
                        }
                    }

                    if (entity.leader && (!entity.leader.valid || !entity.leader.netData || !entity.leader.netData.alive || entity.leader.isAI)) {
                        entity.leader = null;
                    }

                    if (entity.subtype === 'ant_queen' || entity.subtype === 'ant_worker') {
                        entity.checkRequestTask();
                    }

                    if (entity.stuckCheckTicker <= 0) {
                        if (entity.subtype === 'ant_queen') {
                            entity.stuckCheckTicker = 250 + Math.round(Math.random() * 400);
                        } else {
                            entity.stuckCheckTicker = 50;
                        }

                        if (entity.aiState !== 'follow') {
                            let checkDist = Math.distanceBetween(entity, entity.stuckCheckPos);
                            if (checkDist < 5) {
                                entity.stuckTicker++;
                            } else {
                                entity.stuckTicker = 0;
                            }

                            entity.stuckCheckPos.x = entity.x;
                            entity.stuckCheckPos.y = entity.y;

                            if (entity.stuckTicker > 2) {
                                entity.stuckTicker = 0;
                                entity.moveToPos = null;
                                entity.path = [];
                                entity.setAIState('idle');
                            }
                        }

                        if (entity.subtype === 'ant_queen' && (!entity.netData || !entity.netData.newQueen)) {
                            if (entity.anthill && !entity.anthill.valid) {
                                entity.anthill = null;
                            }

                            let newAnthill = server.getClosestAnthill(entity, null, true);
                            if (newAnthill) {
                                entity.anthill = newAnthill;
                            }
                        } else if (entity.subtype === 'ant_worker') {
                            if (!entity.queen && server.teamData[entity.team] && server.teamData[entity.team].queens && server.teamData[entity.team].queens.length) {
                                entity.queen = server.getClosestQueen(entity, entity.team);
                            }
                        }
                    } else {
                        entity.stuckCheckTicker--;
                    }
                }
            } else {
                if (entity.removeTime) {
                    if (entity.removeTime < server.getModifiedTime()) {
                        entity.remove();
                    }
                } else {
                    entity.removeTime = server.getModifiedTime() + removeBodyTime;
                }
            }

            nearbyEnemy = 0;
            nearbyFriendly = 1;

            entity.dx *= 0.5;
            entity.dy *= 0.5;

            oldTick();
        };
    }

    entity.lastRequestTime = server.getModifiedTime();
    entity.checkRequestTask = () => {
        if (entity.valid && entity.netData.alive && server.getModifiedTime() >= entity.lastRequestTime) {
            if (entity.netData.hungry) {
                let extraReq = null;
                if (entity.subtype === 'ant_worker') {
                    extraReq = (worker) => {
                        return worker.socialFoodStorage > 0;
                    };
                }
                let worker = server.getNearbyWorker(entity, extraReq, true);

                if (worker) {
                    worker.target = entity;
                    worker.returnToLastStateAfterStateChange();
                    worker.setAIState('feed');
                    entity.lastRequestTime = server.getModifiedTime() + 15000;
                } else {
                    if (entity.aiState !== 'follow' && entity.subtype !== 'ant_queen') {
                        entity.returnToLastStateAfterStateChange()
                        entity.target = entity;
                        entity.setAIState('feed');
                    }
                    entity.lastRequestTime = server.getModifiedTime() + (entity.subtype === 'ant_queen' ? 2000 : 10000);
                }
            } else {
                entity.lastRequestTime = server.getModifiedTime() + 1000;
            }
        }
    };

    entity.returnToLastStateAfterStateChange = () => {
        if (entity.aiState === 'follow') {
            entity.nextAIState = {
                state: 'follow',
                leader: entity.leader,
                onExecute: function (entity) {
                    if (this.leader && this.leader.followers.includes(entity)) {
                        entity.setFollow(this.leader);
                    }
                }
            };
        } else if (entity.aiState === 'defend') {
            entity.nextAIState = {
                state: 'defend'
            };
        }
    };

    entity.dig = (tx, ty) => {
        if (entity.z >= 1) {
            if (entity.subtype === 'bug') {
                server.updateTile(tx, ty, 0);
            } else {
                currentDigData = {
                    tx: tx,
                    ty: ty,
                    amount: 0
                };
                entity.netData.digging = true;
                entity.sendRPC('setDigging', entity.netData.digging);
            }
        }
    };

    entity.stopDig = () => {
        currentDigData = null;
        entity.netData.digging = false;
        entity.sendRPC('setDigging', entity.netData.digging);
    };

    if (entity.subtype === 'ant_queen') {
        entity.queueBrood = (data) => {
            if (!entity.netData.newQueen && entity.broodQueue.length < 10) {
                if (entity.broodQueue.length <= 0) {
                    broodTick = 10;
                }

                entity.broodQueue.push(data);

                if (entity.broodQueue.length >= 1) {
                    entity.setCurrentBroodCost(entity.broodQueue[0].cost);
                } else {
                    entity.setCurrentBroodCost(null);
                }
            }
        };

        entity.removeBroodQueueAtIndex = (index) => {
            if (entity.broodQueue[index]) {
                entity.broodQueue.splice(index, 1);
                if (entity.broodQueue.length >= 1) {
                    entity.setCurrentBroodCost(entity.broodQueue[0].cost);
                } else {
                    entity.setCurrentBroodCost(null);
                }
            }
        };

        entity.setCurrentBroodCost = (cost, forceUpdate) => {
            if (forceUpdate || entity.netData.broodCost !== cost) {
                entity.netData.broodCost = cost;
                entity.sendRPC('setBroodCost', entity.netData.broodCost);
            }
        };

        entity.getNeededFoodType = () => {
            let bq = entity.broodQueue[0];
            if (bq && bq.cost) {
                let costKeys = Object.keys(bq.cost);
                if (costKeys.length >= 1) {
                    return costKeys[0];
                }
            }
            return null;
        };

        entity.applyFoodToBroodQueue = (foodType) => {
            let bq = entity.broodQueue[0];
            if (bq && bq.cost[foodType] >= 1) {
                bq.cost[foodType]--;
                if (bq.cost[foodType] <= 0) {
                    delete bq.cost[foodType];
                }

                if (Object.keys(bq.cost).length <= 0) {
                    let aliveAnts = server.teamData[entity.team].aliveAntCount;
                    broodTick = 200 + Math.round((aliveAnts * aliveAnts) * 0.5);
                } else {
                    broodTick = 1;
                }

                entity.setCurrentBroodCost(bq.cost, true);
            }
        };
    }

    let moveAngleDist = Math.PI/2;
    let lastMoveAngle = Math.random() * Math.PI * 2;
    let changeParentZPos = null;
    entity.tickAI = () => {
        if (entity.subtype === 'ant_worker') {
            if (entity.isAggro && Math.abs(server.getModifiedTime() - entity.lastDamageTime) > 15000) {
                entity.isAggro = false;
            }
        } else {
            entity.isAggro = Math.abs(server.getModifiedTime() - entity.lastAggroTime) > 100000;
        }

        if (subtype === 'spider' || subtype === 'bug' || subtype === 'beetle') {
            if (subtype === 'bug' && entity.netData && entity.netData.alive && entity.netData.bugType === 'centipede') {
                if (entity.netData.centipedeType !== 'head' && !entity.parent) {
                    entity.netData.health -= 5;
                    if (entity.netData.health <= 0) {
                        entity.damage(1);
                    }
                }
            }

            if (!entity.moveToPos) {
                if (entity.parent && entity.parent.netData && entity.parent.netData.alive) {
                    entity.moveToPos = null;
                    let dist = Math.distanceBetween(entity, entity.parent);
                    let angle = Math.angleBetween(entity, entity.parent);
                    let diff = dist-parentDist;
                    if (Math.abs(diff) > 0.5) {
                        entity.rotation = angle + Math.PI / 2;
                        let curSpeed = diff*0.95;
                        entity.x += Math.cos(angle) * curSpeed;
                        entity.y += Math.sin(angle) * curSpeed;
                    }

                    if (entity.parent.z !== entity.z) {
                        if (changeParentZPos) {
                            let cdist = Math.distanceBetween(entity, changeParentZPos);
                            if (cdist > 12) {
                                entity.z = entity.parent.z;
                                changeParentZPos = null;
                            }
                        } else {
                            changeParentZPos = {
                                x: entity.parent.x,
                                y: entity.parent.y
                            };
                        }
                    }
                } else {
                    if (entity.parent) {
                        entity.parent = null;
                    }

                    if (moveTick <= 0) {
                        if (subtype === 'bug' && entity.netData && entity.netData.bugType === 'centipede') {
                            moveTick = 2;
                        } else {
                            moveTick = 10;
                        }

                        if (Math.random() >= 0.35) {
                            lastMoveAngle += ((Math.random() * moveAngleDist) - (moveAngleDist/2));
                            entity.moveToPos = {
                                x: entity.x + (Math.cos(lastMoveAngle) * (50 + (Math.random() * 600))),
                                y: entity.y + (Math.sin(lastMoveAngle) * (50 + (Math.random() * 600)))
                            };

                            if (entity.moveToPos.x <= 0 || entity.moveToPos.x >= (server.MAP_SIZE * server.TILE_SIZE) || entity.moveToPos.y <= 0 || entity.moveToPos.y >= (server.MAP_SIZE * server.TILE_SIZE)) {
                                let offset = 3000;
                                entity.moveToPos = {
                                    x: (((server.MAP_SIZE * server.TILE_SIZE) / 2) - offset / 2) + Math.random() * offset,
                                    y: (((server.MAP_SIZE * server.TILE_SIZE) / 2) - offset / 2) + Math.random() * offset
                                };
                            }
                        }
                    } else {
                        moveTick--;
                    }
                }
            }
        } else {
            if (!entity.moveToPos) {
                if (entity.path && entity.path.length > 0) {
                    let pathNode = entity.path[0];
                    entity.moveToPos = {
                        x: pathNode.x,
                        y: pathNode.y,
                        action: !!pathNode.action
                    };

                    if (Math.distanceBetween(entity, pathNode) < (pathNode.maxDist ? pathNode.maxDist : 180)) {
                        if (pathNode.z >= 0) {
                            entity.z = pathNode.z;
                        }
                        entity.path.shift();

                        if (entity.path.length <= 0) {
                            if (pathNode.dropObject && entity.carriedObject) {
                                entity.dropGrabbedObject();
                            }
                        }
                    }
                } else {
                    switch(entity.aiState) {
                        case 'feed':
                            if (entity.target && entity.target.valid && entity.target.netData.alive) {
                                if (entity.socialFoodStorage <= 0 && !entity.carriedObject && (entity.target.subtype !== 'ant_worker' || entity.target === entity)) {
                                    let candidates = server.quadtrees[entity.z].retrieve({x: entity.x, y: entity.y, width: 3000, height: 3000});
                                    let nearbyFood = null;
                                    let closestDist = 20000;
                                    for (let i = 0; i < candidates.length; i++) {
                                        let entity2 = candidates[i];
                                        let dist = Math.distanceBetween(entity, entity2);
                                        if (entity.z === entity2.z && entity.team === entity2.team && entity2.valid && entity2.subtype === 'food' && entity2.netData.foodType !== 'blue' && entity2.netData.foodType !== 'red' && dist < closestDist) {
                                            nearbyFood = entity2;
                                            closestDist = dist;
                                        }
                                    }

                                    if (nearbyFood) {
                                        entity.pathTo(nearbyFood, null, null, true);
                                    } else {
                                        entity.setAIState('idle');
                                    }
                                } else {
                                    if (entity.target.netData.hungry && entity.target.z === entity.z && Math.distanceBetween(entity, entity.target) < 2000) {
                                        entity.pathTo(entity.target, null, null, true);
                                        entity.setAIState('idle');
                                    } else {
                                        entity.setAIState('idle');
                                        entity.dropGrabbedObject();
                                    }
                                }
                            } else {
                                entity.setAIState('idle');
                                entity.dropGrabbedObject();
                            }
                            break;
                        case 'craft':
                            if (entity.target && entity.target.valid && entity.target.netData.alive && entity.target.subtype === 'ant_queen') {
                                let neededFoodType = entity.target.getNeededFoodType();
                                if ((entity.socialFoodStorage <= 0 || entity.lastEatenFoodType !== neededFoodType) && !entity.carriedObject) {
                                    let candidates = server.quadtrees[entity.z].retrieve({x: entity.x, y: entity.y, width: 3000, height: 3000});
                                    let nearbyFood = null;
                                    let closestDist = 20000;
                                    for (let i = 0; i < candidates.length; i++) {
                                        let entity2 = candidates[i];
                                        let dist = Math.distanceBetween(entity, entity2);
                                        if (entity.z === entity2.z && entity.team === entity2.team && entity2.valid && entity2.subtype === 'food' && entity2.netData.foodType === neededFoodType && dist < closestDist) {
                                            nearbyFood = entity2;
                                            closestDist = dist;
                                        }
                                    }

                                    if (nearbyFood) {
                                        entity.pathTo(nearbyFood, null, null, true);
                                    } else {
                                        entity.setAIState('idle');
                                    }
                                } else {
                                    if (entity.target.z === entity.z && Math.distanceBetween(entity, entity.target) < 2000) {
                                        entity.pathTo(entity.target, null, null, true);
                                        entity.setAIState('idle');
                                    } else {
                                        entity.setAIState('idle');
                                        entity.dropGrabbedObject();
                                    }
                                }
                            } else {
                                entity.setAIState('idle');
                                entity.dropGrabbedObject();
                            }
                            break;
                        case 'moveobject':
                            if (entity.target && (entity.target.subtype === 'food' || entity.target.subtype === 'brood')) {
                                if (entity.carriedObject) {
                                    if (entity.carriedObject === entity.target && entity.queen && entity.queen.valid) {
                                        let potentialTiles = entity.getPotentialTilesNearQueen(entity.target.subtype === 'brood' ? 1 : 0);
                                        if (potentialTiles.length) {
                                            let topbuff = potentialTiles.length;
                                            if (topbuff > 4) {
                                                topbuff = 4;
                                            }

                                            let validTile = potentialTiles[Math.floor(Math.random() * (topbuff-1))].node;
                                            entity.pathTo({
                                                x: validTile.x * server.TILE_SIZE + server.TILE_SIZE/2,
                                                y: validTile.y * server.TILE_SIZE + server.TILE_SIZE/2,
                                                z: 1,
                                                returningHome: true
                                            }, 35, true);
                                        } else {
                                            if (entity.queen && entity.queen.anthill) {
                                                let angle = Math.random() * 360;
                                                entity.pathTo({
                                                    x: entity.queen.anthill.x + (Math.cos(angle) * 100),
                                                    y: entity.queen.anthill.y + (Math.sin(angle) * 100),
                                                    z: 1,
                                                    returningHome: true
                                                }, 35, true);
                                            }
                                        }

                                        entity.setAIState('idle');
                                    } else {
                                        entity.dropGrabbedObject();
                                    }
                                } else {
                                    entity.pathTo(entity.target, null, null, true);
                                    if (!entity.path || !entity.path.length) {
                                        entity.setAIState('idle');
                                        entity.dropGrabbedObject();
                                    }
                                }
                            } else {
                                entity.setAIState('idle');
                                entity.dropGrabbedObject();
                            }
                            break;
                        case 'dig':
                            if (entity.carriedObject && entity.carriedObject.subtype === 'dirt') {
                                if (entity.z === 1) {
                                    let angle = Math.random() * 360;
                                    let anthill = entity.queen ? entity.queen.anthill : null;
                                    if (!anthill) {
                                        try {
                                            anthill = server.getClosestAnthill(entity, null, true);
                                        } catch (e) {}
                                    }

                                    if (anthill) {
                                        entity.pathTo({
                                            x: anthill.x + (Math.cos(angle) * 100),
                                            y: anthill.y + (Math.sin(angle) * 100),
                                            z: 0
                                        }, 35, false);
                                    } else {
                                        entity.setAIState('idle');
                                        entity.dropGrabbedObject();
                                    }
                                } else {
                                    entity.setAIState('idle');
                                    entity.dropGrabbedObject();
                                }
                            } else if (entity.digTarget) {
                                entity.dig(entity.digTarget.x, entity.digTarget.y);
                                entity.digTarget = null;
                                entity.target = null;
                            } else {
                                entity.setAIState('idle');
                                entity.dropGrabbedObject();
                            }
                            break;
                        case 'follow':
                            let follow = entity.leader;
                            if (follow && follow.isAI) {
                                entity.setFollow(null);
                                break;
                            }

                            if (entity.leader && entity.leader.followers && entity.leader.followers.length) {
                                let followIndex = follow.followers.indexOf(entity);
                                if (followIndex === -1) {
                                    entity.setFollow(null);
                                    break;
                                } else {
                                    entity.leaderIndex = (Math.floor(followIndex / 4) * 4) - 1;
                                    if (entity.leader.followers[entity.leaderIndex - 1]) {
                                        follow = entity.leader.followers[entity.leaderIndex - 1];
                                    }
                                }
                            } else {
                                entity.setFollow(null);
                                break;
                            }

                            if (follow && follow.valid && follow.netData.alive) {
                                if (Math.distanceBetween(entity, follow) > 100 || follow.z !== entity.z) {
                                    entity.pathTo(follow);
                                }
                            } else {
                                if (follow && follow.leader && follow.leader.valid) {
                                    entity.leader = follow.leader;
                                } else {
                                    entity.setAIState('idle');
                                }
                            }
                            break;
                        case 'defend':
                            if (moveTick <= 0) {
                                moveTick = 10;
                                if (entity.defendTarget) {
                                    let dist = Math.distanceBetween(entity, entity.defendTarget);
                                    let radius = entity.defendRadius ? entity.defendRadius : 200;
                                    if (dist > radius) {
                                        entity.pathTo(entity.defendTarget, 100);
                                    } else {
                                        if (Math.random() >= 0.75) {
                                            let moveDist = 100;

                                            entity.moveToPos = {
                                                x: entity.x + ((Math.random() * (moveDist * 2)) - moveDist),
                                                y: entity.y + ((Math.random() * (moveDist * 2)) - moveDist)
                                            };

                                            if (entity.z === 1) {
                                                let tx = parseInt((entity.moveToPos.x + (server.TILE_SIZE / 2)) / server.TILE_SIZE);
                                                let ty = parseInt((entity.moveToPos.y + (server.TILE_SIZE / 2)) / server.TILE_SIZE);
                                                let tile = server.getTile(tx, ty)[0];
                                                if (tile !== 0) {
                                                    entity.moveToPos = null;
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    entity.setAIState('idle');
                                }
                            } else {
                                moveTick--;
                            }
                            break;
                        case 'idle':
                        default:
                            if (moveTick <= 0) {
                                moveTick = 50;

                                if (entity.subtype === 'ant_worker' && entity.z === 0 && !entity.target && (server.getModifiedTime() - entity.stateChangeTime) > 10000 && Math.random() >= 0.25) {
                                    if (server.teamData[entity.team]) {
                                        if (server.teamData[entity.team].isFakeTeam && server.gamemode.type === 'coop' && server.teamData[0] && server.teamData[0].queen && server.teamData[0].queen.valid) {
                                            entity.pathTo({
                                                x: server.teamData[0].queen.x,
                                                y: server.teamData[0].queen.y,
                                                z: 1
                                            }, 35);

                                            if (!entity.path || !entity.path.length) {
                                                entity.x = server.teamData[0].queen.x + Math.random();
                                                entity.y = server.teamData[0].queen.y + Math.random();
                                                entity.z = server.teamData[0].queen.z;
                                            }
                                        } else {
                                            if (entity.queen && entity.queen.anthill) {
                                                entity.pathTo({
                                                    x: entity.queen.anthill.x,
                                                    y: entity.queen.anthill.y,
                                                    z: 1,
                                                    returningHome: true
                                                }, 35, true);
                                            } else if (entity.queen && entity.queen.valid) {
                                                entity.pathTo(entity.queen, 35, null, true);
                                            }
                                        }
                                    }
                                } else if (Math.random() >= 0.9) {
                                    let moveDist = 100;
                                    if (entity.subtype === 'ant_queen') {
                                        moveDist = 25;
                                    }

                                    entity.moveToPos = {
                                        x: entity.x + ((Math.random() * (moveDist * 2)) - moveDist),
                                        y: entity.y + ((Math.random() * (moveDist * 2)) - moveDist)
                                    };

                                    if (entity.z === 1) {
                                        let tx = parseInt((entity.moveToPos.x + (server.TILE_SIZE / 2)) / server.TILE_SIZE);
                                        let ty = parseInt((entity.moveToPos.y + (server.TILE_SIZE / 2)) / server.TILE_SIZE);
                                        let tile = server.getTile(tx, ty)[0];
                                        if (tile !== 0) {
                                            entity.moveToPos = null;
                                        }
                                    }
                                }

                                if (!entity.moveToPos) {
                                    if (entity.carriedObject && entity.carriedObject.subtype === 'dirt') {
                                        if (entity.subtype !== 'ant_queen') {
                                            entity.aiReturnPos = {
                                                x: entity.x,
                                                y: entity.y,
                                                z: entity.z
                                            };
                                            entity.setAIState('dig');
                                        }
                                    } else {
                                        entity.dropGrabbedObject();
                                    }
                                }
                            } else {
                                moveTick--;
                            }

                            if (!entity.moveToPos) {
                                if (server.teamData[entity.team] && !entity.carriedObject && entity.aiState === 'idle' && (!entity.path || !entity.path.length)) {
                                    server.tickTeamAIEntity(entity);
                                }
                            }
                            break;
                    }
                }
            }
        }
    };

    entity.searchForTile = (from, fn, ignoreNotWalkable) => {
        let finder = new TileFinder({
            allowDiagonal: true,
            dontCrossCorners: false
        });
        let grid = server.tileGrids[1].clone();
        if (ignoreNotWalkable) {
            grid = new PF.Grid(server.MAP_SIZE, server.MAP_SIZE);
        }
        let fromTile = server.getTile(parseInt(from.x / server.TILE_SIZE), parseInt(from.y / server.TILE_SIZE));
        if (fromTile) {
            try {
                let results = finder.findTile(parseInt(from.x / server.TILE_SIZE), parseInt(from.y / server.TILE_SIZE), fn, grid);
                if (results) {
                    return results;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    };

    let lastPathAttempt = 0;
    entity.tilesPathTo = (to, z, overrideAttempt, useFromZ, dontPushToPath) => {
        if (overrideAttempt || server.getModifiedTime() - lastPathAttempt > 2000) {
            let from = (entity.path && entity.path.length && entity.path[entity.path.length - 1]) ? entity.path[entity.path.length - 1] : entity;
            if (useFromZ) {
                z = from.z;
            }

            if (!server.tileGrids[z]) {
                return false;
            }

            let finder = new PF.AStarFinder({
                allowDiagonal: true,
                dontCrossCorners: true
            });
            let grid = server.tileGrids[z].clone();
            let fromTile = server.getTile(parseInt(from.x / server.TILE_SIZE), parseInt(from.y / server.TILE_SIZE));
            let toTile = server.getTile(parseInt(to.x / server.TILE_SIZE), parseInt(to.y / server.TILE_SIZE));
            if (fromTile && toTile) {
                try {
                    let path = finder.findPath(parseInt(from.x / server.TILE_SIZE), parseInt(from.y / server.TILE_SIZE), parseInt(to.x / server.TILE_SIZE), parseInt(to.y / server.TILE_SIZE), grid);
                    if (path && path.length) {
                        if (!dontPushToPath) {
                            for (let i = (path.length >= 1) ? 1 : 0; i < path.length - 1; i++) {
                                let node = path[i];
                                entity.path.push({
                                    x: (node[0] * server.TILE_SIZE) + server.TILE_SIZE / 2,
                                    y: (node[1] * server.TILE_SIZE) + server.TILE_SIZE / 2
                                });
                            }
                        }
                        return true;
                    } else {
                        lastPathAttempt = server.getModifiedTime();
                        return false;
                    }
                } catch (e) {
                    lastPathAttempt = server.getModifiedTime();
                    return false;
                }
            } else {
                lastPathAttempt = server.getModifiedTime();
                return false;
            }
        } else {
            return false;
        }
    };

    entity.pathTo = (to, maxDist, dropObject, action, forceTilePathTo, options) => {
        if (!options) {
            options = {};
        }
        //TODO: Actually make this work correctly.
        entity.path = [];

        if (entity.z !== to.z) {
            let closestAnthill;
            if (entity.z === 0) {
                closestAnthill = server.getClosestAnthill(to, null, true);
            } else {
                closestAnthill = server.getClosestAnthill(entity, null, true);
            }
            if (closestAnthill) {
                let hasPath = entity.tilesPathTo(closestAnthill, entity.z);
                if (hasPath) {
                    if (entity.z === 0) {
                        if (entity.path && entity.path.length >= 2) {
                            entity.path.shift();
                        }
                    }

                    entity.path.push({
                        x: closestAnthill.x,
                        y: closestAnthill.y,
                        z: to.z,
                        maxDist: 35
                    });
                } else {
                    entity.path = [];
                }
            } else {
                return;
            }
        } else if (entity.z === 0) {
            let pathTo = to.z === entity.z ? to : entity.path[entity.path.length-1];
            if (pathTo) {
                let pathdist = Math.distanceBetween(entity, pathTo);
                if (pathdist > 500 || forceTilePathTo) {
                    let hasPath = entity.tilesPathTo(pathTo, entity.z);
                    if (!hasPath) {
                        entity.path = [];
                        return;
                    }
                }
            } else {
                entity.path = [];
                return;
            }
        }

        if (to.z >= 1) {
            if (entity.z === 0) {
                let closestAnthill = server.getClosestAnthill(to, null, true);
                if (closestAnthill) {
                    entity.path = [];
                    let hasPath = entity.tilesPathTo(closestAnthill, entity.z, true, true);
                    if (!hasPath) {
                        entity.path = [];
                        return;
                    }

                    entity.path.push({
                        x: closestAnthill.x,
                        y: closestAnthill.y,
                        z: to.z,
                        maxDist: 35
                    });

                    entity.tilesPathTo(to, to.z, true);
                } else {
                    entity.path = [];
                    return;
                }
            } else {
                let hasPath = entity.tilesPathTo(to, to.z);
                if (!hasPath) {
                    if (!options.doNotLeaveNest) {
                        entity.path = [];

                        let closestAnthill1 = server.getClosestAnthill(entity, null, true);
                        let closestAnthill2 = null;
                        if (to.returningHome && entity.queen) {
                            closestAnthill2 = entity.queen.anthill;
                        }
                        if (!closestAnthill2) {
                            closestAnthill2 = server.getClosestAnthill(to);
                        }
                        if (closestAnthill1 !== closestAnthill2 && closestAnthill1 && closestAnthill2) {
                            if (closestAnthill1) {
                                let hasPath = entity.tilesPathTo(closestAnthill1, entity.z, true, true);
                                if (!hasPath) {
                                    entity.path = [];
                                    return;
                                }

                                entity.path.push({
                                    x: closestAnthill1.x,
                                    y: closestAnthill1.y,
                                    z: 0,
                                    maxDist: 35
                                });
                            }

                            if (closestAnthill2) {
                                let hasPath = entity.tilesPathTo(closestAnthill2, entity.z, true, true);
                                if (!hasPath) {
                                    entity.path = [];
                                    return;
                                }

                                entity.path.push({
                                    x: closestAnthill2.x,
                                    y: closestAnthill2.y,
                                    z: to.z,
                                    maxDist: 35
                                });
                            }

                            entity.tilesPathTo(to, to.z, true);
                        } else {
                            entity.path = [];
                            return;
                        }
                    } else {
                        entity.path = [];
                        return;
                    }
                }
            }
        }

        let node = {
            x: to.x + ((Math.random() * 10) - 5),
            y: to.y + ((Math.random() * 10) - 5),
            z: to.z
        };

        if (dropObject) {
            node.dropObject = dropObject;
        }

        if (maxDist) {
            node.maxDist = maxDist;
        }

        if (action) {
            node.action = action;
        }

        entity.path.push(node);
        return true;
    };

    entity.stateChangeTime = server.getModifiedTime();
    entity.setAIState = (newState) => {
        entity.aiState = newState;
        entity.stateChangeTime = server.getModifiedTime();
        if (newState === 'idle') {
            entity.target = null;
            targetPriority = 0;

            if (entity.nextAIState) {
                entity.aiState = entity.nextAIState.state;
                if (entity.nextAIState.onExecute) {
                    entity.nextAIState.onExecute(entity);
                }
                entity.nextAIState = null;
            }
        }

        if (server.config.enableAiDebugging) {
            entity.sendRPC('setAIState', {
                state: entity.aiState,
                targetId: entity.target ? entity.target.id : null
            });
        }
    };

    entity.setFollow = (follow) => {
        if (server.getMaxFollowers() && follow && follow.followers && follow.followers.length >= server.getMaxFollowers()) {
            return;
        }

        entity.leader = follow;
        entity.dropGrabbedObject();

        if (follow) {
            entity.path = [];
            entity.moveToPos = null;
            entity.setAIState('follow');
            if (!follow.followers) {
                follow.followers = [];
            }

            if (!follow.followers.includes(entity)) {
                follow.followers.push(entity);
            }
        } else {
            entity.setAIState('idle');
        }
    };

    entity.lastActionTime = server.getModifiedTime();
    entity.performAction = () => {
        if (entity.moveToPos.action && server.getModifiedTime() - entity.lastActionTime >= 100) {
            entity.lastActionTime = server.getModifiedTime();
            entity.moveToPos.action = false;

            entity.energy -= 0.001;

            if (entity.subtype === 'ant_queen' && entity.netData.flying) {
                entity.netData.flying = false;
                entity.sendRPC('setFlying', entity.netData.flying);
                entity.z = 0;
                return;
            }

            let candidates = server.quadtrees[entity.z].retrieve({x: entity.x, y: entity.y, width: 200, height: 200});
            if (!entity.carriedObject) {
                for (let i = 0; i < candidates.length; i++) {
                    let entity2 = candidates[i];
                    let entDist = Math.distanceBetween(entity.moveToPos, entity2);
                    if (entity !== entity2) {
                        let shouldFeed = false;
                        if (entity2.subtype === 'ant_queen') {
                            let foodType = entity2.getNeededFoodType();
                            if (entity.socialFoodStorage > 0 && entity.lastEatenFoodType === foodType) {
                                shouldFeed = true;
                            }
                        }
                        if (!shouldFeed && entity2.netData) {
                            shouldFeed = entity2.netData.hungry;
                        }
                        if (!entity.carriedObject && entity.socialFoodStorage > 0 && entity.team === entity2.team && (entity2.type === 'insect' || entity2.subtype === 'brood') && entity.z === entity2.z && entity2.valid && entity2.netData.alive && shouldFeed && entDist < entity.radius + entity2.radius + 5) {
                            entity.socialFoodStorage--;
                            entity2.eat(null, entity);
                            entity.lastEatenFoodType = null;
                            return;
                        } else if (entity.z === entity2.z && entity2.valid && (entity2.subtype === 'food' || entity2.subtype === 'brood' || entity2.subtype === 'aphid' || entity2.subtype === 'wreath' || entity2.subtype === 'material') && entDist < 15) {
                            if ((entity.netData.hungry || (entity.hasSocialStomach && entity.socialFoodStorage < 1) || (entity.subtype === 'ant_queen' && entity2.netData.foodType === entity.getNeededFoodType())) && entity2.subtype === 'food' && (entity.subtype === 'ant_queen' || (entity2.netData.foodType !== 'blue' && entity2.netData.foodType !== 'red'))) {
                                entity.eat(entity2);
                                entity2.remove();
                            } else {
                                if (entity.team !== entity2.team && entity2.freeBrood) {
                                    if (entity.subtype !== 'ant_queen') {
                                        entity2.remove();
                                    }
                                } else {
                                    entity.changeGrabbedObject(entity2);
                                }
                            }
                            return;
                        }
                    }
                }
            }

            let targetOverride = null;
            for (let i = 0; i < candidates.length; i++) {
                let entity2 = candidates[i];
                let entDist = Math.distanceBetween(entity.moveToPos, entity2);
                if (entity !== entity2) {
                    if (entity2.subtype === 'anthill' && (entity.z === entity2.z || entity.z === entity2.z + 1) && entity2.valid && entDist < 40 && (entity.subtype !== 'ant_queen' || (entity.team === entity2.team || (server.teamData[entity2.team] && server.teamData[entity2.team].dead)) || (entity.team === entity2.team && entity.netData && entity.netData.newQueen))) {
                        if (entity.z > entity2.z) {
                            entity.z--;
                        } else {
                            entity.z++;
                        }
                        entity.rotation = Math.random() * Math.PI * 2;
                        return;
                    } else if (!entity.carriedObject && entity2.type === 'insect' && entity.team !== entity2.team && entity.z === entity2.z && entity2.valid && entity2.netData.alive && entDist < entity.radius + entity2.radius + 5) {
                        entity.performAttack(entity2);
                        entity.moveToPos = null;
                        return;
                    } else if (entity.carriedObject && entity.carriedObject.subtype === 'food' && (entity2.type === 'insect' || entity2.subtype === 'brood') && entity.team === entity2.team && (entity2.netData.hungry || (entity2.subtype === 'ant_queen' && entity.carriedObject.netData.foodType === entity2.getNeededFoodType())) && entity.z === entity2.z && entity2.valid && entDist < entity.radius + entity2.radius + 5) {
                        entity2.eat(entity.carriedObject);
                        entity.changeGrabbedObject(null);
                        return;
                    } else if (entity2.subtype === 'food_source' && entDist < entity.radius + entity2.radius + 5) {
                        targetOverride = entity2;
                    }
                }
            }

            if (entity.z === 1 && !entity.carriedObject) {
                let tx = parseInt((entity.moveToPos.x)/server.TILE_SIZE);
                let ty = parseInt((entity.moveToPos.y)/server.TILE_SIZE);
                let tile = server.getTile(tx, ty)[0];

                if (tile === 1) {
                    entity.dig(tx, ty);
                    return;
                }
            }

            if (entity.carriedObject) {
                entity.dropGrabbedObject();
            } else {
                if (entity.subtype === 'ant_queen' && entity.netData.newQueen && entity.z <= 0) {
                    let mapSize = server.MAP_SIZE * server.TILE_SIZE;
                    if (entity.x < 250 || entity.y < 250 || entity.x > mapSize - 250 || entity.y > mapSize - 250) {
                        if (entity.currentPlayer) {
                            entity.currentPlayer.emit('growl', 'Nest too close to map edge.');
                        }
                    } else {
                        let blocked = false;
                        let blockedMessage = 'Nest does not fit here.';
                        for (let i=0; i<server.entities.length; i++) {
                            let other = server.entities[i];
                            let dist = Math.distanceBetween(entity, other);
                            if (other.subtype === 'anthill' && other.z === entity.z && dist < 800) {
                                blocked = true;
                                blockedMessage = 'Nest too close to another colony.';
                                break;
                            } else if (other.subtype === 'anthill' && dist < 100) {
                                blocked = true;
                                break;
                            }  else if (other.subtype === 'food_source' && dist < other.radius + 200) {
                                blocked = true;
                                break;
                            }
                        }

                        if (blocked) {
                            if (entity.currentPlayer) {
                                entity.currentPlayer.emit('growl', blockedMessage);
                            }
                        } else {
                            let anthill = server.createNewAnthill(entity);
                            if (!anthill) {
                                if (entity.currentPlayer) {
                                    entity.currentPlayer.emit('growl', 'Nest does not fit here.');
                                }
                            }
                        }
                    }
                }
            }

            if (targetOverride) {
                entity.target = targetOverride;
            }
        }
    };

    entity.lastAggroTime = server.getModifiedTime();
    entity.isAggro = false;
    let harvesting = 0;
    let lastHarvest = server.getModifiedTime();
    entity.performAttack = (attackTarget) => {
        if (entity.weapon === 'acid' && entity.z >= 1) {
            return;
        }

        let dist = Math.distanceBetween(entity, attackTarget);
        if (dist < entity.radius + attackTarget.radius + attackDistance && entity.z === attackTarget.z) {
            if ((attackTarget === entity.target && entity.target.team === entity.team) || entity.z <= -1 || (entity.subtype === 'ant_queen' && (entity.z <= 0 || server.gamemode.type === 'endless'))) {
                entity.target = null;
                return;
            }

            if (attackTarget && attackTarget.damage && attackTarget.team !== entity.team && !entity.carriedObject && server.getModifiedTime() - lastAttackTime > attackTimeCoolDown) {
                if (attackTarget.subtype === 'food_source' && attackTarget.canHarvest(entity)) {
                    if (server.getModifiedTime() >= lastHarvest+5000) {
                        harvesting = 0;
                    }
                    harvesting++;
                    lastHarvest = server.getModifiedTime();

                    entity.dx = 0;
                    entity.dy = 0;
                    moveTick = 50;
                    if (harvesting >= 16) {
                        harvesting = 0;
                        let foodType = attackTarget.takeFood();
                        let food = server.createObject('food', entity.x + Math.cos(entity.rotation-(Math.PI/2))*35, entity.y + Math.sin(entity.rotation-(Math.PI/2))*35, entity.z, 45, 45, -1, {foodType: foodType});
                        entity.resetTarget();
                        if (entity.isAI) {
                            entity.target = food;
                            entity.setAIState('moveobject');
                        }
                        return;
                    }
                } else if (attackTarget.subtype === 'food_source') {
                    entity.resetTarget();
                    return;
                }

                lastAttackTime = server.getModifiedTime();
                let targetKilled = attackTarget.damage(damage, entity);
                entity.rotation = Math.angleBetween(entity, attackTarget) + Math.PI / 2;
                entity.sendMoveUpdate = true;
                entity.sendRPC('performAttack', {
                    weapon: attackTarget.subtype === 'food_source' ? 'jaws' : entity.weapon,
                    targetX: attackTarget ? attackTarget.x : null,
                    targetY: attackTarget ? attackTarget.y : null
                });

                if (targetKilled && (entity.subtype === 'spider' || (entity.subtype === 'bug' && entity.netData && entity.netData.bugType === 'centipede' && entity.netData.centipedeType === 'head'))) {
                    entity.lastAggroTime = server.getModifiedTime();
                }

                if (!entity.isAI) {
                    entity.target = attackTarget;
                }
            }
        }
    };

    let lastDamageAlert = Date.now();
    entity.damage = (amount, attacker) => {
        if (entity.netData && entity.netData.alive) {
            entity.netData.health -= amount;
            entity.lastDamageTime = server.getModifiedTime();
            entity.lastAggroTime = 0;
            entity.isAggro = true;
            if (entity.mainEntity) {
                entity.mainEntity.lastAggroTime = 0;
                entity.mainEntity.netData.health -= amount*0.1;
                if (entity.mainEntity.netData.health <= 0) {
                    entity.mainEntity.damage(1, attacker);
                }
            }
            if (Date.now()-lastDamageAlert > 5000 && (!entity.target || !entity.target.valid || !entity.target.netData || !entity.target.netData.alive) && attacker && attacker.valid && attacker.netData && attacker.netData.alive && attacker.weapon === 'acid') {
                lastDamageAlert = Date.now();
                entity.target = attacker;
                let others = server.getAvailableWorkers(entity, false, true);
                for (let i=0; i<others.length; i++) {
                    let other = others[i];
                    other.moveToPos = {
                        x: attacker.x,
                        y: attacker.y
                    };
                    other.target = attacker;
                }
            }

            if (entity.netData.health <= 0) {
                entity.kill(attacker);
                return true;
            } else {
                entity.sendRPC('damage', amount);
            }
        }
    };

    let targetDist = 10000;
    let targetPriority = 0;
    let nonTargetList = {};
    entity.resetTarget = (addToNonTargetList) => {
        if (entity.target) {
            if (addToNonTargetList) {
                nonTargetList[entity.target.id] = server.getModifiedTime()+2500+Math.floor(Math.random()*4000);
            }
            entity.target = null;
            targetDist = 10000;
            targetPriority = 0;
            entity.dropGrabbedObject();
            entity.moveToPos = null;
            entity.path = null;
        }
    };

    entity.tickTargetAI = () => {
        if (!entity.target || (!entity.target.valid && entity.target !== entity.carriedObject)) {
            entity.resetTarget();
            return;
        }

        targetDist = Math.distanceBetween(entity, entity.target);
        if (entity.target !== entity.carriedObject && (targetDist > 800 || entity.z !== entity.target.z || (entity.target.subtype !== 'object' && entity.target.netData && !entity.target.netData.alive))) {
            entity.resetTarget();
            return;
        }

        if (entity.subtype === 'ant_worker' && !entity.isAggro && entity.team !== entity.target.team && !entity.leader && entity.z <= 0 && entity.target.type === 'insect' && entity.target.subtype !== 'bug' && entity.target.subtype !== 'beetle') {
            if (nearbyEnemy >= nearbyFriendly) {
                let diff = Math.abs(nearbyEnemy - nearbyFriendly);
                let enemyPercentage = diff/nearbyFriendly;
                if (enemyPercentage > 0.1) {
                    if (entity.queen && entity.queen.anthill && entity.queen.valid) {
                        let dist = Math.distanceBetween(entity, entity.queen.anthill);
                        if (dist <= 1000) {
                            let angle = Math.random() * 360;
                            entity.pathTo({
                                x: entity.queen.anthill.x + (Math.cos(angle) * 100),
                                y: entity.queen.anthill.y + (Math.sin(angle) * 100),
                                z: 1,
                                returningHome: true
                            }, 35, true);
                            return;
                        }
                    }

                    let angle = Math.angleBetween(entity.target, entity);
                    entity.moveToPos = {
                        x: entity.x + Math.cos(angle) * 100,
                        y: entity.y + Math.sin(angle) * 100
                    };
                    return;
                }
            }
        }

        if (entity.subtype === 'spider' || (entity.subtype === 'bug' && entity.netData && entity.netData.bugType === 'centipede' && entity.netData.centipedeType === 'head')) {
            if ((entity.target.subtype === 'ant_worker' || entity.target.subtype === 'ant_queen') && entity.target.netData.alive) {
                if (targetDist <= 70) {
                    entity.performAttack(entity.target);
                }

                if (targetDist <= 400) {
                    if (entity.netData && entity.netData.bugType === 'centipede') {
                        if (targetDist > 100) {
                            let angle = Math.angleBetween(entity, entity.target);
                            entity.moveToPos = {
                                x: entity.target.x + (Math.cos(angle) * 150),
                                y: entity.target.y + (Math.sin(angle) * 150)
                            };
                        }

                    } else {
                        entity.moveToPos = {
                            x: entity.target.x,
                            y: entity.target.y
                        };
                    }
                }
            }
        } else if (entity.subtype === 'ant_worker' || entity.subtype === 'ant_queen') {
            if (entity.target.type === 'insect' && !entity.carriedObject && entity.team !== entity.target.team && entity.target.netData.alive && targetDist <= 250+attackDistance && (((entity.aiState === 'idle' || entity.aiState === 'defend') && entity.subtype !== 'ant_queen') || targetDist < 80)) {
                if (entity.netData.newQueen) {
                    if (!entity.moveToPos && (!entity.path || !entity.path.length)) {
                        let angle = Math.angleBetween(entity, entity.target) - (Math.PI/2);
                        entity.pathTo({
                            x: Math.cos(angle) * 100,
                            y: Math.sin(angle) * 100,
                            z: entity.z
                        });
                    }
                } else {
                    if (targetDist < entity.radius + entity.target.radius + attackDistance) {
                        entity.performAttack(entity.target);
                    } else {
                        if (!entity.moveToPos && (!entity.path || !entity.path.length)) {
                            let hasPath = entity.pathTo(entity.target, null, null, null, null, {
                                doNotLeaveNest: true
                            });
                            if (!hasPath) {
                                entity.resetTarget(true);
                            }
                        }
                    }
                }
            } else if (entity.subtype === 'ant_worker' && (entity.aiState === 'idle' || (entity.aiState === 'follow' && entity.target.subtype === 'food' && entity.socialFoodStorage <= 0 && entity.target.netData.foodType !== 'blue' && entity.target.netData.foodType !== 'red')) && ((entity.queen && entity.queen.anthill && entity.queen.valid) || entity.netData.hungry) && (entity.z === 0 || entity.team !== entity.target.team) && (entity.target.subtype === 'food' || entity.target.subtype === 'brood' || entity.target.subtype === 'food_source') && !entity.carriedObject && targetDist <= 350 && !server.teamData[entity.team].isFakeTeam) {
                if (!entity.moveToPos && (!entity.path || !entity.path.length)) {
                    let hasPath = entity.pathTo(entity.target, null, null, null, null, {
                        doNotLeaveNest: true
                    });
                    if (!hasPath) {
                        entity.resetTarget(true);
                        return;
                    }
                }

                if (entity.target.subtype === 'food_source') {
                    if (targetDist < entity.target.radius+entity.radius+5) {
                        entity.performAttack(entity.target);

                        if (entity.target) {
                            entity.aiReturnPos = {
                                x: entity.target.x,
                                y: entity.target.y,
                                z: entity.target.z
                            };
                        }
                    }
                } else {
                    if (targetDist < 25) {
                        entity.returnToLastStateAfterStateChange();
                        entity.setAIState('moveobject');

                        if (entity.z <= 0 || entity.target.team === -1) {
                            entity.aiReturnPos = {
                                x: entity.target.x,
                                y: entity.target.y,
                                z: entity.target.z
                            };
                        }
                    }
                }
            } else if (entity.subtype === 'ant_worker' && entity.target.subtype === 'ant_worker' && server.teamData[entity.team] && server.teamData[entity.team].isAI && entity.team === entity.target.team && entity.aiState === 'idle') {
                if (!entity.moveToPos && (!entity.path || !entity.path.length)) {
                    entity.greetOther(entity.target, true);
                    entity.pathTo(entity.target);
                    entity.target = null;
                }
            } else if (entity.subtype === 'ant_worker' && entity.target.subtype === 'anthill') {
                entity.pathTo({
                    x: entity.target.x,
                    y: entity.target.y,
                    z: 1
                });
                entity.target = null;
            }
        }
    };

    entity.greetOther = (entity2, emitToOther, forceShareReturnPos) => {
        if (entity.dataAI && entity.dataAI.greetList && !entity.dataAI.greetList[entity2.id]) {
            entity.dataAI.greetList[entity2.id] = true;
            if (!entity.dataAI.roleEncounters[entity2.dataAI.role]) {
                entity.dataAI.roleEncounters[entity2.dataAI.role] = 0;
            }
            entity.dataAI.roleEncounters[entity2.dataAI.role]++;

            if (emitToOther) {
                entity2.greetOther(entity, false, true);
            }

            if (!entity.carriedObject && entity2.aiReturnPos && entity.aiState === 'idle' && entity2.carriedObject) {
                entity.pathTo(entity2.aiReturnPos);
            }
        } else if (forceShareReturnPos && Math.random() > 0.5) {
            if (!entity.carriedObject && entity2.aiReturnPos && entity.aiState === 'idle' && entity2.carriedObject && (!entity.path || !entity.path.length)) {
                entity.pathTo(entity2.aiReturnPos);
            }
        }
    };

    if (entity.subtype !== 'grub') {
        entity.thinkAI = (entity2, dist) => {
            let validTarget = false;
            let potentialPriority = 1;
            if (entity.isAggro && (entity.subtype === 'spider' || (entity.subtype === 'bug' && entity.netData && entity.netData.bugType === 'centipede' && entity.netData.centipedeType === 'head'))) {
                if ((entity2.subtype === 'ant_worker' || entity2.subtype === 'ant_queen') && entity2.netData.alive) {
                    validTarget = true;
                    potentialPriority = 5;
                }
            } else if (entity.subtype === 'ant_worker' || (entity.subtype === 'ant_queen' && server.gamemode.type !== 'endless')) {
                if (entity2.type === 'insect' && entity.team !== entity2.team && entity2.netData.alive && ((dist <= 250+attackDistance && entity2.isAggro) || dist <= 120+attackDistance) && (((entity.aiState === 'idle' || entity.aiState === 'defend') && entity.subtype !== 'ant_queen') || dist < 80)) {
                    validTarget = true;
                    potentialPriority = 5;
                } else if (entity.subtype === 'ant_worker' && (entity.aiState === 'idle' || entity.aiState === 'follow') && ((server.teamData[entity.team] && entity.queen && entity.queen.anthill) || (entity2.subtype === 'food' && entity.netData.hungry)) && (entity.z === 0 || entity.team !== entity2.team) && (entity2.subtype === 'food' || entity2.subtype === 'brood' || (entity2.subtype === 'food_source' && entity2.canHarvest(entity))) && dist <= 350) {
                    validTarget = true;
                    if (entity2.subtype === 'brood') {
                        potentialPriority = 4;
                    } else if (entity2.subtype === 'food' && entity2.netData && (entity2.netData.foodType === 'blue' || entity2.netData.foodType === 'red')) {
                        potentialPriority = 3;
                    } else if (entity2.subtype === 'food_source') {
                        potentialPriority = 1;
                    } else {
                        potentialPriority = 2;
                    }
                } else if (entity2.subtype === 'ant_worker' && dist < 250 && server.teamData[entity.team] && server.teamData[entity.team].isAI && entity.team === entity2.team && entity.dataAI.greetList && !entity.dataAI.greetList[entity2.id]) {
                    validTarget = true;
                    potentialPriority = 1;
                } else if (entity2.subtype === 'anthill' && entity.queen && entity.queen.birthCount > 30 && dist < 150 && server.teamData[entity.team] && server.teamData[entity.team].isAI && entity.team !== entity2.team && !entity.carriedObject && (!entity.path || !entity.path.length) && !entity.moveToPos && entity.aiState === 'idle') {
                    validTarget = true;
                    potentialPriority = 2;
                }
            }

            if (entity2.type === 'insect') {
                if (entity.team === entity2.team && dist <= 500) {
                    nearbyFriendly++;
                    if (entity2.isAggro) {
                        nearbyFriendly += 5;
                    }
                } else {
                    if (entity2.subtype === 'spider') {
                        nearbyEnemy += 5;
                    } else if (entity2.netData.bugType === 'centipede' && entity2.netData.centipedeType === 'head') {
                        nearbyEnemy += 10;
                    } else if (entity2.subtype === 'ant_worker' || entity2.subtype === 'ant_queen') {
                        nearbyEnemy++;
                    }
                }
            }

            if (validTarget && nonTargetList[entity2.id] && server.getModifiedTime() < nonTargetList[entity2.id]) {
                validTarget = false;
            }

            if (validTarget && potentialPriority > targetPriority && entity.carriedObject && dist < 100) {
                entity.resetTarget();
            }

            if (validTarget && !entity.carriedObject && potentialPriority >= targetPriority && (!entity.target || dist < targetDist)) {
                if (nonTargetList[entity2.id]) {
                    delete nonTargetList[entity2.id];
                }
                targetDist = dist;
                targetPriority = potentialPriority;
                entity.target = entity2;
            }
        };
    }

    entity.getPotentialTilesNearQueen = (val) => {
        let potentialTiles = [];

        entity.searchForTile(entity.queen, (node, start) => {
            let tile = server.getTile(node.x, node.y);
            let tileServer = server.getTileServer(node.x, node.y);
            if (tile && tileServer && tile[0] === 0 && tile[1] === val && tileServer.usage <= 0.98) {
                let qdist = Math.distanceBetween(node, start);
                potentialTiles.push({
                    node: node,
                    tile: tile,
                    score: ((1 - tile.usage) * 4) - qdist
                });
                return potentialTiles.length >= 8;
            } else {
                return false;
            }
        });

        potentialTiles.sort((a, b) => {
            return b.score - a.score;
        });

        return potentialTiles;
    };

    entity.onCollide = (colEntity) => {
        if (entity.subtype === 'ant_queen' && entity.netData.alive && (entity.netData.hungry || colEntity.netData.foodType === entity.getNeededFoodType()) && colEntity.subtype === 'food') {
            entity.eat(colEntity);
            colEntity.remove();
        } else if ((entity.subtype !== 'ant_queen' && entity.subtype !== 'ant_worker') && entity.netData.alive && colEntity.static) {
            entity.moveToPos = null;
            lastMoveAngle = Math.random() * Math.PI * 2;
        } else if (entity.subtype === 'ant_worker' && colEntity.subtype === 'ant_worker' && server.teamData[entity.team] && server.teamData[entity.team].isAI && entity.team === colEntity.team && entity.dataAI && entity.dataAI.greetList && !entity.dataAI.greetList[colEntity.id]) {
            entity.greetOther(colEntity, true, true);
        }
    };

    entity.dropGrabbedObject = () => {
        if (entity.carriedObject) {
            if (entity.carriedObject.subtype === 'dirt') {
                if (entity.z >= 1 && entity.moveToPos) {
                    let dist = Math.distanceBetween(entity, entity.moveToPos);
                    if (dist <= server.TILE_SIZE) {
                        let tx = parseInt((entity.moveToPos.x) / server.TILE_SIZE);
                        let ty = parseInt((entity.moveToPos.y) / server.TILE_SIZE);
                        let ptx = parseInt((entity.x) / server.TILE_SIZE);
                        let pty = parseInt((entity.y) / server.TILE_SIZE);
                        let tile = server.getTile(tx, ty);

                        if (tile !== null && tile[0] === 0 && !(tx === ptx && ty === pty)) {
                            let tilepos = {
                                x: (tx * server.TILE_SIZE) + (server.TILE_SIZE / 2),
                                y: (ty * server.TILE_SIZE) + (server.TILE_SIZE / 2)
                            };
                            let candidates = server.quadtrees[1].retrieve({
                                x: tilepos.x,
                                y: tilepos.y,
                                width: 200,
                                height: 200
                            });

                            let empty = true;
                            for (let j = 0; j < candidates.length; j++) {
                                let entity2 = candidates[j];
                                let maxDist = server.TILE_SIZE;
                                if (entity2.subtype === 'anthill') {
                                    maxDist = server.TILE_SIZE * 1.8;
                                }
                                if (entity2 !== entity && Math.distanceBetween(tilepos, entity2) < maxDist) {
                                    empty = false;
                                    break;
                                }
                            }
                            if (empty) {
                                server.updateTile(tx, ty, 1);
                                entity.changeGrabbedObject(null);
                            }
                        }
                    }
                } else if (entity.z <= 0) {
                    entity.changeGrabbedObject(null);
                }
            } else if (entity.carriedObject.subtype === 'material' && !entity.isAI && entity.z >= 1 && entity.moveToPos) {
                let dist = Math.distanceBetween(entity, entity.moveToPos);
                if (dist <= server.TILE_SIZE) {
                    let tx = parseInt((entity.moveToPos.x) / server.TILE_SIZE);
                    let ty = parseInt((entity.moveToPos.y) / server.TILE_SIZE);
                    let tile = server.getTile(tx, ty);

                    if (tile !== null && tile[0] === 0) {
                        let tilepos = {
                            x: (tx * server.TILE_SIZE) + (server.TILE_SIZE / 2),
                            y: (ty * server.TILE_SIZE) + (server.TILE_SIZE / 2)
                        };
                        let candidates = server.quadtrees[1].retrieve({
                            x: tilepos.x,
                            y: tilepos.y,
                            width: 200,
                            height: 200
                        });

                        let empty = true;
                        for (let j = 0; j < candidates.length; j++) {
                            let entity2 = candidates[j];
                            let maxDist = server.TILE_SIZE * 1.8;
                            if (entity2 !== entity && entity2.subtype === 'anthill' && Math.distanceBetween(tilepos, entity2) < maxDist) {
                                empty = false;
                                break;
                            }
                        }

                        if (empty) {
                            let newMoisture = null;
                            if (entity.carriedObject.netData.matType === 'twigs') {
                                if (tile[1] === 1) {
                                    newMoisture = 0.5;
                                } else {
                                    newMoisture = 0;
                                }
                            } else if (entity.carriedObject.netData.matType === 'water') {
                                if (tile[1] === 0) {
                                    newMoisture = 0.5;
                                } else {
                                    newMoisture = 1;
                                }
                            }

                            if (newMoisture !== null) {
                                server.updateTile(tx, ty, null, newMoisture);
                                let tileServer = server.getTileServer(tx, ty);
                                if (tileServer) {
                                    tileServer.damage = 0;
                                    tileServer.usage = 0;
                                }
                                entity.changeGrabbedObject(null);
                            }
                        }
                    }
                }
            } else {
                if (entity.z >= 1 && entity.moveToPos) {
                    let tx = parseInt((entity.moveToPos.x) / server.TILE_SIZE);
                    let ty = parseInt((entity.moveToPos.y) / server.TILE_SIZE);
                    let tile = server.getTile(tx, ty);

                    if (tile === null || tile[0] === 1) {
                        return;
                    }
                }

                let ox = entity.x + Math.random();
                let oy = entity.y + Math.random();
                ox += Math.cos(entity.rotation - Math.PI / 2) * 20;
                oy += Math.sin(entity.rotation - Math.PI / 2) * 20;
                entity.carriedObject.x = ox;
                entity.carriedObject.y = oy;
                entity.carriedObject.lastX = entity.carriedObject.x;
                entity.carriedObject.lastY = entity.carriedObject.y;
                entity.carriedObject.z = entity.z;
                entity.carriedObject.rotation = Math.random()*Math.PI*2;

                if (!entity.isAI && entity.carriedObject.subtype === 'brood' && entity.z === 0 && entity.team === entity.carriedObject.originalTeam && (!entity.carriedObject.netData || entity.carriedObject.netData.fakeTeam === null || entity.carriedObject.netData.fakeTeam === undefined)) {
                    entity.griefCount++;
                    if (entity.griefCount >= 10) {
                        entity.griefCount = 0;
                        for (let i=0; i<server.clients.length; i++) {
                            let client = server.clients[i];
                            if (client.player === entity) {
                                server.banClient(client, 'Banned for griefing.');
                                break;
                            }
                        }
                    }
                }

                server.addEntity(entity.carriedObject);
                entity.changeGrabbedObject(null);
            }
        }
    };

    entity.changeGrabbedObject = (object) => {
        entity.carriedObject = object;
        let data = null;
        if (entity.carriedObject && entity.carriedObject.subtype === 'brood') {
            data = entity.carriedObject.netData.broodStage;
            if (object.team !== entity.team) {
                object.queen = entity.queen;
            }
            if (entity.carriedObject.team !== entity.team) {
                if (entity.carriedObject.netData.fakeTeam === null || entity.carriedObject.netData.fakeTeam === undefined) {
                    entity.carriedObject.netData.fakeTeam = entity.carriedObject.team;
                }
            }
        }
        if (entity.carriedObject) {
            if (entity.carriedObject.subtype === 'brood' && entity.carriedObject.team !== entity.team) {
                if (!entity.carriedObject.stolenData) {
                    entity.carriedObject.stolenData = {};
                }
                if (!entity.carriedObject.stolenData[entity.team]) {
                    entity.carriedObject.stolenData[entity.carriedObject.team] = true;
                    entity.carriedObject.stolenData[entity.team] = true;
                    server.recordXP(entity, 25, 'brood_stolen');
                }
            }
            entity.carriedObject.team = entity.team;
            entity.carriedObject.moveToPos = null;
        }
        entity.netData.carriedObject = entity.carriedObject ? {subtype: entity.carriedObject.subtype, data: data, netData: entity.carriedObject.netData, size: entity.carriedObject.width} : null;
        if (entity.netData.carriedObject) {
            if (object.subtype === 'food') {
                entity.netData.carriedObject.foodType = object.netData.foodType;
            } else if (object.subtype === 'material') {
                entity.netData.carriedObject.matType = object.netData.matType;
            }
        }
        entity.sendRPC('changeGrabbedObject', entity.netData.carriedObject);

        if (object && object.valid) {
            object.remove();
        }

        if (server.teamData[entity.team] && entity.aiReturnPos && !entity.carriedObject) {
            entity.pathTo(entity.aiReturnPos, 35, false);
            entity.aiReturnPos = null;
        }
    };

    entity.kill = (attacker) => {
        if (!entity.netData.alive) {
            return;
        }

        if (entity.currentPlayer) {
            entity.currentPlayer.canControl = false;
        }

        server.dismissFollowers(entity);

        if (entity.leader && entity.leader.followers && entity.leader.followers.length) {
            for (let i=0; i<entity.leader.followers.length; i++) {
                let follower = entity.leader.followers[i];
                if (entity === follower) {
                    entity.leader.followers.splice(i, 1);
                    break;
                }
            }
        }

        entity.dropGrabbedObject();
        entity.netData.alive = false;
        entity.sendRPC('kill', false);

        if (server.teamData[team]) {
            server.teamData[team].lastAttacker = attacker;
        }

        if (entity.subtype === 'ant_queen') {
            if (server.teamData[team] && server.teamData[team].queens) {
                for (let i = 0; i < server.teamData[team].queens.length; i++) {
                    let queen = server.teamData[team].queens[i];
                    if (queen === entity) {
                        server.teamData[team].queens.splice(i, 1);
                        break;
                    }
                }

                for (let i = 0; i < server.teamData[team].queens.length; i++) {
                    let queen = server.teamData[team].queens[i];
                    if (queen && queen.valid && queen.netData.alive) {
                        server.teamData[team].queen = queen;
                        break;
                    }
                }
            }


            let teamCheck = {};
            let teamCount = 0;
            for (let i = 0; i < server.entities.length; i++) {
                let entcheck = server.entities[i];
                if (entcheck.subtype === 'ant_queen' && entcheck.valid && entcheck.netData.alive && !teamCheck[entcheck.team]) {
                    teamCheck[entcheck.team] = true;
                    teamCount++;
                }
            }

            let endState = 1;
            if (server.gamemode.type === 'coop') {
                endState = 0;
            }

            if (teamCount <= endState) {
                server.endGame();
            } else {
                if (!teamCheck[entity.team]) {
                    server.killTeam(entity.team);
                }
            }

            server.updateTeamInfo(entity.team);

            let xpInc = 0;
            if (entity.birthCount) {
                xpInc = entity.birthCount*5;
            }
            server.recordXP(attacker, 200 + xpInc, 'queen_killed');
        } else if (entity.subtype === 'ant_worker') {
            if (entity.socialFoodStorage >= 1) {
                server.createObject('food', entity.x, entity.y, entity.z, 45, 45, -1, {foodType: entity.lastEatenFoodType ? entity.lastEatenFoodType : 'meat'});
            }

            if (server.teamData[entity.team] && server.teamData[entity.team].isAI && entity.queen && entity.queen.birthCount > 12) {
                let others = server.getAvailableWorkers(entity, true);
                for (let i = 0; i < others.length; i++) {
                    let other = others[i];
                    if (!other.carriedObject && Math.random() > 0.5) {
                        other.pathTo(entity);
                        other.dropGrabbedObject();
                    }
                }
            }

            let antType = 'worker';
            let xpAmount = 0;
            if (entity.antType) {
                antType = entity.antType;
            }
            switch (antType) {
                case 'nanitic':
                    xpAmount = 15;
                    break;
                case 'worker':
                    xpAmount = 30;
                    break;
                case 'soldier':
                    xpAmount = 45;
                    break;
                case 'major':
                    xpAmount = 60;
                    break;
            }
            server.recordXP(attacker, xpAmount, antType + '_killed');
        } else if (entity.subtype === 'spider') {
            let addFoodCount = 6;
            for (let i=0; i<addFoodCount; i++) {
                let angle = (Math.PI*2) * Math.random();
                let dist = 15 + (Math.random()*50);
                server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'meat'});
            }

            for (let i=0; i<3; i++) {
                let angle = (Math.PI*2) * Math.random();
                let dist = 15 + (Math.random()*50);
                server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'blue'});
            }

            server.recordXP(attacker, 100, 'spider_killed');
        } else if (entity.subtype === 'bug' || subtype === 'beetle') {
            if (entity.netData && entity.netData.bugType === 'centipede') {
                let mod = width/120;
                if (mod > 1.25) {
                    mod = 1.25;
                }
                if (entity.netData.centipedeType === 'head') {
                    let redFoodCount = 1;
                    if (width >= 125) {
                        redFoodCount = 2;
                    }
                    for (let i=0; i<redFoodCount; i++) {
                        let angle = (Math.PI*2) * Math.random();
                        let dist = 15 + (Math.random()*40);
                        server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'red'});
                    }

                    let blueFoodCount = Math.round(5*mod);
                    for (let i=0; i<blueFoodCount; i++) {
                        let angle = (Math.PI*2) * Math.random();
                        let dist = 15 + (Math.random()*40);
                        server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'blue'});
                    }

                    server.recordXP(attacker, 100 * mod, 'centipede_killed');
                } else {
                    if (Math.random() > 0.6) {
                        for (let i = 0; i < 1; i++) {
                            let angle = (Math.PI * 2) * Math.random();
                            let dist = 15 + (Math.random() * 40);
                            server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'meat'});
                        }
                    }
                }
            } else {
                let addFoodCount = 6;
                for (let i = 0; i < addFoodCount; i++) {
                    let angle = (Math.PI * 2) * Math.random();
                    let dist = 15 + (Math.random() * 50);
                    server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'meat'});
                }

                server.recordXP(attacker, 25, 'insect_killed');
            }
        } else if (entity.subtype === 'grub') {
            let addFoodCount = 2;
            for (let i=0; i<addFoodCount; i++) {
                let angle = (Math.PI*2) * Math.random();
                let dist = 5 + (Math.random()*10);
                server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'meat'});
            }

            if (Math.random() >= 0.95) {
                for (let i = 0; i < 1; i++) {
                    let angle = (Math.PI * 2) * Math.random();
                    let dist = 5 + (Math.random() * 10);
                    server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), entity.z, 45, 45, -1, {foodType: 'blue'});
                }
            }

            server.recordXP(attacker, 15, 'grub_killed');

            entity.remove();
        }
    };

    entity.onRemove = () => {
        server.dismissFollowers(entity);
    };

    return entity;
};
},{"../tilefinder":36,"pathfinding":9}],33:[function(require,module,exports){
const broodMatureInterval = 5;
const moistureAndBroodCheckInterval = 125;
module.exports = function(subtype, x, y, z, width, height, team, netData) {
    const server = this;

    if (subtype === 'food' || subtype === 'material') {
        width = 32;
        height = 32;
    }

    if (!netData) {
        netData = {};
    }
    netData.delayServerAddEntity = true;
    if (subtype === 'rock') {
        netData.rockType = Math.floor(Math.random()*4);
    }
    if (subtype === 'stick') {
        netData.stickType = Math.floor(Math.random()*4);
    }
    if (subtype === 'anthill') {
        if (!netData.anthillSize) {
            netData.anthillSize = 0;
        }
    }
    if (subtype === 'rock' || subtype === 'plant' || subtype === 'anthill') {
        //Snap position to the center of a tile.
        x = Math.floor(x / server.TILE_SIZE) * server.TILE_SIZE + (server.TILE_SIZE/2);
        y = Math.floor(y / server.TILE_SIZE) * server.TILE_SIZE + (server.TILE_SIZE/2);

        let checkSize = server.TILE_SIZE*1.5;
        let candidates = server.quadtrees[z].retrieve({x: x, y: y, width: checkSize, height: checkSize});
        for (let i = 0; i < candidates.length; i++) {
            let other = candidates[i];
            if (other && other.valid && (other.subtype === 'rock' || other.subtype === 'plant' || other.subtype === 'anthill')) {
                let dist = Math.distanceBetween({x: x, y: y, z: z}, other);
                if (dist <= checkSize) {
                    return;
                }
            }
        }
    }

    if (subtype === 'plant') {
        netData.leafCount = 3;
        netData.leafRotation = -0.1 + (Math.random()*Math.PI*0.2);
        if (Math.random() >= 0.85) {
            netData.leafCount++;
            netData.leafRotation -= 0.8;
        }
    }

    if (subtype === 'food') {
        if (!netData.foodType) {
            netData.foodType = 'plant';
        }
    } else if (subtype === 'material') {
        if (!netData.matType) {
            netData.matType = 'twigs';
        }
    }

    let entity = server.createEntity('object', subtype, x, y, z, width, height, team, netData);
    entity.collisionLayer = 2;

    if (subtype === 'anthill') {
        entity.radius = 0;
        if (server.teamData[team]) {
            server.teamData[team].anthill = entity;
        }

        server.loopTileArea(entity, 2.2, (x, y, z) => {
            let entDist = Math.distanceBetween(entity, {x: (x*server.TILE_SIZE) + server.TILE_SIZE/2, y: (y*server.TILE_SIZE) + server.TILE_SIZE/2});
            if (entDist < 2.2*server.TILE_SIZE) {
                if (entDist <= server.TILE_SIZE) {
                    server.updateTile(x, y, 0, 0.5);
                } else {
                    server.updateTile(x, y, 0);
                }
            }
        });

        server.anthills.push(entity);
    } else if (subtype === 'brood') {
        if (!entity.netData.broodStage) {
            entity.netData.broodStage = 0;
            entity.matureTime = broodMatureInterval;
        } else {
            if (server.tutorial) {
                entity.matureTime = 2 + Math.round(Math.random() * 2);
            } else {
                entity.matureTime = 40 + Math.round(Math.random() * 10);
            }
            entity.freeBrood = true;
        }
        entity.radius = 12;
        entity.rotation = Math.random()*Math.PI*2;
    } else if (subtype === 'aphid') {
        entity.radius = 12;
        entity.rotation = Math.random()*Math.PI*2;
    } else if (subtype === 'rock') {
        entity.radius = width/4;
        entity.rotation = Math.random()*Math.PI*2;
        entity.collisionLayer = 1;
        entity.static = true;
    } else if (subtype === 'plant') {
        entity.radius = width/3;
        //entity.rotation = Math.random()*Math.PI*2;
        entity.rotation = -0.1 + (Math.random()*Math.PI*0.2);
        entity.collisionLayer = 1;
        entity.static = true;
    } else if (subtype === 'object_solid') {
        entity.radius = width*0.4;
        entity.collisionLayer = 1;
        entity.static = true;
    } else if (subtype === 'food_source') {
        entity.radius = width*0.15;
        entity.collisionLayer = 4;
        entity.rotation = Math.random()*Math.PI*2;
        if (netData.foodSourceType === 'plant') {
            entity.radius = width/3;
            entity.collisionLayer = 1;
            entity.rotation = -0.1 + (Math.random()*Math.PI*0.2);
            entity.static = true;
        } else {
            entity.static = false;
        }
    } else if (subtype === 'stick') {
        entity.radius = 0;
        entity.rotation = Math.random()*Math.PI*2;
        entity.collisionLayer = 4;
        entity.static = true;
    } else if (subtype === 'object_hide') {
        entity.radius = 0;
        entity.rotation = Math.random()*Math.PI*2;
        entity.collisionLayer = 4;
        entity.static = true;
    } else {
        entity.radius = 12;
        entity.rotation = Math.random()*Math.PI*2;
    }

    entity.updateTileArea = () => {
        if (subtype === 'food' || subtype === 'brood' || subtype === 'aphid') {
            return;
        }

        server.updateTileArea(entity, entity.getTileCheckRadius() * 1.5);

        let tx = parseInt(entity.x / server.TILE_SIZE);
        let ty = parseInt(entity.y / server.TILE_SIZE);
        let tileServer = server.getTileServer(tx, ty);
        if (tileServer) {
            if (entity.valid) {
                tileServer.anthill = entity;
            } else {
                delete tileServer.anthill;
            }
        }
    };

    entity.getTileCheckRadius = () => {
        let checkRadius = entity.radius*1.2;
        if (subtype === 'anthill') {
            checkRadius = 2 * server.TILE_SIZE;
        }
        return checkRadius;
    }

    server.addEntity(entity);

    if (subtype === 'rock' || subtype === 'object_solid' || subtype === 'plant' || subtype === 'anthill') {
        entity.updateTileArea();
    }

    entity.originalTeam = team;
    entity.spoilage = 0;
    let moistureTick = 0;
    let aphidLastFood = null;
    let aphidBlueCount = 0;
    let workerRequestTime = 0;
    let oldTick = entity.tick;
    let speed = 3;
    entity.tick = () => {
        if (entity.moveToPos && entity.moveToPos.z === entity.z) {
            let dist = Math.distanceBetween(entity, entity.moveToPos);
            let angle = Math.angleBetween(entity, entity.moveToPos);
            entity.rotation = angle + Math.PI / 2;

            entity.dx += Math.cos(angle) * speed;
            entity.dy += Math.sin(angle) * speed;

            let curMoveToDist = entity.moveToPos.moveToDist ? entity.moveToPos.moveToDist : 30;
            if (dist <= curMoveToDist) {
                entity.moveToPos = null;
            }
        }

        if (entity.subtype === 'food' || entity.subtype === 'brood') {
            if (moistureTick <= 0) {
                moistureTick = moistureAndBroodCheckInterval;
                if (entity.z === 1) {
                    let tx = parseInt(entity.x / server.TILE_SIZE);
                    let ty = parseInt(entity.y / server.TILE_SIZE);
                    let curTile = server.getTile(tx, ty);
                    let moisture = curTile[1];

                    if (entity.z >= 1) {
                        server.decreaseTileDamage(tx, ty);
                        if (curTile[0] >= 1) {
                            entity.remove();
                        }
                    }

                    let isSpoiling = false;
                    if (entity.subtype === 'food' && moisture !== 0) {
                        isSpoiling = true;
                    } else if (entity.subtype === 'brood' && moisture !== 1) {
                        isSpoiling = true;
                    }

                    if (isSpoiling) {
                        if (entity.subtype === 'brood') {
                            entity.tickBroodMaturing(0.5);
                        } else {
                            entity.spoilage += 0.075;
                        }

                        if (entity.z >= 1 && entity.team !== -1) {
                            if (server.getModifiedTime() > workerRequestTime) {
                                let worker = server.getNearbyWorker(entity);
                                if (worker) {
                                    worker.target = entity;
                                    worker.setAIState('moveobject');
                                    workerRequestTime = server.getModifiedTime() + 18000;
                                } else {
                                    workerRequestTime = server.getModifiedTime() + 6000;
                                }
                            }
                        }
                    } else {
                        entity.spoilage -= 0.1;
                        if (entity.team !== -1) {
                            server.increaseTileUsage(tx, ty);
                        }

                        entity.tickBroodMaturing(6);
                    }
                } else if (entity.z === 0 && entity.subtype === 'brood') {
                    entity.spoilage += 0.2;
                } else if (entity.z === 0 && entity.subtype === 'food') {
                    entity.spoilage += 0.025;
                }

                if (entity.spoilage >= 1) {
                    entity.remove();
                } else if (entity.spoilage < 0) {
                    entity.spoilage = 0;
                }
            } else {
                moistureTick--;
            }
        } else if (entity.subtype === 'material' && entity.netData.matType === 'water') {
            if (!server.currentWeather || (server.currentWeather.type !== 'rain')) {
                entity.spoilage += 0.01;
                if (entity.spoilage >= 1) {
                    entity.remove();
                } else if (entity.spoilage < 0) {
                    entity.spoilage = 0;
                }
            }
        }

        if (entity.subtype === 'aphid') {
            if (moistureTick <= 0) {
                moistureTick = 850;

                if (server.currentSeason.type === 'winter') {
                    entity.remove();
                }

                if (!aphidLastFood || !aphidLastFood.valid || aphidLastFood.z !== entity.z || Math.distanceBetween(entity, aphidLastFood) >= 200) {
                    let candidates = server.quadtrees[entity.z].retrieve({x: entity.x, y: entity.y, width: 1000, height: 1000});
                    let plant = null;
                    let maxPlantDist = 10000;
                    for (let i=0; i<candidates.length; i++) {
                        let entity2 = candidates[i];
                        let dist = Math.distanceBetween(entity, entity2);
                        if (entity2.subtype === 'plant' && entity2.valid && dist < maxPlantDist) {
                            plant = entity2;
                            maxPlantDist = dist;
                        }
                    }

                    if (plant) {
                        entity.moveToPos = {
                            x: plant.x,
                            y: plant.y,
                            z: plant.z,
                            moveToDist: plant.radius * 1.4
                        };
                    }

                    if (plant && maxPlantDist <= plant.radius*5) {
                        let dist = 15;
                        let angle = entity.rotation + Math.PI/2;
                        if (server.getModifiedTime() - server.roundStartTime > 3 * 60 * 1000) {
                            aphidBlueCount++;
                            if (aphidBlueCount >= 8) {
                                aphidBlueCount = 0;
                                aphidLastFood = server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), 0, 45, 45, -1, {foodType: 'blue'});
                            } else {
                                aphidLastFood = server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), 0, 45, 45, -1, {foodType: 'honeydew'});
                            }
                        } else {
                            aphidLastFood = server.createObject('food', entity.x + (Math.cos(angle) * dist), entity.y + (Math.sin(angle) * dist), 0, 45, 45, -1, {foodType: 'honeydew'});
                        }
                    }
                }
            } else {
                moistureTick--;
            }
        } else if (entity.subtype === 'anthill') {
            let tx = parseInt(entity.x / server.TILE_SIZE);
            let ty = parseInt(entity.y / server.TILE_SIZE);
            let curTile = server.getTile(tx, ty);
            if (curTile[0] >= 1) {
                entity.remove();
            }
        }

        if (entity.subtype === 'brood' && entity.netData.broodStage === 1) {
            entity.checkRequestTask();

            if (entity.energy <= 0) {
                entity.remove();
            } else {
                if (entity.energy > 100) {
                    entity.energy = 100;
                }
                entity.energy -= 0.02;

                if (entity.energy <= 60 && !entity.netData.hungry) {
                    entity.setHungry(true);
                }
            }
        }

        entity.dx *= 0.5;
        entity.dy *= 0.5;
        oldTick();
    };

    if (subtype === 'rock' || subtype === 'plant' || subtype === 'stick') {
        delete entity.tick;
    }

    entity.tickBroodMaturing = (matureRate) => {
        if (entity.matureTime > 0) {
            if (server.tutorial) {
                matureRate = 4;
            }
            entity.matureTime -= matureRate;
        } else if (entity.netData.broodStage < 1) {
            entity.matureBroodStage();
        } else if (entity.subtype === 'brood' && entity.matureTime <= 0 && entity.netData.broodStage >= 2) {
            entity.remove();

            if (entity.team < 0) {
                return;
            }

            if (entity.queen) {
                if (!entity.queen.birthCount) {
                    entity.queen.birthCount = 0;
                }
                entity.queen.birthCount++;
            }

            let ant;
            let xpAmount = 0;
            switch (entity.broodType) {
                case 'nanitic':
                    ant = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, 48, 48, entity.team, {
                        fakeTeam: entity.netData.fakeTeam,
                        isNanitic: true
                    });
                    xpAmount = 15;
                    break;
                case 'worker':
                    ant = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, 65, 65, entity.team, {
                        fakeTeam: entity.netData.fakeTeam
                    });
                    xpAmount = 30;
                    break;
                case 'soldier':
                    ant = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, 80, 80, entity.team, {
                        fakeTeam: entity.netData.fakeTeam,
                        soldier: true
                    });
                    xpAmount = 45;
                    break;
                case 'major':
                    ant = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, 110, 110, entity.team, {
                        fakeTeam: entity.netData.fakeTeam,
                        soldier: true
                    });
                    xpAmount = 60;
                    break;
                case 'acid':
                    ant = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, 85, 105, entity.team, {
                        fakeTeam: entity.netData.fakeTeam
                    });
                    xpAmount = 75;
                    break;
                case 'queen':
                    ant = server.createInsect('ant_queen', entity.x + Math.random(), entity.y + Math.random(), entity.z, 70, 70, entity.team, {
                        newQueen: true
                    });
                    xpAmount = 150;
                    break;
            }

            if (ant) {
                server.recordXP(ant, xpAmount, entity.broodType + '_born');
                ant.queen = entity.queen;
            } else {
                if (entity.broodType === 'queen') {
                    let newQueen = server.createInsect('ant_queen', entity.x + Math.random(), entity.y + Math.random(), entity.z, 70, 70, entity.team, {newQueen: true});
                    if (entity.queen && entity.queen.anthill) {
                        newQueen.anthill = entity.queen.anthill;
                    }
                } else {
                    if (entity.netData.isSuper) {
                        let size = 80;
                        if (server.teamData[entity.team]) {
                            server.teamData[entity.team].majorCount++;
                            if (server.teamData[entity.team].majorCount >= 4) {
                                size = 110;
                                server.teamData[entity.team].majorCount = 0;
                            }
                        }

                        let worker = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, size, size, entity.team, {
                            soldier: true,
                            fakeTeam: entity.netData.fakeTeam
                        });
                        worker.queen = entity.queen;
                    } else {
                        let worker = server.createInsect('ant_worker', entity.x + Math.random(), entity.y + Math.random(), entity.z, 65, 65, entity.team, {fakeTeam: entity.netData.fakeTeam});
                        worker.queen = entity.queen;
                    }
                }
            }

            if (!entity.freeBrood && server.teamData[entity.team] && entity.queen && entity.queen.anthill && entity.queen.anthill.netData.anthillSize < 10) {
                entity.queen.anthill.increaseAnthillSize();
            }
        }
    };

    entity.matureBroodStage = () => {
        entity.netData.broodStage++;
        entity.matureTime = broodMatureInterval;
        entity.sendRPC('changeBroodStage', entity.netData.broodStage);
    };

    let anthillSizeChange = 0;
    entity.increaseAnthillSize = () => {
        anthillSizeChange++;
        if (anthillSizeChange > 2) {
            anthillSizeChange = 0;
            entity.netData.anthillSize++;
            entity.sendRPC('changeAnthillSize', entity.netData.anthillSize);

            if (entity.netData.anthillSize >= 10) {
                let candidates = server.quadtrees[0].retrieve({x: entity.x, y: entity.y, width: 400, height: 400});
                for (let i=0; i<candidates.length; i++) {
                    let entity2 = candidates[i];
                    if (entity2.subtype === 'object_hide') {
                        let dist = Math.distanceBetween(entity, entity2);
                        if (dist <= 300) {
                            entity2.remove();
                        }
                    }
                }
            }
        }
    };

    if (subtype === 'food_source') {
        let harvesters = {};
        entity.tick = () => {
            let keys = Object.keys(harvesters);
            if (keys.length) {
                let curTime = server.getModifiedTime();
                for (let i=0; i<keys.length; i++) {
                    let ht = harvesters[keys[i]];
                    if (curTime > ht+2000) {
                        delete harvesters[keys[i]];
                    }
                }
            }
        };

        entity.damage = (amount, attacker) => {
            if (entity.canHarvest(attacker)) {
                harvesters[attacker.id] = server.getModifiedTime();
            }
        };

        entity.canHarvest = (harvester) => {
            if (netData.foodSourceType === 'plant' && server.currentSeason.type === 'winter') {
                return false;
            }
            return harvesters[harvester.id] || Object.keys(harvesters).length < 3;
        }

        let foodCount = 128;
        if (netData.foodSourceType === 'plant') {
            foodCount = 20;
        }
        entity.takeFood = () => {
            foodCount--;
            if (foodCount <= 0) {
                entity.remove();
            }
            if (netData.foodSourceType) {
                return netData.foodSourceType;
            }
            return 'meat';
        };
    }

    entity.eat = (eaten) => {
        entity.hasEaten = true;
        entity.energy = 100;
        entity.netData.health = 100;
        entity.setHungry(false);

        if (eaten && eaten.netData.foodType === 'blue') {
            entity.netData.isSuper = true;
            entity.superTime = server.getModifiedTime();
        }

        if (entity.subtype === 'brood') {
            entity.matureBroodStage();
        }
    };

    entity.onRemove = () => {
        entity.updateTileArea();
        if (entity.subtype === 'anthill' && server.anthills) {
            let index = server.anthills.indexOf(entity);
            if (index > -1) {
                server.anthills.splice(index, 1);
            }
        }
    };

    return entity;
};
},{}],34:[function(require,module,exports){
/*
 * Javascript Quadtree 
 * @version 1.1.1
 * @licence MIT
 * @author Timo Hausmann
 * https://github.com/timohausmann/quadtree-js/
 */
 
/*
 Copyright © 2012 Timo Hausmann

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENthis. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

 /*
  * Quadtree Constructor
  * @param Object bounds		bounds of the node, object with x, y, width, height
  * @param Integer max_objects		(optional) max objects a node can hold before splitting into 4 subnodes (default: 10)
  * @param Integer max_levels		(optional) total max levels inside root Quadtree (default: 4)
  * @param Integer level		(optional) deepth level, required for subnodes
  */
function Quadtree( bounds, max_objects, max_levels, level ) {

	this.max_objects	= max_objects || 10;
	this.max_levels		= max_levels || 4;

	this.level 		= level || 0;
	this.bounds 		= bounds;

	this.objects 		= [];
	this.nodes 		= [];
};


/*
 * Split the node into 4 subnodes
 */
Quadtree.prototype.split = function() {

	var 	nextLevel	= this.level + 1,
		subWidth	= Math.round( this.bounds.width / 2 ),
		subHeight 	= Math.round( this.bounds.height / 2 ),
		x 		= Math.round( this.bounds.x ),
		y 		= Math.round( this.bounds.y );

	//top right node
	this.nodes[0] = new Quadtree({
		x	: x + subWidth,
		y	: y,
		width	: subWidth,
		height	: subHeight
	}, this.max_objects, this.max_levels, nextLevel);

	//top left node
	this.nodes[1] = new Quadtree({
		x	: x,
		y	: y,
		width	: subWidth,
		height	: subHeight
	}, this.max_objects, this.max_levels, nextLevel);

	//bottom left node
	this.nodes[2] = new Quadtree({
		x	: x,
		y	: y + subHeight,
		width	: subWidth,
		height	: subHeight
	}, this.max_objects, this.max_levels, nextLevel);

	//bottom right node
	this.nodes[3] = new Quadtree({
		x	: x + subWidth,
		y	: y + subHeight,
		width	: subWidth,
		height	: subHeight
	}, this.max_objects, this.max_levels, nextLevel);
};


/*
 * Determine which node the object belongs to
 * @param Object pRect		bounds of the area to be checked, with x, y, width, height
 * @return Integer		index of the subnode (0-3), or -1 if pRect cannot completely fit within a subnode and is part of the parent node
 */
Quadtree.prototype.getIndex = function( pRect ) {

	var 	index 			= -1,
		verticalMidpoint 	= this.bounds.x + (this.bounds.width / 2),
		horizontalMidpoint 	= this.bounds.y + (this.bounds.height / 2),

		//pRect can completely fit within the top quadrants
		topQuadrant = (pRect.y < horizontalMidpoint && pRect.y + pRect.height < horizontalMidpoint),

		//pRect can completely fit within the bottom quadrants
		bottomQuadrant = (pRect.y > horizontalMidpoint);

	//pRect can completely fit within the left quadrants
	if( pRect.x < verticalMidpoint && pRect.x + pRect.width < verticalMidpoint ) {
		if( topQuadrant ) {
			index = 1;
		} else if( bottomQuadrant ) {
			index = 2;
		}

	//pRect can completely fit within the right quadrants
	} else if( pRect.x > verticalMidpoint ) {
		if( topQuadrant ) {
			index = 0;
		} else if( bottomQuadrant ) {
			index = 3;
		}
	}

	return index;
};


/*
 * Insert the object into the node. If the node
 * exceeds the capacity, it will split and add all
 * objects to their corresponding subnodes.
 * @param Object pRect		bounds of the object to be added, with x, y, width, height
 */
Quadtree.prototype.insert = function( pRect ) {

	var 	i = 0,
		index;

	//if we have subnodes ...
	if( typeof this.nodes[0] !== 'undefined' ) {
		index = this.getIndex( pRect );

		if( index !== -1 ) {
			this.nodes[index].insert( pRect );
			return;
		}
	}

	this.objects.push( pRect );

	if( this.objects.length > this.max_objects && this.level < this.max_levels ) {

		//split if we don't already have subnodes
		if( typeof this.nodes[0] === 'undefined' ) {
			this.split();
		}

		//add all objects to there corresponding subnodes
		while( i < this.objects.length ) {

			index = this.getIndex( this.objects[ i ] );

			if( index !== -1 ) {
				this.nodes[index].insert( this.objects.splice(i, 1)[0] );
			} else {
				i = i + 1;
			}
		}
	}
 };


/*
 * Return all objects that could collide with the given object
 * @param Object pRect		bounds of the object to be checked, with x, y, width, height
 * @Return Array		array with all detected objects
 */
Quadtree.prototype.retrieve = function( pRect, cancelCenter ) {
	if (!cancelCenter) {
        pRect.x -= pRect.width / 2;
        pRect.y -= pRect.height / 2;
    }
    var index = this.getIndex( pRect ),
		returnObjects = this.objects;

	//if we have subnodes ...
	if( typeof this.nodes[0] !== 'undefined' ) {

		//if pRect fits into a subnode ..
		if( index !== -1 ) {
			returnObjects = returnObjects.concat( this.nodes[index].retrieve( pRect, true ) );

		//if pRect does not fit into a subnode, check it against all subnodes
		} else {
			for( var i=0; i < this.nodes.length; i=i+1 ) {
				returnObjects = returnObjects.concat( this.nodes[i].retrieve( pRect, true ) );
			}
		}
	}

	return returnObjects;
};


/*
 * Clear the quadtree
 */
Quadtree.prototype.clear = function() {

	this.objects = [];

	for( var i=0; i < this.nodes.length; i=i+1 ) {
		if( typeof this.nodes[i] !== 'undefined' ) {
			this.nodes[i].clear();
		}
	}

	this.nodes = [];
};

//make Quadtree available in the global namespace
module.exports = Quadtree;
},{}],35:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,setImmediate){(function (){
const Noise = require('noisejs');
const PF = require('pathfinding');
const Quadtree = require('./quadtree');
const Tutorial = require('./tutorial');
const CreateEntity = require('./entities/entity');
const CreateObject = require('./entities/object');
const CreateInsect = require('./entities/insect');

const LOBBY_WAIT_TIME = 90000;

function Server(gameMaster, serverId, sendMasterMessage, gameData, serverInviteToken, tokenRequestData, config, window, gamemodeString) {
    const server = this;
    server.config = config;
    server.TILE_SIZE = 64;
    server.MAP_SIZE = Math.round(8000/server.TILE_SIZE);
    //server.MAP_SIZE = Math.round(10000/server.TILE_SIZE);
    server.paused = false;

    let fixedTimeStep = 1000/14;
    let snapshotRate = 1000/6;
    let originalFixedTimeStep = fixedTimeStep;

    let lastTimeOffset = 0;
    server.changeTimestep = (increased) => {
        if (increased) {
            fixedTimeStep = 1000/120;
            snapshotRate = 1000/8;
            let timeMod = originalFixedTimeStep/fixedTimeStep;
            server.getModifiedTime = function() {
                lastTimeOffset = (Date.now() - server.roundStartTime) * timeMod;
                return Date.now() + lastTimeOffset;
            };
        } else {
            fixedTimeStep = 1000/14;
            snapshotRate = 1000/6;
            originalFixedTimeStep = fixedTimeStep;
            server.getModifiedTime = function() {
                return Date.now() + lastTimeOffset;
            };
        }

        if (server.sendMessage) {
            server.sendMessage('changeTimeStep', fixedTimeStep);
        }
    };
    server.changeTimestep(false);

    server.serverId = serverId;
    if (!tokenRequestData) {
        tokenRequestData = {};
    }
    if (config.isTutorial) {
        server.tutorial = new Tutorial(this, window, config);
    }

    server.broodTypes = {
        'nanitic': {
            name: 'Nanitic',
            cost: {
                'plant': 2
            }
        },
        'worker': {
            name: 'Worker',
            cost: {
                'plant': 1,
                'meat': 1
            }
        },
        'soldier': {
            name: 'Soldier',
            cost: {
                'meat': 2,
                'blue': 1
            }
        },
        'major': {
            name: 'Major',
            cost: {
                'meat': 2,
                'blue': 2
            }
        },
        'acid': {
            name: 'Acid',
            cost: {
                'plant': 1,
                'meat': 1,
                'blue': 2
            }
        },
        'queen': {
            name: 'Queen',
            cost: {
                'red': 4
            }
        }
    };

    let MAX_TEAM_PLAYERS = 4;
    let MAX_FOLLOWERS = null;
    let TIME_TIL_NIGHT = 2 * 60 * 1000;
    let TIME_TIL_DAY = 1 * 60 * 1000;
    let WEATHER_CHANGE_INTERVAL = 60 * 1000;
    let SEASON_CHANGE_INTERVAL = ((TIME_TIL_DAY + TIME_TIL_NIGHT) * 3) - 10000;
    server.getMaxFollowers = () => {
        return MAX_FOLLOWERS;
    };

    server.roundStartTime = Date.now();
    server.gamemode = {
        type: 'normal'
    };
    if (config.isSingleplayer) {
        server.gamemode = 'normal';
    }
    server.worldData = {};
    server.currentDay = 1;
    server.currentYear = 1;

    let seasonDataObj = {
        spring: {
            rainChance: 0.3
        },
        summer: {
            rainChance: 0.15
        },
        fall: {
            rainChance: 0.01
        },
        winter: {
            rainChance: 0.0001
        }
    };
    server.getSeasonData = (type) => {
        if (!type) {
            type = server.currentSeason.type;
        }
        if (seasonDataObj[type]) {
            return seasonDataObj[type];
        }
        return {};
    };

    server.currentWeather = null;
    server.currentSeason = {
        type: 'spring'
    };

    server.lastEntityId = 0;
    server.clients = [];
    server.entities = [];
    server.anthills = [];
    let tiles = [];
    let tilesServer = [];
    server.tileGrids = null;
    let gameEnded = false;
    server.teamData = {};
    let teamCount = 0;
    let clientCounter = 0;
    let night = false;
    let nextNightChange = server.getModifiedTime() + TIME_TIL_NIGHT;
    let nextWeatherChange = server.getModifiedTime() + WEATHER_CHANGE_INTERVAL;
    let nextSeasonChange = server.getModifiedTime() + SEASON_CHANGE_INTERVAL;
    let roundState = {
        type: 'lobby'
    };
    server.quadtrees = [];
    server.quadtrees[-1] = new Quadtree({
        x: 0,
        y: 0,
        width: server.MAP_SIZE * server.TILE_SIZE,
        height: server.MAP_SIZE * server.TILE_SIZE
    });
    for (let z=0; z<3; z++) {
        server.quadtrees.push(new Quadtree({
            x: 0,
            y: 0,
            width: server.MAP_SIZE * server.TILE_SIZE,
            height: server.MAP_SIZE * server.TILE_SIZE
        }));
    }

    server.createEntity = CreateEntity.bind(this);
    server.createObject = CreateObject.bind(this);
    server.createInsect = CreateInsect.bind(this);

    server.getClients = () => {
        return server.clients;
    };

    server.getServerInviteToken = () => {
        return serverInviteToken;
    };

    server.getFullInviteToken = () => {
        return gameData.inviteToken + '-' + serverInviteToken;
    };

    server.isPrivate = () => {
        return tokenRequestData.privateGame;
    };

    server.getPlayerCount = () => {
        return server.clients.length;
    };

    server.getActualPlayerCount = () => {
        let actualClients = 0;
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            if (client && !client.isBot) {
                actualClients++;
            }
        }
        return actualClients;
    };

    server.hasOpenSlot = (requireCanPlayRightAway) => {
        if (server.getRoundState().type === 'lobby') {
            return true;
        } else {
            let availableTeams = 0;
            let teamLength = Object.keys(server.teamData).length;
            for (let i = 0; i < teamLength; i++) {
                let team = server.teamData[i];
                if (team && !team.locked && !team.dead && team.clients.length < MAX_TEAM_PLAYERS && (!requireCanPlayRightAway || team.aliveAntCount > team.clients.length || !team.queen || team.queen.newQueen)) {
                    availableTeams++;
                }
            }
            return availableTeams > 0;
        }
    };

    server.createTeam = () => {
        let newTeam = server.teamData[teamCount] = {
            id: teamCount,
            locked: false,
            queens: [],
            clients: [],
            spawnQueue: [],
            majorCount: 0,
            score: 0,
            isAI: false,
            dataAI: {},
            stats: {}
        };
        teamCount++;
        return newTeam;
    };

    server.getNearbyWorker = (entity, extraReq, allowNonIdle) => {
        let followers = server.getAvailableWorkers(entity, false, allowNonIdle);
        if (entity && followers && followers.length) {
            for (let i=0; i<followers.length; i++) {
                let worker = followers[i];
                if (entity.z === worker.z && Math.distanceBetween(entity, worker) <= 2000 && (allowNonIdle || worker.aiState === 'idle') && !worker.carriedObject && worker.valid && worker.netData.alive && (!worker.path || !worker.path.length)) {
                    if (!extraReq || extraReq(worker)) {
                        return worker;
                    }
                }
            }
            return null;
        }
    };

    server.getAvailableWorkers = (leader, includeOtherZ, allowFollowingWorkers) => {
        if (leader && server.teamData[leader.team]) {
            let candidates = server.quadtrees[leader.z].retrieve({x: leader.x, y: leader.y, width: 1500, height: 1500});
            let followers = [];
            for (let i=0; i<candidates.length; i++) {
                let entity = candidates[i];
                if (entity.isAI && entity.subtype === 'ant_worker' && entity.valid && entity.netData && entity.netData.alive && entity.team === leader.team && (!entity.leader || allowFollowingWorkers) && entity.aiState !== 'defend') {
                    followers.push(entity);
                }
            }
            if (includeOtherZ) {
                let otherZ = leader.z;
                if (otherZ === 0) {
                    otherZ = 1;
                } else {
                    otherZ = 0;
                }
                candidates = server.quadtrees[otherZ].retrieve({x: leader.x, y: leader.y, width: 1500, height: 1500});
                for (let i=0; i<candidates.length; i++) {
                    let entity = candidates[i];
                    let dist = Math.distanceBetween(leader, entity);
                    if (entity.isAI && entity.subtype === 'ant_worker' && entity.valid && dist < 1000 && entity.netData && entity.netData.alive && entity.team === leader.team && (!entity.leader || allowFollowingWorkers) && entity.aiState !== 'defend') {
                        followers.push(entity);
                    }
                }
            }
            followers.sort((a, b) => {
                let adist = Math.distanceBetween(leader, a);
                let bdist = Math.distanceBetween(leader, b);
                return adist - bdist;
            });
            return followers;
        }

        return [];
    };

    server.tilesPathTo = (from, to) => {
        if (!server.tileGrids[from.z]) {
            return false;
        }

        let finder = new PF.AStarFinder({
            allowDiagonal: true,
            dontCrossCorners: true
        });
        let grid = server.tileGrids[from.z].clone();
        let fromTile = server.getTile(parseInt(from.x / server.TILE_SIZE), parseInt(from.y / server.TILE_SIZE));
        let toTile = server.getTile(parseInt(to.x / server.TILE_SIZE), parseInt(to.y / server.TILE_SIZE));
        if (fromTile && toTile) {
            try {
                let path = finder.findPath(parseInt(from.x / server.TILE_SIZE), parseInt(from.y / server.TILE_SIZE), parseInt(to.x / server.TILE_SIZE), parseInt(to.y / server.TILE_SIZE), grid);
                if (path && path.length) {
                    return path;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    };

    server.getClosestAnthill = (entity, team, checkPath) => {
        let closestArray = [];
        for (let i = 0; i < server.anthills.length; i++) {
            let entity2 = server.anthills[i];
            if (entity2.subtype === 'anthill' && (team === null || team === undefined || entity2.team === team)) {
                let dist = Math.distanceBetween(entity, entity2);
                closestArray.push({
                    anthill: entity2,
                    dist: dist
                });
            }
        }

        closestArray.sort((a, b) => {
            if (a.dist < b.dist) {
                return -1;
            } else if (a.dist > b.dist) {
                return 1;
            } else {
                return 0;
            }
        });

        if (checkPath && entity.z !== null && entity.z !== undefined) {
            for (let i=0; i<closestArray.length; i++) {
                let val = closestArray[i];

                let hasPath = server.tilesPathTo(entity, val.anthill);
                if (hasPath) {
                    break;
                } else {
                    closestArray.shift();
                    i--;
                }
            }
        }

        return (closestArray && closestArray.length) ? closestArray[0].anthill : null;
    };

    server.getClosestQueen = (entity, team) => {
        let currentTeam = server.teamData[team];
        if (!currentTeam) {
            return null;
        }

        currentTeam.queens.sort((a, b) => {
            if (!a.dist) {
                a.dist = Math.distanceBetween(entity, a);
            }
            if (!b.dist) {
                b.dist = Math.distanceBetween(entity, b);
            }

            if (a.dist < b.dist) {
                return -1;
            } else if (a.dist > b.dist) {
                return 1;
            } else {
                return 0;
            }
        });

        return (currentTeam.queens && currentTeam.queens.length) ? currentTeam.queens[0] : null;
    };

    server.addEntity = (entity) => {
        entity.valid = true;
        if (config.isSingleplayer || entity.static) {
            server.sendMessage('createEntity', entity.getCreateData());
        }
        server.entities.push(entity);
    };

    server.openQueenMenu = (queen, doNotOpen) => {
        let team = server.teamData[queen.team];
        if (team && team.clients.length) {
            let queenData = {
                id: queen.id,
                broodTypes: server.broodTypes,
                broodQueue: queen.broodQueue,
                doNotOpen: doNotOpen
            };
            team.clients[0].emit('openQueenMenu', queenData);
        }
    };

    server.onClientConnected = (socket) => {
        socket.clientId = clientCounter++;
        socket.canControl = false;
        socket.knownEntities = {};
        socket.team = null;
        socket.recentMessages = [];
        socket.score = 0;
        socket.lastAction = Date.now();
        server.clients.push(socket);
        socket.playStartTime = Date.now();
        socket.unawardedXP = 0;
        socket.connected = true;
        socket.emit('worldData', server.worldData);
        if (!server.running) {
            server.startLoop();
        }

        socket.on('move', (data) => {
            if (socket.canControl && socket.player && socket.player.valid && !gameEnded) {
                socket.lastAction = Date.now();
                if (data && !data.stop && ((data.x && data.y) || data.angle !== undefined)) {
                    if (data.angle !== undefined) {
                        socket.player.moveToPos = {
                            angle: parseFloat(data.angle)
                        };
                    } else {
                        socket.player.moveToPos = {
                            x: parseFloat(data.x),
                            y: parseFloat(data.y),
                            action: data.action
                        };
                    }
                } else if (data.stop && socket.player.moveToPos) {
                    //socket.player.moveToPos = null;
                    if (socket.player.moveToPos.x) {
                        delete socket.player.moveToPos.angle;
                    } else {
                        socket.player.moveToPos = null;
                    }
                    return;
                }
                socket.player.target = null;

                if (socket.player.netData.digging) {
                    socket.player.stopDig();
                }

                if (data.action) {
                    let entity = socket.player;
                    if (entity && entity.valid && entity.moveToPos) {
                        let candidates = server.quadtrees[entity.z].retrieve({
                            x: entity.x,
                            y: entity.y,
                            width: 400,
                            height: 400
                        });
                        for (let i = 0; i < candidates.length; i++) {
                            let entity2 = candidates[i];
                            if (entity.moveToPos) {
                                let entDist = Math.distanceBetween(entity.moveToPos, entity2);
                                if (!entity.carriedObject && entity2.type === 'insect' && entity.team !== entity2.team && entity.z === entity2.z && entity2.valid && entity2.netData.alive && entDist < entity.radius + entity2.radius + 5) {
                                    entity.target = entity2;
                                    return;
                                }
                            }
                        }
                    }
                }
            }
        });

        socket.on('sandboxPosition', (data) => {
            if (socket.isSandbox && socket.player) {
                if (!socket.player.valid) {
                    socket.player = {
                        valid: true,
                        x: socket.player.x,
                        y: socket.player.y,
                        z: socket.player.z,
                        netData: {}
                    };
                }
                socket.player.x = data.x;
                socket.player.y = data.y;
                socket.player.z = data.z;
            }
        });

        let lastSwitch = 0;
        socket.on('switchSpectate', () => {
            if (Date.now()-lastSwitch <= 500 || socket.canControl) {
                return;
            }
            lastSwitch = Date.now();
            socket.canControl = false;
            let foundPlayer = false;
            for (let i = 0; i < server.entities.length; i++) {
                let entity = server.entities[i];
                if (entity.valid && entity.netData && entity.netData.alive && entity.team === socket.team && (entity.subtype === 'ant_queen' || entity.subtype === 'ant_worker') && entity !== socket.player && i > socket.lastSpectatedIndex) {
                    foundPlayer = true;
                    socket.lastSpectatedIndex = i;
                    server.setPlayerNoControl(socket, entity);
                    break;
                }
            }

            if (!foundPlayer) {
                let foundAI = false;
                for (let i = 0; i < server.entities.length; i++) {
                    let entity = server.entities[i];
                    if (entity.valid && entity.netData && entity.netData.alive && entity.team === socket.team && (entity.subtype === 'ant_queen' || entity.subtype === 'ant_worker') && entity !== socket.player && i > socket.lastSpectatedIndex) {
                        foundAI = true;
                        socket.lastSpectatedIndex = i;
                        server.setPlayerNoControl(socket, entity);
                        break;
                    }
                }

                if (!foundAI) {
                    socket.lastSpectatedIndex = -1;
                }
            }
        });

        socket.on('scoreboard', () => {
            let scoreboardData = server.getScoreboardData();
            scoreboardData.clientId = socket.clientId;
            socket.emit('scoreboardData', scoreboardData);
        });

        socket.reportedPlayers = {};
        socket.on('reportPlayer', (data) => {
            if (!socket.reportedPlayers[data.clientId]) {
                socket.reportedPlayers[data.clientId] = true;

                let reportedPlayer = null;
                for (let i=0; i<server.clients.length; i++) {
                    let client = server.clients[i];
                    if (client.clientId === data.clientId) {
                        reportedPlayer = client;
                        break;
                    }
                }

                if (reportedPlayer === socket) {
                    socket.emit('growl', 'You can not report yourself!');
                    return;
                }

                if (reportedPlayer) {
                    let recentMessages = socket.recentMessages.concat(reportedPlayer.recentMessages);
                    recentMessages.sort((a, b) => a.date - b.date);

                    let reportData = {
                        reporter: {
                            name: socket.name,
                            address: socket.realAddress,
                            user: socket.user
                        },
                        reported: {
                            name: reportedPlayer.name,
                            address: reportedPlayer.realAddress,
                            user: reportedPlayer.user
                        },
                        server: {
                            serverId: serverId,
                            fullInviteToken: server.getFullInviteToken(),
                            address: gameData.address,
                            region: gameData.region
                        },
                        recentMessages: recentMessages,
                        reason: data.reason
                    };

                    sendMasterMessage('reportPlayer', reportData);
                    socket.emit('growl', 'Player report sent.');
                } else {
                    socket.emit('growl', 'Player not found.');
                }
            } else {
                socket.emit('growl', 'You have already reported this player.');
            }
        });

        socket.on('switchPlayer', (entityId) => {
            if (socket.isSandbox || (socket.canControl && socket.player && socket.player.valid && socket.player.netData.alive)) {
                for (let i=0; i<server.entities.length; i++) {
                    let entity = server.entities[i];
                    if (entity.id === entityId) {
                        if (entity.valid && entity.netData.alive && entity.isAI) {
                            let check = false;
                            if (socket.isSandbox) {
                                check = entity.type === 'insect';
                            } else {
                                check = entity.team === socket.player.team && entity.z === socket.player.z && Math.distanceBetween(socket.player, entity) <= 2000 && (entity.subtype === 'ant_worker' || entity.subtype === 'ant_queen')
                            }

                            if (check) {
                                let isLeader = (socket && server.teamData[entity.team]) ? server.teamData[entity.team].clients[0] === socket : false;
                                if (!socket.isSandbox && entity.subtype === 'ant_queen' && !isLeader) {
                                    socket.emit('growl', 'Only team leader can switch to the queen.');
                                    break;
                                }
                                server.switchPlayer(socket, entity);
                            }
                        }
                        break;
                    }
                }
            }
        });

        socket.on('tutorialContinue', () => {
            if (server.tutorial) {
                server.tutorial.continue();
            }
        });

        socket.on('followPlayer', (entityId) => {
            if (socket.canControl && socket.player && socket.player.valid && socket.player.netData.alive) {
                for (let i=0; i<server.entities.length; i++) {
                    let entity = server.entities[i];
                    if (entity.id === entityId) {
                        if (entity.valid && entity.netData.alive && entity.isAI && entity.team === socket.player.team && entity.z === socket.player.z && Math.distanceBetween(socket.player, entity) <= 2000 && entity.subtype === 'ant_worker' && !entity.leader) {
                            entity.setFollow(socket.player);
                        }
                        break;
                    }
                }
            }
        });

        socket.on('lobbyReady', () => {
            if (!socket.ready && (!socket.player || !socket.canControl)) {
                socket.ready = true;

                if (roundState.type !== 'lobby') {
                    if (!socket.isSandbox) {
                        if (socket.team === null || socket.team === undefined) {
                            server.joinSmallestTeam(socket, false);
                        }

                        if (server.teamData[socket.team] && !server.teamData[socket.team].dead && server.teamData[socket.team].queen && server.teamData[socket.team].queen.valid && server.teamData[socket.team].queen.netData.alive) {
                            server.addClientToSpawnQueue(socket);
                        } else {
                            if (server.teamData[socket.team] && !server.teamData[socket.team].dead && !server.teamData[socket.team].queen) {
                                server.createTeamQueen(socket.team, socket);
                            } else {
                                socket.emit('growl', 'This team has already died, please pick another.');
                                socket.ready = false;
                            }
                        }
                    }
                }

                server.sendLobbyUpdate();
            }
        });

        /*
        socket.on('lobbyNewTeam', () => {
            if (Object.keys(server.teamData).length < 8 && server.gamemode.type !== 'coop') {
                let team = server.createTeam();
                server.setClientTeam(socket, team.id);
                server.sendLobbyUpdate();
            }
        });
        */

        socket.on('lobbyJoinTeam', (teamId) => {
            teamId = parseInt(teamId);
            if (teamId !== null && teamId !== undefined && socket.team !== teamId && server.teamData[teamId] && !server.teamData[teamId].locked && server.teamData[teamId].clients.length < MAX_TEAM_PLAYERS) {
                server.switchPlayer(socket, null);
                server.setClientTeam(socket, teamId);
                server.sendLobbyUpdate();
            }
        });

        socket.on('lobbyLockTeam', () => {
            if (socket.team !== null && socket.team !== undefined && server.teamData[socket.team].clients[0] === socket) {
                server.teamData[socket.team].locked = !server.teamData[socket.team].locked;
                server.sendLobbyUpdate();
            }
        });

        socket.on('lobbyKickPlayer', (clientId) => {
            if (socket.team !== null && socket.team !== undefined && server.teamData[socket.team].clients[0] === socket) {
                let client = server.getClientById(clientId);
                if (client && client.team === socket.team) {
                    if (client === socket) {
                        socket.emit('growl', 'You can\'t kick yourself!');
                        return;
                    }
                    if (client && client.user && client.user.isDev) {
                        socket.emit('growl', 'You can\'t kick a developer!');
                        return;
                    }

                    client.emit('growl', 'You were kicked by the team leader.');

                    /*
                    server.setClientTeam(client, null);
                    server.switchPlayer(client, null);
                    client.hasSpawned = false;
                    client.ready = false;
                    */
                    client.disconnect();

                    socket.emit('growl', client.name + ' was kicked from the team.');
                    server.sendLobbyUpdate();
                    console.info('Team leader "' + socket.name + '" kicked player "' + client.name + '" from their team.');
                } else {
                    socket.emit('growl', 'Invalid client.');
                }
            }
        });

        function getTeamQueenById(team, queenId) {
            for (let i=0; i<server.teamData[team].queens.length; i++) {
                let queen = server.teamData[team].queens[i];
                if (queen.id === queenId) {
                    return queen;
                }
            }
            return null;
        }

        socket.on('getQueenInfo', (queenId) => {
            if (queenId && socket.team !== null && socket.team !== undefined && server.teamData[socket.team].clients[0] === socket) {
                let queen = getTeamQueenById(socket.team, queenId);
                if (queen) {
                    server.openQueenMenu(queen);
                }
            }
        });

        socket.on('queueBrood', (data) => {
            if (data && data.queenId && data.type && socket.team !== null && socket.team !== undefined && server.teamData[socket.team].clients[0] === socket) {
                let queen = getTeamQueenById(socket.team, data.queenId);
                let typeData = server.broodTypes[data.type];
                if (queen && typeData) {
                    typeData = JSON.parse(JSON.stringify(typeData));
                    typeData.type = data.type;
                    queen.queueBrood(typeData);
                    server.openQueenMenu(queen);
                }
            }
        });

        socket.on('removeBrood', (data) => {
            if (data && data.queenId && data.index >= 0 && socket.team !== null && socket.team !== undefined && server.teamData[socket.team].clients[0] === socket) {
                let queen = getTeamQueenById(socket.team, data.queenId);
                if (queen && queen.broodQueue && queen.broodQueue[data.index]) {
                    queen.removeBroodQueueAtIndex(data.index);
                    server.openQueenMenu(queen);
                }
            }
        });

        socket.on('useSandboxTool', (tool) => {
            if (socket && socket.isSandbox) {
                console.info('Player has sandbox access:', socket.realAddress, socket.name, tool);
                if (tool.type === 'create') {
                    let ant = null;
                    switch (tool.data.entity) {
                        case 'Worker':
                            ant = server.createInsect('ant_worker', tool.pos.x, tool.pos.y, tool.pos.z, 65, 65, tool.data.team);
                            break;
                        case 'Soldier':
                            ant = server.createInsect('ant_worker', tool.pos.x, tool.pos.y, tool.pos.z, 80, 80, tool.data.team, {soldier: true});
                            break;
                        case 'Major':
                            ant = server.createInsect('ant_worker', tool.pos.x, tool.pos.y, tool.pos.z, 110, 110, tool.data.team, {soldier: true});
                            break;
                        case 'Acid':
                            ant = server.createInsect('ant_worker', tool.pos.x, tool.pos.y, tool.pos.z, 85, 105, tool.data.team);
                            break;
                        case 'Queen':
                            server.createInsect('ant_queen', tool.pos.x, tool.pos.y, tool.pos.z, 70, 70, tool.data.team, {newQueen: tool.pos.z === 0});
                            break;
                        case 'Bug':
                            if (Math.random() <= 0.5) {
                                server.createInsect('bug', tool.pos.x, tool.pos.y, tool.pos.z, 100, 100, -1);
                            } else {
                                server.createInsect('beetle', tool.pos.x, tool.pos.y, tool.pos.z, 145, 145, -1);
                            }
                            break;
                        case 'Spider':
                            server.createInsect('spider', tool.pos.x, tool.pos.y, tool.pos.z, 120, 120, -1);
                            break;
                        case 'Centipede':
                            let size = Math.round(80 + (Math.random() * 100));
                            server.createInsect('bug', tool.pos.x, tool.pos.y, tool.pos.z, size, size, -1, {
                                bugType: 'centipede',
                                centipedeType: 'head'
                            });
                            break;
                        case 'Aphid':
                            server.createObject('aphid', tool.pos.x, tool.pos.y, tool.pos.z, 45, 45, -1);
                            break;
                        case 'Food':
                            let addFoodCount = 3;
                            for (let i = 0; i < addFoodCount; i++) {
                                let angle = (Math.PI * 2) * Math.random();
                                let dist = 15 + (Math.random() * 50);
                                server.createObject('food', tool.pos.x + (Math.cos(angle) * dist), tool.pos.y + (Math.sin(angle) * dist), tool.pos.z, 45, 45, -1, {foodType: 'plant'});
                            }
                            break;
                        case 'Blue Food':
                            server.createObject('food', tool.pos.x, tool.pos.y, tool.pos.z, 45, 45, -1, {foodType: 'blue'});
                            break;
                        case 'Red Food':
                            server.createObject('food', tool.pos.x, tool.pos.y, tool.pos.z, 45, 45, -1, {foodType: 'red'});
                            break;
                        case 'Brood':
                            server.createObject('brood', tool.pos.x, tool.pos.y, tool.pos.z, 45, 45, -1);
                            break;
                        case 'Anthill':
                            if (tool.pos.z === 0 || tool.pos.z === 1) {
                                server.createObject('anthill', tool.pos.x, tool.pos.y, tool.pos.z, 200, 200, -1, {anthillSize: 0});
                            }
                            break;
                        case 'Rock':
                            if (tool.pos.z === 0) {
                                let rockSize = 400 + Math.round(Math.random() * 200);
                                server.createObject('rock', tool.pos.x, tool.pos.y, tool.pos.z, rockSize, rockSize, -1);
                            }
                            break;
                        case 'Plant':
                            if (tool.pos.z === 0) {
                                let plantSize = 110 + Math.round(Math.random() * 25);
                                server.createObject('plant', tool.pos.x, tool.pos.y, tool.pos.z, plantSize, plantSize, -1);
                            }
                            break;
                        default:
                            console.error('Spawn tool undefined entity:', tool.data.entity);
                            break;
                    }

                    if (ant) {
                        let queen = null;
                        if (server.teamData && server.teamData[ant.team] && server.teamData[ant.team].queens && server.teamData[ant.team].queens.length) {
                            queen = server.teamData[ant.team].queens[Math.floor(Math.random() * server.teamData[ant.team].queens.length)];
                        }
                        if (queen) {
                            ant.queen = queen;
                        }
                        ant.rotation = Math.random() * (Math.PI*2);
                    }
                } else if (tool.type === 'remove') {
                    let candidates = server.quadtrees[tool.pos.z].retrieve({x: tool.pos.x, y: tool.pos.y, width: 500, height: 500});
                    for (let i=0; i<candidates.length; i++) {
                        let entity = candidates[i];
                        if (entity.valid && entity.z === tool.pos.z && Math.distanceBetween(entity, tool.pos) < 20) {
                            entity.remove();
                            break;
                        }
                    }
                } else if (tool.type === 'terrain') {
                    if (tool.pos.z > 0) {
                        let tx = Math.floor(tool.pos.x/server.TILE_SIZE);
                        let ty = Math.floor(tool.pos.y/server.TILE_SIZE);
                        let tile = server.getTile(tx, ty);
                        if (tile) {
                            switch (tool.terrainType) {
                                case 'Empty':
                                    server.updateTile(tx, ty, 0, null);
                                    break;
                                case 'Dirt':
                                    server.updateTile(tx, ty, 1, null);
                                    break;
                                case 'Rock':
                                    server.updateTile(tx, ty, 2, null);
                                    break;
                                case '0% Moisture':
                                    server.updateTile(tx, ty, null, 0);
                                    break;
                                case '50% Moisture':
                                    server.updateTile(tx, ty, null, 0.5);
                                    break;
                                case '100% Moisture':
                                    server.updateTile(tx, ty, null, 1);
                                    break;
                                default:
                                    console.error('Terrain tool with unspecified terrain type:', tool.terrainType);
                                    break;
                            }

                            let tileServer = server.getTileServer(tx, ty);
                            if (tileServer) {
                                tileServer.usage = 0;
                            }
                        }
                    }
                } else if (tool.type === 'weather') {
                    server.setWeather(tool.value);
                } else if (tool.type === 'timestepChange') {
                    server.changeTimestep(tool.enabled);
                }
            } else {
                server.banClient(socket, 'Attempting to use sandbox tool.');
            }
        });

        socket.on('command', (command) => {
            if (socket.canControl && socket.player && socket.player.valid && socket.player.netData && socket.player.netData.alive) {
                if (command === '+5 Follow') {
                    let avail = server.getAvailableWorkers(socket.player);
                    let availCount = avail.length;
                    if (availCount > 5) {
                        availCount = 5;
                    }

                    for (let i = 0; i < availCount; i++) {
                        let entity = avail[i];
                        if (Math.distanceBetween(socket.player, entity) < 800 && socket.player.z === entity.z) {
                            if (!entity.leader) {
                                entity.setFollow(socket.player);
                            } else {
                                entity.setAIState('follow');
                            }
                        }
                    }
                } else if (command === '+1 Follow') {
                    let avail = server.getAvailableWorkers(socket.player);
                    for (let i = 0; i < avail.length; i++) {
                        let entity = avail[i];
                        if (entity.aiState !== 'follow') {
                            if (Math.distanceBetween(socket.player, entity) < 800 && socket.player.z === entity.z) {
                                if (!entity.leader) {
                                    entity.setFollow(socket.player);
                                } else {
                                    entity.setAIState('follow');
                                }
                                break;
                            }
                        }
                    }
                } else if (command === 'Dismiss') {
                    server.dismissFollowers(socket.player);
                } else if (command === 'Defend') {
                    server.setFollowerInstructions(socket, (entity, entities) => {
                        entity.setAIState('defend');
                        entity.defendTarget = {
                            x: socket.player.x,
                            y: socket.player.y,
                            z: socket.player.z
                        };
                        entity.defendRadius = 15 * entities.length;
                        if (entity.defendRadius < 50) {
                            entity.defendRadius = 50;
                        }
                        if (entity.defendRadius > 400) {
                            entity.defendRadius = 400;
                        }

                        entity.pathTo(entity.defendTarget, 35);
                    });
                } else if (command === 'Forage') {
                    server.setFollowerInstructions(socket, (entity) => {
                        entity.setAIState('idle');
                        entity.dataAI.role = 'forager';
                    });
                } else if (command === 'Stay Home') {
                    server.setFollowerInstructions(socket, (entity) => {
                        entity.setAIState('idle');
                        entity.dataAI.role = 'nurse';
                    });
                } else if (command === 'Stop Defend') {
                    let candidates = server.quadtrees[socket.player.z].retrieve({x: socket.player.x, y: socket.player.y, width: 1500, height: 1500});
                    for (let i=0; i<candidates.length; i++) {
                        let entity = candidates[i];
                        if (entity.isAI && entity.subtype === 'ant_worker' && entity.valid && entity.netData && entity.netData.alive && entity.team === socket.player.team && !entity.leader && entity.aiState === 'defend') {
                            entity.setFollow(socket.player);
                        }
                    }
                } else if (command === 'Attack') {
                    if (socket.player && socket.player.followers && socket.player.followers.length) {
                        let candidates = server.quadtrees[socket.player.z].retrieve({x: socket.player.x, y: socket.player.y, width: 1500, height: 1500});
                        let target = null;
                        let closestDist = 1000;
                        for (let i=0; i<candidates.length; i++) {
                            let entity = candidates[i];
                            let dist = Math.distanceBetween(socket.player, entity);
                            if (dist <= closestDist && entity.type === 'insect' && entity.valid && entity.netData && entity.netData.alive && entity.team !== socket.player.team) {
                                target = entity;
                                closestDist = dist;
                            }
                        }

                        if (target) {
                            for (let i = 0; i < socket.player.followers.length; i++) {
                                let follower = socket.player.followers[i];
                                follower.isAggro = true;
                                follower.moveToPos = {
                                    x: target.x + (-50 + Math.round(Math.random()*100)),
                                    y: target.y + (-50 + Math.round(Math.random()*100))
                                };
                            }
                        }

                        server.dismissFollowers(socket.player);
                    }
                } else if (command === 'Sandbox') {
                    if (socket.hasSandboxAccess) {
                        server.setPlayerSpectate(socket, true);
                    } else {
                        server.banClient(socket, 'Attempting to use sandbox tool.');
                    }
                }
            }
        });

        server.setFollowerInstructions = (socket, fn) => {
            if (socket.player.followers && socket.player.followers.length) {
                let ents = [];
                for (let i = 0; i < socket.player.followers.length; i++) {
                    let entity = socket.player.followers[i];
                    ents.push(entity);
                }
                server.dismissFollowers(socket.player);

                for (let i=0; i<ents.length; i++) {
                    let entity = ents[i];
                    fn(entity, ents);
                }
            }
        }

        function sendChatMessage(socket, message, isLocal) {
            let isDev = socket && socket.user && socket.user.isDev;

            let messageObject;
            if (message !== null && typeof message === 'object') {
                messageObject = message;
            } else {
                messageObject = {
                    message: message
                };
            }

            let messageEvent = {
                id: (isLocal && socket.player && socket.player.netData.alive) ? socket.player.id : null,
                userId: (socket && socket.user) ? socket.user.id : null,
                team: socket.team,
                name: socket ? socket.name : null,
                message: messageObject.message,
                xp: socket && socket.user && !isDev ? socket.user.xp : 0,
                isDev: isDev,
                date: new Date()
            };

            if (socket.canControl && socket.player && socket.player.netData.alive) {
                if (isLocal) {
                    messageObject.channel = 'local';
                }
            } else if (roundState.type === 'lobby') {
                messageObject.channel = 'lobby';
            }

            messageEvent.channel = messageObject.channel;
            console.info(server.serverId + ':' + (messageObject.channel ? messageObject.channel.toUpperCase() : 'GAME') + ' => ' + socket.name + ': ' + messageObject.message);
            switch (messageObject.channel) {
                case 'local':
                    if (socket.canControl && socket.player) {
                        server.sendLocalMessage(socket.player, 'chat', messageEvent);
                    }
                    break;
                case 'team':
                    server.sendTeamMessage(socket.team, 'chat', messageEvent);
                    break;
                default:
                    server.sendMessage('chat', messageEvent);
                    break;
            }

            socket.recentMessages.push({
                date: new Date(),
                name: socket.name,
                message: messageObject.message
            });
            if (socket.recentMessages.length > 10) {
                socket.recentMessages.shift();
            }
        }

        /*
        AntWar.io Game Commands
        =======================================================================================
        /banip {ip} - Ban an IP
        /ban {name} - Ban a player
        /kick {name} - Kick a player
        /slay {name} - Slay a player
        /spider - Become a spider
        /centipede - Become a centipede
        /changez - Change your Z level.
        /kill - Kill yourself.
        /toggleai - Toggle AI on all teams.
        /spectate {name} - Switch a player to a spectator. Leave blank to switch yourself.
        /sandbox {name} - Switch a player to sandbox. Leave blank to switch yourself.
        /spawn {queen, spider, centipede, bug} - Spawn one of these.
        /weather {clear, rain, thunderstorm} - Set the current weather.
        /season {spring, summer, fall, winter} - Set the current season.
        /reviveteam {team number 0 - 7} - Revive a team.
        /forcestart - Force a game in the lobby to start.
        /timestep {number 0 - 1} - Set server timestep speed.
        /gamemode {normal, coop, endless} - Switch gamemode.
        /yearend - Triggers the end of the year.
        /crash - Triggers an error and simulates a crash.
        /message - Sends a global message.
        /stopserver - Stops the server.
        /hungry - Make yourself hungry.
        =======================================================================================
         */
        let lastChatMessage = Date.now();
        socket.on('chat', (data) => {
            if (Date.now()-lastChatMessage <= 600) {
                return;
            }
            lastChatMessage = Date.now();
            socket.lastAction = Date.now();

            let message = data;
            let isLocal = false;
            let channel = null;
            if (data && typeof data === 'object') {
                message = data.message;
                isLocal = data.local;
                channel = data.channel;
            }

            let messageLimit = 500;
            if (isLocal) {
                messageLimit = 64;
            }

            if (!message || (typeof message !== 'string' && !message instanceof String)) {
                return;
            }

            if (message.length >= messageLimit+50) {
                server.banClient(socket, 'Banned for spamming chat.');
                return;
            }

            if (message && message.length && message.length <= messageLimit && message.startsWith) {
                if (message.startsWith('/') && socket.user && socket.user.isDev) {
                    if (message.startsWith('/banip')) {
                        let ipAddress = message.replace('/banip', '').trim();
                        console.info(socket.realAddress + ': Banned IP:', ipAddress);
                        if (!gameMaster.banList) {
                            gameMaster.banList = [];
                        }
                        gameMaster.banList.push(ipAddress);
                    } else if (message.startsWith('/ban')) {
                        let name = message.replace('/ban', '').trim();
                        let client = server.getClientByName(name);
                        if (client) {
                            server.banClient(client, 'Banned by admin.');
                        } else {
                            socket.emit('growl', 'Player with name "' + name + '" not found.');
                        }
                    } else if (message.startsWith('/kick')) {
                        let name = message.replace('/kick', '').trim();
                        let client = server.getClientByName(name);
                        if (client) {
                            console.info(socket.realAddress + ': Kicked player:', client.name, client.realAddress);
                            server.sendMessage('growl', 'Player "' + name + '" has been kicked.');
                            client.disconnect();
                        } else {
                            socket.emit('growl', 'Player with name "' + name + '" not found.');
                        }
                    } else if (message.startsWith('/slay')) {
                        let name = message.replace('/slay', '').trim();
                        let client = server.getClientByName(name);
                        if (client && client.player && client.player.valid && client.player.netData.alive) {
                            console.info(socket.realAddress + ': Slayed player:', client.name, client.realAddress);
                            server.sendMessage('growl', 'Player "' + name + '" has been slain.');
                            client.player.kill();
                        } else {
                            socket.emit('growl', 'Player with name "' + name + '" not found.');
                        }
                    } else if (message.startsWith('/spider')) {
                        let spider = null;
                        for (let i=0; i<server.entities.length; i++) {
                            let entity = server.entities[i];
                            if (entity && entity.valid && entity !== socket.player && entity.netData.alive && entity.subtype === 'spider') {
                                spider = entity;
                                break;
                            }
                        }

                        if (spider) {
                            server.switchPlayer(socket, spider);
                        } else {
                            socket.emit('growl', 'No spiders found.');
                        }
                    } else if (message.startsWith('/centipede')) {
                        let centipede = null;
                        for (let i=0; i<server.entities.length; i++) {
                            let entity = server.entities[i];
                            if (entity && entity.valid && entity !== socket.player && entity.netData.alive && entity.subtype === 'bug' && entity.netData && entity.netData.bugType === 'centipede' && entity.netData.centipedeType === 'head') {
                                centipede = entity;
                                break;
                            }
                        }

                        if (centipede) {
                            server.switchPlayer(socket, centipede);
                        } else {
                            socket.emit('growl', 'No centipedes found.');
                        }
                    } else if (message.startsWith('/changez')) {
                        if (socket.player && socket.player.netData.alive) {
                            if (socket.player.z === 0) {
                                socket.player.z = 1;
                            } else {
                                socket.player.z = 0;
                            }

                            if (socket.player.z === 1) {
                                let tx = Math.floor(socket.player.x/server.TILE_SIZE);
                                let ty = Math.floor(socket.player.y/server.TILE_SIZE);
                                let tile = server.getTile(tx, ty)[0];

                                if (tile) {
                                    server.updateTile(tx, ty, 0);
                                }
                            }
                        }
                    } else if (message.startsWith('/kill')) {
                        if (socket.player && socket.player.netData.alive) {
                            socket.player.damage(1000);
                        }
                    } else if (message.startsWith('/crash')) {
                        throw new Error('This is a fake error triggered with a command.');
                    }  else if (message.startsWith('/stresstest')) {
                        for (let t=0; t<8; t++) {
                            for (let i = 0; i < 50; i++) {
                                server.createInsect('ant_worker', 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600)), 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600)), 0, 65, 65, t);
                            }
                        }
                    } else if (message.startsWith('/toggleai')) {
                        let teams = Object.keys(server.teamData);
                        for (let i=0; i<teams.length; i++) {
                            let team = server.teamData[teams[i]];
                            team.isAI = !team.isAI;
                        }
                        server.sendMessage('growl', 'AI has been toggled.');
                    } else if (message.startsWith('/spectate')) {
                        let name = message.replace('/spectate', '').trim();
                        if (name) {
                            let client = server.getClientByName(name);
                            if (client) {
                                server.setPlayerSpectate(client);
                            } else {
                                socket.emit('growl', 'Player with name "' + name + '" not found.');
                            }
                        } else {
                            server.setPlayerSpectate(socket);
                        }
                    } else if (message.startsWith('/yearend')) {
                        server.performYearEnd();
                    } else if (message.startsWith('/sandbox')) {
                        let name = message.replace('/sandbox', '').trim();
                        if (name) {
                            let client = server.getClientByName(name);
                            if (client) {
                                server.setPlayerSpectate(client, true);
                            } else {
                                socket.emit('growl', 'Player with name "' + name + '" not found.');
                            }
                        } else {
                            server.setPlayerSpectate(socket, true);
                        }
                    } else if (message.startsWith('/weather')) {
                        let type = message.replace('/weather', '').trim();
                        if (!type) {
                            type = 'clear';
                        }
                        server.setWeather(type);
                    } else if (message.startsWith('/season')) {
                        let type = message.replace('/season', '').trim();
                        let seasonData = server.getSeasonData(type);
                        if (seasonData) {
                            server.updateSeason({
                                type: type
                            });
                        } else {
                            socket.emit('growl', 'Invalid season.');
                        }
                    } else if (message.startsWith('/spawn')) {
                        if (socket.player && socket.player.valid && socket.player.netData.alive) {
                            let params = message.replace('/spawn', '').trim().split(' ');
                            if (params && params.length >= 1) {
                                try {
                                    if (params[0] === 'queen') {
                                        let queen = server.createInsect('ant_queen', socket.player.x + Math.random(), socket.player.y + Math.random(), socket.player.z, 70, 70, socket.player.team);
                                        queen.anthill = server.teamData[socket.team].anthill;
                                        server.switchPlayer(socket, queen);
                                    } else if (params[0] === 'spider') {
                                        let pos = server.getEdgePosition();
                                        server.createInsect('spider', pos.x, pos.y, 0, 120, 120, -1);
                                    } else if (params[0] === 'centipede') {
                                        let size = Math.round(80 + (Math.random() * 100));
                                        let pos = server.getEdgePosition();
                                        server.createInsect('bug', pos.x, pos.y, 0, size, size, -1, {
                                            bugType: 'centipede',
                                            centipedeType: 'head'
                                        });
                                    } else if (params[0] === 'bug') {
                                        let pos = server.getEdgePosition();
                                        if (Math.random() <= 0.5) {
                                            server.createInsect('bug', pos.x, pos.y, 0, 100, 100, -1);
                                        } else {
                                            server.createInsect('beetle', pos.x, pos.y, 0, 145, 145, -1);
                                        }
                                    }
                                } catch(e) {
                                    socket.emit('growl', 'Failed to use spawn command.');
                                }
                            } else {
                                socket.emit('growl', 'Invalid spawn parameters.');
                            }
                        }
                    } else if (message.startsWith('/reviveteam')) {
                        let params = message.replace('/reviveteam', '').trim().split(' ');
                        if (params && params.length >= 1) {
                            try {
                                let teamId = parseInt(params[0]);
                                server.teamData[teamId].dead = false;
                                server.teamData[teamId].queen = null;
                                socket.emit('growl', 'Team ' + server.getTeamString(teamId) + ' has been revived.');
                            } catch (e) {
                                socket.emit('growl', 'Failed to use spawn command.');
                            }
                        }
                    } else if (message.startsWith('/timestep')) {
                        let params = message.replace('/timestep', '').trim().split(' ');
                        if (params && params.length >= 1) {
                            try {
                                server.changeTimestep(params[0] == '1');
                                socket.emit('growl', 'Timestep updated: ' + params[0]);
                            } catch (e) {
                                socket.emit('growl', 'Failed to use timestep command.');
                            }
                        }
                    } else if (message.startsWith('/hungry')) {
                        if (socket && socket.player && socket.player.valid && socket.player.netData) {
                            socket.player.energy = 40;
                        }
                    } else if (message.startsWith('/forcestart')) {
                        if (roundState.type === 'lobby') {
                            server.startRound();
                            server.sendMessage('growl', 'Round force started.');
                        }
                    } else if (message.startsWith('/forceend')) {
                        if (roundState.type === 'playing') {
                            server.endGame();
                            server.sendMessage('growl', 'Round force ended.');
                        }
                    } else if (message.startsWith('/gamemode')) {
                        let name = message.replace('/gamemode', '').trim();
                        server.updateGamemode(name);
                        server.sendMessage('growl', 'Gamemode updated: ' + name);
                    } else if (message.startsWith('/message')) {
                        let serverMessage = message.replace('/message', '').trim();
                        server.sendMessage('growl', serverMessage);
                    } else if (message.startsWith('/stopserver')) {
                        server.sendMessage('growl', 'Server stopped.');
                        server.stopServer();
                    }
                } else {
                    sendChatMessage(socket, {
                        channel: channel,
                        message: message
                    }, isLocal);
                }
            }
        });

        socket.emit('tileData', tiles);

        let entityDataToSend = [];
        server.entities.forEach((entity) => {
            if (config.isSingleplayer || entity.static) {
                entityDataToSend.push(entity.getCreateData());
            }
        });
        socket.emit('createEntity', entityDataToSend);

        socket.emit('updateNight', {
            night: night,
            force: true
        });

        socket.emit('updateWeather', server.currentWeather);
        let season = JSON.parse(JSON.stringify(server.currentSeason));
        season.forceUpdate = true;
        socket.emit('updateSeason', season);

        server.sendLobbyUpdate();

        server.sendMessage('chat', {
            message: socket.name + ' has joined the game.'
        });
    };

    server.setPlayerNoControl = (socket, entity) => {
        socket.player = entity;
        socket.canControl = false;
        socket.emit('setPlayer', {
            id: socket.player.id,
            canControl: false
        });
    };

    server.setPlayerSpectate = (player, enableSandbox) => {
        player.hasSpawned = true;
        player.spectating = true;
        player.isSandbox = config.isSandbox || enableSandbox;
        if (!config.isSingleplayer && player.isSandbox) {
            console.info('Player has sandbox access:', player.realAddress, player.name);
        }
        let oldPlayer = player.player;
        server.switchPlayer(player, null);
        player.player = {
            valid: true,
            x: 0,
            y: 0,
            z: 0,
            netData: {}
        };
        if (oldPlayer) {
            player.player.x = oldPlayer.x;
            player.player.y = oldPlayer.y;
            player.player.z = oldPlayer.z;
        }
        player.emit('setPlayer', {
            spectator: true,
            isSandbox: player.isSandbox
        });

        if (player.isSandbox) {
            player.hasSandboxAccess = true;
        }

        if (config.isSingleplayer || config.enableAi) {
            if (server.teamData[player.team]) {
                server.teamData[player.team].isAI = true;
            }
        }

        server.setClientTeam(player, null);
    };

    server.getTeamString = (team) => {
        if (team === 0) {
            return 'BLACK';
        } else if (team === 1) {
            return 'RED';
        } else if (team === 2) {
            return 'GREEN';
        } else if (team === 3) {
            return 'BLUE';
        } else if (team === 4) {
            return 'YELLOW';
        } else if (team === 5) {
            return 'ORANGE';
        } else if (team === 6) {
            return 'PINK';
        } else if (team === 7) {
            return 'CYAN';
        }
        return 'NONE';
    };

    server.banClient = (client, note) => {
        if (client) {
            console.info('Banned player:', client.name, client.realAddress, note);
            server.sendMessage('growl', 'Player "' + client.name + '" has been banned.');
            if (!gameMaster.banList) {
                gameMaster.banList = [];
            }
            gameMaster.banList.push(client.realAddress);
            client.disconnect();
        } else {
            console.error('Attempted to ban invalid client.');
        }
    };

    server.setClientTeam = (socket, team) => {
        if (socket.team !== null && socket.team !== undefined && server.teamData[socket.team]) {
            for (let i=0; i<server.teamData[socket.team].clients.length; i++) {
                let client = server.teamData[socket.team].clients[i];
                if (client === socket) {
                    server.teamData[socket.team].clients.splice(i, 1);
                    break;
                }
            }

            if (server.teamData[socket.team].clients.length <= 0) {
                server.teamData[socket.team].locked = false;
            }
        }

        socket.team = team;

        if (socket.team !== null && socket.team !== undefined && server.teamData[socket.team]) {
            server.teamData[socket.team].clients.push(socket);
        }

        let teamInfo = null;
        if (server.teamData[socket.team] && server.teamData[socket.team].teamInfo) {
            teamInfo = JSON.parse(JSON.stringify(server.teamData[socket.team].teamInfo));
            teamInfo.isLeader = server.teamData[team].clients[0] === socket;
        }
        socket.emit('teamInfo', teamInfo);
    };

    server.sendTeamMessage = (team, name, data, clientFn) => {
        if (server.teamData[team]) {
            for (let i=0; i<server.teamData[team].clients.length; i++) {
                let client = server.teamData[team].clients[i];
                let clientData = data
                if (clientFn) {
                    clientData = JSON.parse(JSON.stringify(data));
                    clientFn(client, clientData);
                }
                client.emit(name, clientData);
            }
        }
    };

    server.updateTeamInfo = (team) => {
        if (server.teamData[team]) {
            let info = {
                id: team,
                queens: [],
                queenHungry: false
            };
            for (let i = 0; i < server.teamData[team].queens.length; i++) {
                let queen = server.teamData[team].queens[i];
                if (queen && queen.netData && !queen.netData.newQueen) {
                    info.queens.push(queen.id);
                    if (queen.netData.hungry) {
                        info.queenHungry = true;
                    }
                }

                if (i === 0 && queen.anthill) {
                    info.anthillPos = {
                        x: queen.anthill.x,
                        y: queen.anthill.y
                    }
                }
            }
            server.teamData[team].teamInfo = info;

            server.sendTeamMessage(team, 'teamInfo', server.teamData[team].teamInfo, (client, data) => {
                data.isLeader = server.teamData[team].clients[0] === client;
            });
        }
    };

    server.recordXP = (entity, xp, type) => {
        if (entity && xp) {
            let team = server.teamData[entity.team];
            if (team && !team.dead) {
                if (!config.isSandbox) {
                    for (let i = 0; i < team.clients.length; i++) {
                        let client = team.clients[i];

                        if (client.ready) {
                            client.unawardedXP += Math.round(xp);
                            client.emit('xpfeed', {
                                xp: Math.round(xp),
                                type: type
                            });
                        }
                    }
                }

                if (!team.stats[type]) {
                    team.stats[type] = 0;
                }
                team.stats[type]++;
            }
        }
    };

    server.joinSmallestTeam = (socket, atRoundStart) => {
        let teams = Object.keys(server.teamData);
        if (teams.length) {
            let teamLength = Object.keys(server.teamData).length;
            let lowestTeam = null;
            let lowestPlayers = 1000;
            for (let i=0; i<teamLength; i++) {
                let team = server.teamData[i];
                if (!team.locked && !team.dead && team.clients.length < lowestPlayers && (atRoundStart || (team.queen && team.queen.valid && team.queen.netData.alive))) {
                    lowestTeam = team.id;
                    lowestPlayers = team.clients.length;
                }
            }

            if (lowestTeam !== null) {
                server.setClientTeam(socket, lowestTeam);
                if (!atRoundStart) {
                    socket.emit('setPlayer', {
                        id: server.teamData[socket.team].queen.id,
                        canControl: false
                    });
                    socket.emit('showMenu', null);

                    if (server.teamData[socket.team] && server.teamData[socket.team].spawnQueue) {
                        server.addClientToSpawnQueue(socket);
                    } else {
                        console.error('Disconnect client because invalid socket team.');
                        socket.disconnect();
                    }
                }
            }
        }
    };

    server.addClientToSpawnQueue = (client) => {
        if (config.isSandbox) {
            server.setPlayerSpectate(client);
        } else if ((!client.player || (client.player && !client.player.valid) || !client.canControl) && server.teamData[client.team]) {
            client.hasSpawned = true;
            client.ready = true;
            if (server.teamData[client.team].spawnQueue.indexOf(client) === -1) {
                client.emit('setPlayer', {
                    id: (server.teamData[client.team] && server.teamData[client.team].queen) ? server.teamData[client.team].queen.id : null,
                    canControl: false
                });
                server.teamData[client.team].spawnQueue.push(client);
            }
        }
    };

    server.createTeamQueen = (teamId, client, spawnAngle) => {
        let pos = server.getPositionAwayFromEdge(1000);
        if (process.env.NODE_ENV === 'local' || server.gamemode.type === 'coop') {
            pos.x = (server.MAP_SIZE * server.TILE_SIZE)/2 + Math.random();
            pos.y = (server.MAP_SIZE * server.TILE_SIZE)/2 + Math.random();
        } else if (spawnAngle !== undefined && spawnAngle !== null) {
            pos.x = ((server.MAP_SIZE * server.TILE_SIZE)/2) + (Math.cos(spawnAngle) * 2000);
            pos.y = ((server.MAP_SIZE * server.TILE_SIZE)/2) + (Math.sin(spawnAngle) * 2000);
        }

        let queen = server.createInsect('ant_queen', pos.x, pos.y, -1, 70, 70, teamId, {newQueen: true, flying: true});
        queen.rotation = Math.random() * (Math.PI*2);
        if (client) {
            client.hasSpawned = true;
            server.switchPlayer(client, queen);
        } else {
            queen.isAI = true;
        }

        if (server.teamData[teamId]) {
            server.teamData[teamId].nestCreationTime = server.getModifiedTime();
        }

        return queen;
    };

    function shuffle(array) {
        let currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    let plants = [];
    server.startRound = () => {
        server.updateRoundState({
            type: 'playing'
        });

        server.resetEnvironment();

        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            if (client.team === null || client.team === undefined) {
                server.joinSmallestTeam(client, true);
            }
        }

        let teamLength = Object.keys(server.teamData).length;
        if ((config.isSingleplayer || config.enableAi) && !config.isTutorial) {
            for (let i = 0; i < teamLength; i++) {
                let team = server.teamData[i];
                if (i > 0) {
                    team.isAI = true;
                }
            }
        }

        let teamCount = 0;
        for (let i=0; i<teamLength; i++) {
            let team = server.teamData[i];
            if (team.clients.length > 0 || team.isAI) {
                teamCount++;
            }
        }

        if (teamCount <= 1 && server.gamemode.type !== 'coop') {
            for (let i=0; i<Math.floor(server.clients.length/2); i++) {
                let client = server.clients[i];
                if (client) {
                    server.joinSmallestTeam(client, true);
                }
            }

            if (!config.skipGameLobby) {
                server.sendMessage('growl', 'Teams have been balanced.');
            }
        }

        if (!config.isSandbox) {
            let teamCountForRadius = 0;
            for (let i = 0; i < teamLength; i++) {
                let team = server.teamData[i];
                if (team.clients.length > 0 || team.isAI) {
                    teamCountForRadius++;
                }
            }

            let spawnAngles = [];
            for (let i = 0; i < teamCountForRadius; i++) {
                spawnAngles.push(((Math.PI * 2) / teamCountForRadius) * i);
            }
            spawnAngles = shuffle(spawnAngles);

            let spawnAngleOffset = Math.random() * (Math.PI * 2);
            for (let i = 0; i < teamLength; i++) {
                let team = server.teamData[i];
                if (team && team.clients && (team.clients.length || team.isAI)) {
                    let client = team.clients[0];
                    if (!client) {
                        client = team.clients[parseInt((team.clients.length - 1) * Math.random())];
                    }

                    if (client || team.isAI) {
                        let angle = Math.random() * (Math.PI * 2);
                        if (spawnAngles && spawnAngles.length) {
                            angle = spawnAngles.shift();
                        }
                        server.createTeamQueen(team.id, client, spawnAngleOffset + angle);
                    }
                }
            }
        }

        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            client.lastAction = Date.now();
            server.addClientToSpawnQueue(client);
        }

        server.roundStartTime = Date.now();

        server.sendLobbyUpdate();

        server.resetEnvironment();
    };

    server.getRoundState = () => {
        return roundState;
    };

    server.updateRoundState = (newRoundState) => {
        roundState = newRoundState;
    };

    server.sendLobbyUpdate = () => {
        let lobbyData = server.getLobbyData();
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            if (!client.hasSpawned) {
                lobbyData.clientId = client.clientId;
                client.emit('showMenu', lobbyData);
            } else {
                client.emit('showMenu', null);
            }

            if (!client.player && client.ready && client.team !== null && client.team !== undefined && server.teamData[client.team]) {
                if (server.teamData[client.team].queens && server.teamData[client.team].queens[0]){
                    server.setPlayerNoControl(client, server.teamData[client.team].queens[0])
                } else if (server.teamData[client.team].clients) {
                    for (let j=0; j<server.teamData[client.team].clients.length; j++) {
                        let otherClient = server.teamData[client.team].clients[j];
                        if (otherClient.canControl && otherClient.player && otherClient.player.valid) {
                            server.setPlayerNoControl(client, otherClient.player);
                        }
                    }
                }
            }
        }
    };

    server.getScoreboardData = () => {
        let data = {
            menu: 'scoreboard',
            teams: [],
            players: [],
            gamemode: server.gamemode.type,
            shareLinkToken: server.getFullInviteToken()
        };

        let teams = Object.keys(server.teamData);
        for (let i=0; i<teams.length; i++) {
            let team = server.teamData[i];
            data.teams.push({
                id: team.id,
                name: server.getTeamString(team.id),
                players: team.clients.length,
                score: team.score,
                maxPlayers: MAX_TEAM_PLAYERS,
                locked: team.locked || team.dead,
                dead: team.dead
            });
        }

        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            data.players.push({
                clientId: client.clientId,
                name: client.name,
                score: client.score,
                team: client.team,
                isTeamLeader: client.team !== null && client.team !== undefined && server.teamData[client.team] && server.teamData[client.team].clients && server.teamData[client.team].clients[0] === client,
                xp: client.user ? client.user.xp : 0
            });
        }

        return data;
    };

    let minPlayersForRoundStart = 2;
    if (process.env.NODE_ENV === 'local') {
        minPlayersForRoundStart = 1;
    }
    server.getLobbyData = () => {
        if (roundState.type === 'lobby') {
            if (server.clients.length <= 1) {
                if (roundState.endTime) {
                    delete roundState.endTime;
                }
            } else {
                if (!roundState.endTime) {
                    roundState.endTime = Date.now() + LOBBY_WAIT_TIME;
                }
            }
        }

        let data = {
            menu: 'lobby',
            state: roundState ? roundState.type : null,
            gamemode: server.gamemode.type,
            privateGame: tokenRequestData.privateGame,
            startTimer: roundState.endTime ? roundState.endTime - Date.now() : null,
            shareLinkToken: server.getFullInviteToken(),
            teams: [],
            players: []
        };

        let teams = Object.keys(server.teamData);
        for (let i=0; i<teams.length; i++) {
            let team = server.teamData[i];
            data.teams.push({
                id: team.id,
                name: server.getTeamString(team.id),
                players: team.clients.length,
                maxPlayers: MAX_TEAM_PLAYERS,
                locked: team.locked || team.dead,
                dead: team.dead,
                score: team.score
            });
        }

        let allClientsReady = true;
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            let playerData = {
                clientId: client.clientId,
                name: client.name,
                team: client.team,
                ready: client.ready,
                xp: client.user ? client.user.xp : 0,
                isTeamLeader: client.team !== null && client.team !== undefined && server.teamData[client.team] && server.teamData[client.team].clients && server.teamData[client.team].clients[0] === client,
                canLock: false
            };
            if (playerData.isTeamLeader) {
                //playerData.canLock = client.team >= 2;
                playerData.canLock = true;
            }
            data.players.push(playerData);

            if (!client.ready) {
                allClientsReady = false;
            }
        }

        if (roundState.type === 'lobby' && server.clients.length >= minPlayersForRoundStart && allClientsReady) {
            server.startRound();
        }

        return data;
    };

    server.getClientByName = (name) => {
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            if (client.name === name) {
                return client;
            }
        }

        return null;
    };

    server.getClientById = (clientId) => {
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            if (client.clientId === clientId) {
                return client;
            }
        }

        return null;
    };

    server.dismissFollowers = (leader, returnToNest) => {
        if (leader.followers) {
            for (let i = 0; i < leader.followers.length; i++) {
                let entity = leader.followers[i];
                entity.setFollow(null);
                entity.isAggro = true;

                if (returnToNest && entity.queen && entity.queen.anthill) {
                    entity.pathTo({
                        x: entity.queen.anthill.x,
                        y: entity.queen.anthill.y,
                        z: 1,
                        returningHome: true
                    }, 35, true);
                }
            }
            leader.followers = [];
        }
    };

    server.switchPlayer = (socket, entity) => {
        if (socket.player && socket.canControl) {
            socket.player.netData.name = null;
            socket.player.netData.isDev = false;
            socket.player.netData.settings = null;
            socket.player.isAI = true;
            socket.player.currentPlayer = null;
            server.dismissFollowers(socket.player);
        }

        if (entity && entity.team !== socket.team) {
            server.setClientTeam(socket, entity.team);
        }

        socket.player = entity;
        if (socket.player) {
            socket.player.griefCount = 0;
            socket.player.netData.isDev = socket.user && socket.user.isDev;
            socket.player.netData.settings = (socket.user && socket.user.settings) ? socket.user.settings : null;
            socket.player.netData.name = socket.name;
            socket.player.isAI = false;
            socket.player.currentPlayer = socket;
            socket.canControl = true;
            socket.ready = true;
            socket.lastSpectatedIndex = -1;
            socket.emit('setPlayer', {
                id: socket.player.id,
                canControl: true
            });
        }
    };

    server.killTeam = (teamId)=> {
        let team = server.teamData[teamId];
        if (!team.dead) {
            team.dead = true;
            let lastDeadTime = team.deadTime;
            team.deadTime = Date.now();
            for (let i = 0; i < server.entities.length; i++) {
                let entity = server.entities[i];
                if (entity.team === teamId && (entity.type === 'insect' || (entity.subtype === 'brood' && entity.freeBrood))) {
                    if (entity.kill) {
                        entity.kill();
                    } else {
                        entity.remove();
                    }
                }
            }

            if (server.gamemode.type === 'endless') {
                if (!team.respawnTime) {
                    team.respawnTime = 30;
                }

                if (lastDeadTime && Date.now()-lastDeadTime <= 60000) {
                    team.respawnTime *= 4;
                } else {
                    team.respawnTime = 30;
                }

                if (team.respawnTime >= 5*60*1000) {
                    team.respawnTime = 5*60*1000;
                }

                for (let i=0; i<team.clients.length; i++) {
                    let client = team.clients[i];
                    client.emit('chat', {
                        message: 'Your team died, your queen will respawn in ' + team.respawnTime + ' seconds.'
                    });
                }
            } else {
                if (server.currentYear === 1 && server.currentSeason.type === 'spring') {
                    team.respawnTime = 60;
                }

                let awardData = [];
                let rewardTime = Date.now();
                for (let i = 0; i < server.clients.length; i++) {
                    let client = server.clients[i];
                    if (client.team === teamId) {
                        let xp = Math.round(client.unawardedXP);
                        if (!xp || xp < 0) {
                            xp = 0;
                        }
                        let coins = 5;

                        if (client.playStartTime) {
                            let multiplier = Math.abs(rewardTime - client.playStartTime) / 1000;
                            multiplier = multiplier / 60;
                            multiplier = Math.abs(multiplier);
                            if (multiplier > 20) {
                                multiplier = 20;
                            }

                            xp += Math.round(multiplier * 15);
                            coins += Math.round(multiplier);
                        }

                        if (tokenRequestData.privateGame || config.isSingleplayer) {
                            xp = 0;
                            coins = 0;
                        }

                        //Disable coins for now.
                        coins = 0;

                        if (!client.spectating) {
                            client.emit('roundEnd', {
                                message: 'YOUR QUEEN WAS KILLED OR STARVED',
                                awards: {
                                    xp: xp,
                                    coins: coins
                                },
                                lastXp: client.user ? client.user.xp : 0,
                                isUser: client.user && client.user.session,
                                stats: team.stats
                            });

                            if (client.user && client.user.session && (xp > 0 || coins > 0)) {
                                client.user.xp += xp;
                                awardData.push({
                                    session: client.user.session,
                                    xp: xp,
                                    coins: coins
                                });
                            }
                        }

                        client.unawardedXP = 0;
                    }
                }

                if (awardData && awardData.length) {
                    sendMasterMessage('awardUsers', awardData);
                }
            }
        }
    };

    server.endGame = () => {
        if (gameEnded || config.isSandbox) {
            return;
        }
        if (server.gamemode.type === 'endless') {
            return;
        }

        let teams = Object.keys(server.teamData);
        let aliveTeam = null;
        for (let i=0; i<teams.length; i++) {
            let team = server.teamData[i];
            if (team.queen && team.queen.valid && team.queen.netData.alive) {
                aliveTeam = team.id;
                break;
            }
        }

        gameEnded = true;
        if (aliveTeam !== null) {
            let teamString = server.getTeamString(aliveTeam);

            let awardData = [];
            let endMessage = teamString + ' TEAM WINS';
            console.info(server.serverId + ':Game Ended -', endMessage);
            let rewardTime = Date.now();
            for (let i=0; i<server.clients.length; i++) {
                let client = server.clients[i];
                let xp = Math.round(client.unawardedXP);
                if (!xp || xp < 0) {
                    xp = 0;
                }
                let coins = 10;
                client.isWinner = client.team === aliveTeam;
                if (client.isWinner) {
                    xp += 350;
                    coins = 25;
                }

                if (client.playStartTime) {
                    let multiplier = Math.abs(rewardTime - client.playStartTime)/1000;
                    multiplier = multiplier/60;
                    multiplier = Math.abs(multiplier);
                    if (multiplier > 20) {
                        multiplier = 20;
                    }

                    if (client.isWinner) {
                        xp += Math.round(multiplier * 30);
                        coins += Math.round(multiplier * 4);
                    } else {
                        xp += Math.round(multiplier * 15);
                        coins += Math.round(multiplier * 2);
                    }
                }

                if (tokenRequestData.privateGame || config.isSingleplayer) {
                    xp = 0;
                    coins = 0;
                }

                //Disable coins for now.
                coins = 0;

                let stats = null;
                if (server.teamData[client.team]) {
                    stats = server.teamData[client.team].stats;
                }

                client.emit('roundEnd', {
                    roundActuallyEnded: true,
                    message: endMessage,
                    awards: {
                        xp: xp,
                        coins: coins
                    },
                    lastXp: client.user ? client.user.xp : 0,
                    isUser: client.user && client.user.session,
                    stats: stats
                });

                client.unawardedXP = 0;

                if (client.user && client.user.session && (xp > 0 || coins > 0)) {
                    client.user.xp += xp;
                    awardData.push({
                        session: client.user.session,
                        xp: xp,
                        coins: coins
                    });
                }
            }

            let team = server.teamData[aliveTeam];
            let leader = team.clients[0];
            for (let i=0; i<server.entities.length; i++) {
                let entity = server.entities[i];
                entity.remove();
            }

            if (leader) {
                let right = false;
                let yinc = 1;
                let dist = 64;
                for (let i=0; i<team.clients.length; i++) {
                    let client = team.clients[i];

                    let offx = 0;
                    let offy = 0;
                    if (team.clients.length <= 4) {
                        if (i === 1) {
                            offx = -dist;
                            offy = dist;
                        } else if (i === 2) {
                            offx = dist;
                            offy = dist;
                        } else if (i === 3) {
                            offx = 0;
                            offy = dist*2;
                        }
                    } else {
                        if (i > 0) {
                            offy = dist * yinc;
                            if (right) {
                                offx = dist * i;
                                right = false;
                                yinc++;
                            } else {
                                offx = -dist * i;
                                right = true;
                            }
                        }
                    }
                    let newPlayer = server.createInsect('ant_worker', (server.MAP_SIZE * server.TILE_SIZE)/2 + offx, (server.MAP_SIZE * server.TILE_SIZE)/2 + offy, 0, 65, 65, aliveTeam);
                    server.switchPlayer(client, newPlayer);
                }

                for (let i=0; i<server.clients.length; i++) {
                    let client = server.clients[i];
                    server.setPlayerNoControl(client, leader.player);
                }
            }

            if (awardData && awardData.length) {
                sendMasterMessage('awardUsers', awardData);
            }
        } else {
            console.info(server.serverId + ':Game Ended - DRAW');
            for (let i=0; i<server.clients.length; i++) {
                let client = server.clients[i];
                client.isWinner = false;
                client.emit('roundEnd', {
                    roundActuallyEnded: true,
                    message: 'ALL QUEENS ARE DEAD',
                    isUser: client.user && client.user.session
                });
            }
        }

        setTimeout(() => {
            server.resetGame();
        }, 16000);
    };

    server.onClientDisconnected = (socket) => {
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            if (client.id === socket.id) {
                server.clients.splice(i, 1);
                break;
            }
        }

        socket.connected = false;
        if (socket.player && socket.player.valid) {
            server.switchPlayer(socket, null);
        }

        let lastTeam = socket.team;

        server.setClientTeam(socket, null);

        server.updateTeamInfo(lastTeam);

        if (roundState.type === 'lobby') {
            server.sendLobbyUpdate();
        }

        server.sendMessage('chat', {
            message: socket.name + ' has left the game.'
        });

        if (server.clients.length <= 0) {
            server.running = false;
        }
    };

    server.getTile = (tx, ty) => {
        if (tx >= 0 && ty >= 0 && tx < server.MAP_SIZE && ty < server.MAP_SIZE) {
            return tiles[ty][tx];
        } else {
            return [1, 0, 0];
        }
    };

    server.getTileOrNull = (tx, ty) => {
        if (tx >= 0 && ty >= 0 && tx < server.MAP_SIZE && ty < server.MAP_SIZE) {
            return tiles[ty][tx];
        } else {
            return null;
        }
    };

    server.increaseTileUsage = (tx, ty) => {
        let tileServer = server.getTileServer(tx, ty);
        if (tileServer) {
            tileServer.usage += 0.001;
            if (tileServer.usage >= 1) {
                server.updateTile(tx, ty, null, 0.5);
            }
        }
    };

    server.decreaseTileDamage = (tx, ty) => {
        let tile = server.getTile(tx, ty);
        if (tile) {
            if (tx > 0 && ty > 0 && tx < server.MAP_SIZE && ty < server.MAP_SIZE && tilesServer[ty] && tilesServer[ty][tx]) {
                tilesServer[ty][tx].touched = true;
                tilesServer[ty][tx].damage -= 5;
                if (tilesServer[ty][tx].damage <= 0) {
                    tilesServer[ty][tx].damage = 0;
                }
            }
        }
    };

    server.updateTile = (tx, ty, val, moisture) => {
        if (tx >= 0 && ty >= 0 && tx < server.MAP_SIZE && ty < server.MAP_SIZE) {
            let data = {
                x: tx,
                y: ty
            };

            if (val !== null && val !== undefined) {
                data.val = val;
                tiles[ty][tx][0] = val;
                server.tileGrids[1].setWalkableAt(tx, ty, tiles[ty][tx][0] === 0);
            }

            if (moisture !== null && moisture !== undefined) {
                server.setTileMoisture(tx, ty, moisture);
                data.m = tiles[ty][tx][1];
            }

            server.sendMessage('tileUpdate', data);
        }
    };

    server.getTileServer = (tx, ty) => {
        if (server.getTile(tx, ty) && tilesServer[ty]) {
            return tilesServer[ty][tx];
        }
        return null;
    };

    server.checkSpawnQueue = (team, spawnQueue) => {
        if (spawnQueue && spawnQueue.length) {
            if (spawnQueue[0].connected && (!spawnQueue[0].player || !spawnQueue[0].canControl || (spawnQueue[0].player && !spawnQueue[0].player.valid)) && server.teamData[spawnQueue[0].team]) {
                for (let i = 0; i < server.entities.length; i++) {
                    let entity = server.entities[i];
                    let isLeader = (spawnQueue[0] && server.teamData[entity.team]) ? server.teamData[entity.team].clients[0] === spawnQueue[0] : false;
                    if ((entity.subtype === 'ant_worker' || (entity.subtype === 'ant_queen' && (entity.netData.newQueen || (team.aliveAntCount <= team.clients.length && isLeader)))) && parseInt(entity.team) === parseInt(spawnQueue[0].team) && entity.isAI && entity.netData.alive) {
                        let socket = spawnQueue.shift();
                        server.switchPlayer(socket, entity);
                        break;
                    }
                }
            } else {
                spawnQueue.shift();
            }
        }
    };

    server.spawnFoodPile = (foodPos) => {
        if (!foodPos) {
            foodPos = {
                x: 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600)),
                y: 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600))
            };
        }

        let canSpawn = true;
        for (let i = 0; i < server.entities.length; i++) {
            let entity = server.entities[i];
            if (entity.subtype === 'anthill') {
                if (Math.distanceBetween(foodPos, entity) <= 400) {
                    canSpawn = false;
                    break;
                }
            }
        }

        if (canSpawn) {
            let addFoodCount = 6 + Math.round(Math.random() * 8);
            for (let i = 0; i < addFoodCount; i++) {
                let angle = (Math.PI * 2) * Math.random();
                let dist = 15 + (Math.random() * 50);
                server.createObject('food', foodPos.x + (Math.cos(angle) * dist), foodPos.y + (Math.sin(angle) * dist), 0, 45, 45, -1, {foodType: 'plant'});
            }
        }
    };

    server.lastSnapshot = Date.now();
    server.tickSnapshot = () => {
        if (Date.now() - server.lastSnapshot >= snapshotRate) {
            server.lastSnapshot = Date.now();
            server.sendSnapshot();
        }
    };

    server.entityAISearch = (entity, maxAngle, dist) => {
        if (!dist) {
            dist = 150;
        }

        let angle = entity.rotation - Math.PI/2;
        angle += (Math.random() * maxAngle) - maxAngle/2;
        entity.pathTo({
            x: entity.x + (Math.cos(angle) * dist),
            y: entity.y + (Math.sin(angle) * dist),
            z: entity.z
        }, null, null, false, true);

        if (!entity.path.length) {
            if (Math.random() > 0.5) {
                angle += Math.PI/2;
            } else {
                angle -= Math.PI/2;
            }

            entity.pathTo({
                x: entity.x + (Math.cos(angle) * dist),
                y: entity.y + (Math.sin(angle) * dist),
                z: entity.z
            }, null, null, false, true);

            if (!entity.path.length) {
                entity.pathTo({
                    x: entity.x + (Math.cos(angle) * dist),
                    y: entity.y + (Math.sin(angle) * dist),
                    z: entity.z
                }, null, null, false, true);

                if (!entity.path.length) {
                    angle = Math.angleBetween(entity, {
                        x: (server.MAP_SIZE*server.TILE_SIZE)/2,
                        y: (server.MAP_SIZE*server.TILE_SIZE)/2
                    });
                    dist = 200;

                    entity.pathTo({
                        x: entity.x + (Math.cos(angle) * dist),
                        y: entity.y + (Math.sin(angle) * dist),
                        z: entity.z
                    }, null, null, false, false);
                }
            }
        }
    };

    server.tickTeamAIEntity = (entity) => {
        if (server.getModifiedTime() - entity.lastAITeamThink > 1000) {
            entity.lastAITeamThink = server.getModifiedTime();
        } else {
            return;
        }

        if (config.isTutorial) {
            return;
        }

        switch (entity.subtype) {
            case 'ant_queen':
                if (entity.netData.newQueen && server.teamData[entity.team] && server.teamData[entity.team].isAI) {
                    if (server.currentSeason.type === 'winter') {
                        if (entity.z <= 0) {
                            if (entity.queen && entity.queen.anthill) {
                                entity.pathTo({
                                    x: entity.queen.anthill.x + server.getRandomNumberBetween(-50, 50),
                                    y: entity.queen.anthill.y + server.getRandomNumberBetween(-50, 50),
                                    z: 1
                                }, null, false, false);
                            }
                        }

                        return;
                    }

                    if (entity.z <= 0) {
                        if (Math.random() >= 0.1) {
                            if (!entity.dataAI.lastAnthillCreationAttempt || server.getModifiedTime() - entity.dataAI.lastAnthillCreationAttempt > 1500) {
                                let dryCount = 0;
                                let wetCount = 0;
                                server.loopTileArea(entity, 4, (tx, ty) => {
                                    let entDist = Math.distanceBetween(entity, {
                                        x: (tx * server.TILE_SIZE) + server.TILE_SIZE / 2,
                                        y: (ty * server.TILE_SIZE) + server.TILE_SIZE / 2
                                    });

                                    if (entDist < 3*server.TILE_SIZE) {
                                        let tile = server.getTile(tx, ty);
                                        if (tile && (tile[0] === 0 || tile[0] === 1)) {
                                            if (tile[1] === 1) {
                                                wetCount++;
                                            }
                                            if (tile[1] === 0) {
                                                dryCount++;
                                            }
                                        }
                                    }
                                });

                                if (dryCount >= 3 && wetCount >= 2) {
                                    entity.pathTo({
                                        x: entity.x,
                                        y: entity.y,
                                        z: entity.z
                                    }, null, true, true);
                                }
                                entity.dataAI.lastAnthillCreationAttempt = server.getModifiedTime();
                            } else {
                                server.entityAISearch(entity, Math.PI / 4);
                            }
                        }
                    } else {
                        if (Math.random() >= 0.8) {
                            let anthill = server.getClosestAnthill(entity, null, true);
                            if (anthill) {
                                entity.pathTo({
                                    x: anthill.x,
                                    y: anthill.y,
                                    z: 0
                                }, null, true, true);
                            }
                        }
                    }
                }
                break;
            case 'ant_worker':
                if (!entity.firstAssignment || server.getModifiedTime() - entity.dataAI.lastRoleCheck > 60000) {
                    if (server.teamData[entity.team] && server.teamData[entity.team].isAI) {
                        if (!entity.firstAssignment) {
                            entity.dataAI.role = 'forager';
                        } else if (Math.random() > 0.5) {
                            if (!entity.dataAI.roleEncounters['nurse'] || entity.dataAI.roleEncounters['nurse'] < 2) {
                                entity.dataAI.role = 'nurse';
                            } else if (!entity.dataAI.roleEncounters['digger'] || entity.dataAI.roleEncounters['digger'] < 1) {
                                entity.dataAI.role = 'digger';
                            } else {
                                entity.dataAI.role = 'forager';
                            }
                        }
                    } else if (!entity.firstAssignment) {
                        entity.dataAI.role = 'nurse';
                    }

                    entity.firstAssignment = true;
                    entity.dataAI.greetList = {};
                    entity.dataAI.roleEncounters = {};
                    entity.dataAI.lastRoleCheck = server.getModifiedTime();
                }

                if (server.currentSeason.type === 'winter' && server.getModifiedTime() >= nextSeasonChange-80000) {
                    if (entity.z <= 0) {
                        if (entity.queen && entity.queen.anthill) {
                            entity.pathTo({
                                x: entity.queen.anthill.x + server.getRandomNumberBetween(-50, 50),
                                y: entity.queen.anthill.y + server.getRandomNumberBetween(-50, 50),
                                z: 1
                            }, null, false, false);
                        }
                    }
                    return;
                }

                switch(entity.dataAI.role) {
                    case 'forager':
                        if (entity.z === 0) {
                            if (Math.random() >= 0.15) {
                                server.entityAISearch(entity, Math.PI / 4);
                            }
                        } else {
                            if (Math.random() > 0.8 && entity.queen && entity.queen.anthill) {
                                entity.pathTo({
                                    x: entity.queen.anthill.x + server.getRandomNumberBetween(-50, 50),
                                    y: entity.queen.anthill.y + server.getRandomNumberBetween(-50, 50),
                                    z: 0
                                }, null, false, false);
                            }
                        }
                        break;
                    case 'nurse':
                        if (entity.z === 0 && server.teamData[entity.team] && server.teamData[entity.team].isAI) {
                            if (Math.random() > 0.8 && entity.queen && entity.queen.anthill) {
                                if (Math.random() >= 0.5) {
                                    entity.pathTo({
                                        x: entity.queen.anthill.x + server.getRandomNumberBetween(-50, 50),
                                        y: entity.queen.anthill.y + server.getRandomNumberBetween(-50, 50),
                                        z: 1
                                    }, null, false, false);
                                } else {
                                    entity.pathTo({
                                        x: entity.queen.x + server.getRandomNumberBetween(-50, 50),
                                        y: entity.queen.y + server.getRandomNumberBetween(-50, 50),
                                        z: 1
                                    }, null, false, false);
                                }
                            }
                        }
                        break;
                    case 'digger':
                        if (entity.z === 0) {
                            if (Math.random() > 0.2 && entity.queen && entity.queen.anthill) {
                                entity.pathTo({
                                    x: entity.queen.anthill.x + server.getRandomNumberBetween(-50, 50),
                                    y: entity.queen.anthill.y + server.getRandomNumberBetween(-50, 50),
                                    z: 1
                                }, null, false, false);
                            }
                        } else if (entity.z >= 1 && server.teamData[entity.team] && server.teamData[entity.team].isAI) {
                            if (Math.random() > 0.75) {
                                let potentialTiles = [];

                                if (entity.queen) {
                                    entity.searchForTile(entity.queen, (node, start) => {
                                        let tile = server.getTile(node.x, node.y);
                                        if (tile[0] === 1) {
                                            let qdist = Math.distanceBetween(node, start);
                                            potentialTiles.push({
                                                node: node,
                                                tile: tile,
                                                score: 1 - qdist
                                            });
                                            return potentialTiles.length >= 8;
                                        } else {
                                            return false;
                                        }
                                    }, true);
                                }

                                potentialTiles.sort((a, b) => {
                                    return b.score - a.score;
                                });

                                if (potentialTiles.length) {
                                    let topbuff = potentialTiles.length;
                                    if (topbuff > 4) {
                                        topbuff = 4;
                                    }

                                    let validTile = potentialTiles[Math.floor(Math.random() * (topbuff-1))].node;
                                    let offx = 0;
                                    let offy = 0;
                                    if (Math.random() > 0.5) {
                                        offx = server.TILE_SIZE - (server.TILE_SIZE*0.4);
                                    } else {
                                        offx = (-server.TILE_SIZE) + (server.TILE_SIZE*0.4);
                                    }
                                    if (Math.random() > 0.5) {
                                        offy = server.TILE_SIZE - (server.TILE_SIZE*0.4);
                                    } else {
                                        offy = (-server.TILE_SIZE) + (server.TILE_SIZE*0.4);
                                    }
                                    entity.pathTo({
                                        x: (validTile.x * server.TILE_SIZE + server.TILE_SIZE/2) + offx,
                                        y: (validTile.y * server.TILE_SIZE + server.TILE_SIZE/2) + offy,
                                        z: 1
                                    }, 35, true);
                                    if (entity.path.length) {
                                        entity.digTarget = validTile;
                                        entity.setAIState('dig');
                                    }
                                }
                            } else {
                                if (Math.random() >= 0.1) {
                                    server.entityAISearch(entity, Math.PI / 4);
                                }
                            }
                        }
                        break;
                }
                break;
        }
    };

    server.getRandomNumberBetween = (min, max) => {
        return Math.floor(Math.random() * (max-min+1)+min);
    };

    const TILE_SECTOR_SIZE = 16;
    let sectorX = 0;
    let sectorY = 0;
    server.tickTiles = () => {
        if (server.gamemode.type === 'endless') {
            let damageRate = 0.6;
            if (server.currentWeather && server.currentWeather.type === 'rain') {
                damageRate *= 2.5;
            }

            for (let y = sectorY * TILE_SECTOR_SIZE; y < (sectorY * TILE_SECTOR_SIZE) + TILE_SECTOR_SIZE; y++) {
                for (let x = sectorX * TILE_SECTOR_SIZE; x < (sectorX * TILE_SECTOR_SIZE) + TILE_SECTOR_SIZE; x++) {
                    if (x > 0 && y > 0 && x < server.MAP_SIZE && y < server.MAP_SIZE) {
                        let tile = server.getTile(x, y);
                        if (tile && tile[0] === 0) {
                            /*
                            let nc = 0;
                            for (let tx=-1; tx<=1; tx++) {
                                for (let ty=-1; ty<=1; ty++) {
                                    if (!(tx === 0 && ty === 0)) {
                                        let nx = x + tx;
                                        let ny = y + ty;
                                        let t = server.getTile(nx, ny);
                                        if (t[0] !== 0 || (tilesServer[ny] && tilesServer[ny][nx] && tilesServer[ny][nx].anthill)) {
                                            nc++;
                                        }
                                    }
                                }
                            }

                            if (nc <= 0) {
                                server.updateTile(x, y, 1, null);
                            }
                            */

                            if (tilesServer[y][x].touched) {
                                tilesServer[y][x].damage += damageRate;
                                if (tilesServer[y][x].damage > 50) {
                                    tilesServer[y][x].damage = 0;
                                    server.updateTile(x, y, 1, null);
                                }
                            }
                        }
                    }
                }
            }

            sectorX++;
            if (sectorX > Math.floor(server.MAP_SIZE / TILE_SECTOR_SIZE)) {
                sectorX = 0;
                sectorY++;
                if (sectorY > Math.floor(server.MAP_SIZE / TILE_SECTOR_SIZE)) {
                    sectorY = 0;
                }
            }
        }
    };

    let lastStatusUpdate = Date.now();
    server.sendStatusUpdate = () => {
        if (Date.now()-lastStatusUpdate <= 1000) {
            return;
        }
        lastStatusUpdate = Date.now();
        sendMasterMessage('statusUpdate', {
            openSlot: server.hasOpenSlot(),
            openSlotRequireCanPlayRightAway: server.hasOpenSlot(true),
            roundState: server.getRoundState()
        }, true);
    };

    let spawnCheckTick = 0;
    let foodCheck = 0;
    let lastWinterMessage;
    server.tick = (delta) => {
        server.sendStatusUpdate();

        if (roundState.type === 'lobby') {
            if (roundState.endTime && (roundState.endTime - Date.now() <= 0 && server.clients.length >= 2) || (Date.now() - server.roundStartTime > 100 && config.skipGameLobby)) {
                server.startRound();
            }
            server.tickSnapshot();
            return;
        }

        if (server.tutorial) {
            server.tutorial.tick();

            if (server.tutorial.tutorialData && server.tutorial.tutorialData.pause) {
                return;
            }
        }

        if (server.paused) {
            if (server.newYearTime && Date.now() >= server.newYearTime) {
                server.newYearTime = null;
                server.paused = false;
                server.performNewYear();
            }
            server.tickSnapshot();
            return;
        }

        if (foodCheck <= 0) {
            foodCheck = 500;

            let teamLength = Object.keys(server.teamData).length;
            let aliveTeamCount = 0;
            for (let i = 0; i<teamLength; i++) {
                let team = server.teamData[i];
                if (team.queen && team.queen.netData.alive) {
                    aliveTeamCount++;
                }

                if ((server.currentYear === 1 && server.currentSeason.type === 'spring') || server.gamemode.type === 'endless') {
                    if (team.dead && Date.now() >= team.deadTime + team.respawnTime) {
                        team.dead = false;
                        team.queen = null;
                        if (server.gamemode.type === 'endless') {
                            server.createTeamQueen(i, null);
                        }
                    }
                }
            }

            let outsideFoodCount = 0;
            let outsideTwigCount = 0;
            let outsideWaterCount = 0;
            for (let i = 0; i < server.entities.length; i++) {
                let entity = server.entities[i];
                if (entity.z === 0) {
                    if (entity.subtype === 'food') {
                        outsideFoodCount++;
                    } else if (entity.subtype === 'material') {
                        if (entity.netData.matType === 'twigs') {
                            outsideTwigCount++;
                        } else if (entity.netData.matType === 'water') {
                            outsideWaterCount++
                        }
                    }
                }
            }

            let foodPileCount = Math.floor(aliveTeamCount * 0.6);
            if (foodPileCount < 1) {
                foodPileCount = 1;
            }
            if (outsideFoodCount < foodPileCount*6 && server.currentSeason.type !== 'winter') {
                for (let i=0; i<foodPileCount; i++) {
                    server.spawnFoodPile();
                }
            }

            if (outsideTwigCount < 20) {
                for (let i=0; i<40; i++) {
                    let pos = {
                        x: 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600)),
                        y: 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600))
                    };
                    server.createObject('material', pos.x, pos.y, 0, 45, 45, -1, {matType: 'twigs'});
                }
            }

            if (server.currentWeather && server.currentWeather.type === 'rain' && outsideWaterCount < 20) {
                for (let i=0; i<40; i++) {
                    let pos = {
                        x: 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600)),
                        y: 300 + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - 600))
                    };
                    server.createObject('material', pos.x, pos.y, 0, 45, 45, -1, {matType: 'water'});
                }
            }
        } else {
            foodCheck--;
        }

        if (nextNightChange - server.getModifiedTime() <= 0) {
            if (night) {
                server.currentDay++;
            }
            night = !night;
            if (night) {
                nextNightChange = server.getModifiedTime() + TIME_TIL_DAY;
            } else {
                nextNightChange = server.getModifiedTime() + TIME_TIL_NIGHT;
            }

            server.sendMessage('updateNight', {
                night: night
            });

            server.onNightChange();
        }

        if (nextWeatherChange - server.getModifiedTime() <= 0) {
            nextWeatherChange = server.getModifiedTime() + WEATHER_CHANGE_INTERVAL;

            let seasonData = server.getSeasonData();
            if (server.currentWeather) {
                server.updateWeather(null);
                nextWeatherChange = server.getModifiedTime() + (5 * 60 * 1000);
            } else if (Math.random() >= 1-(seasonData.rainChance ? seasonData.rainChance : 0.1)) {
                server.setWeather('rain');
            }
        }

        if (server.currentSeason.type === 'winter' && (!server.currentWeather || server.currentWeather.type !== 'snow') && server.getModifiedTime() >= nextSeasonChange-(TIME_TIL_DAY+TIME_TIL_NIGHT)) {
            nextWeatherChange = server.getModifiedTime() + (5 * 60 * 1000);
            server.setWeather('snow');
        }

        if (server.currentSeason.type === 'winter' && server.getModifiedTime() >= nextSeasonChange-80000) {
            let message = 'RETURN TO YOUR NEST\n60 SECONDS BEFORE HIBERNATION';

            if (server.getModifiedTime() >= nextSeasonChange-30000) {
                message = 'RETURN TO YOUR NEST\n10 SECONDS BEFORE HIBERNATION';
            } else if (server.getModifiedTime() >= nextSeasonChange-50000) {
                message = 'RETURN TO YOUR NEST\n30 SECONDS BEFORE HIBERNATION';
            }

            if (message !== lastWinterMessage) {
                server.sendMessage('setAnnouncement', message);
                lastWinterMessage = message;
            }

            if (server.currentSeason.type === 'winter' && server.getModifiedTime() >= nextSeasonChange-20000) {
                if (!server.paused) {
                    server.sendMessage('setAnnouncement', null);
                    server.performYearEnd();
                }
            }
        }

        if (nextSeasonChange - server.getModifiedTime() <= 0) {
            nextSeasonChange = server.getModifiedTime() + SEASON_CHANGE_INTERVAL;

            if (server.currentSeason.type === 'spring') {
                if (server.currentYear === 1 && server.gamemode.type !== 'endless') {
                    let teamLength = Object.keys(server.teamData).length;
                    for (let i = 0; i < teamLength; i++) {
                        let team = server.teamData[i];
                        if ((!team.queens || !team.queens.length) && team.clients.length <= 0) {
                            team.locked = true;
                        }
                    }
                }

                server.updateSeason({
                    type: 'summer'
                });
            } else if (server.currentSeason.type === 'summer') {
                server.updateSeason({
                    type: 'fall'
                });
            } else if (server.currentSeason.type === 'fall') {
                nextSeasonChange = server.getModifiedTime() + Math.round(SEASON_CHANGE_INTERVAL * 0.5);
                server.updateSeason({
                    type: 'winter'
                });
            } else {
                server.updateSeason({
                    type: 'spring'
                });
            }
        }

        if (server.currentWeather) {
            if (server.currentWeather.nextEvent) {
                if (Date.now() >= server.currentWeather.nextEvent) {
                    delete server.currentWeather.nextEvent;
                    if (server.currentWeather.type === 'rain' && server.currentWeather.thunderstorm && Math.random() >= 0.7) {
                        server.sendMessage('lightning', {
                            start: 0,
                            lightEnd: 100 + Math.round(200 * Math.random()),
                            end: 1000 + Math.round(1000 * Math.random()),
                            sound: (parseInt(Math.random() * 5) + 1)
                        });
                    }
                }
            } else {
                server.currentWeather.nextEvent = Date.now() + 5000 + Math.round(Math.random() * 5000);
            }
        }

        if (spawnCheckTick <= 0) {
            let teamLength = Object.keys(server.teamData).length;
            for (let i=0; i<teamLength; i++) {
                let team = server.teamData[i];
                server.checkSpawnQueue(team, team.spawnQueue);
            }

            for (let i = 0; i < server.clients.length; i++) {
                let client = server.clients[i];

                if (client.ready && (!client.player || (client.player && !client.player.valid) || !client.canControl) && client.team !== null && !client.hasSandboxAccess) {
                    if (server.teamData[client.team]) {
                        server.addClientToSpawnQueue(client);
                    }
                }

                if (!config.isSingleplayer && !config.standaloneGameServer && !client.hasSandboxAccess) {
                    if (Date.now() - client.lastAction > 360000) {
                        console.info('Disconnecting client due to inactivity:', client.name);
                        client.disconnect();
                    }
                }
            }
        }

        let teamLength = Object.keys(server.teamData).length;
        for (let i=0; i<teamLength; i++) {
            let team = server.teamData[i];
            team.aliveAntCount = 0;
        }

        let spiderCount = 0;
        let bugCount = 0;
        let centipedeCount = 0;
        for (let i=0; i<server.entities.length; i++) {
            let entity1 = server.entities[i];
            let candidates = server.quadtrees[entity1.z].retrieve({x: entity1.x, y: entity1.y, width: 450, height: 450});
            let maxCollisions = candidates.length;
            if (maxCollisions > 128) {
                maxCollisions = 128;
            }
            for (let j=0; j<maxCollisions; j++) {
                let entity2 = candidates[j];
                if (entity2 !== entity1) {
                    let dist = Math.distanceBetween(entity1, entity2);
                    if (entity1.z === entity2.z && entity1.thinkAI && entity1.isAI && entity1.netData.alive && !entity1.parent) {
                        entity1.thinkAI(entity2, dist);
                    }

                    if (entity1.z === entity2.z && entity1.netData.alive && entity1.radius && entity2.netData.alive && entity2.radius && (entity1.collisionLayer === entity2.collisionLayer || ((entity1.collisionLayer === 2 || entity1.collisionLayer === 3) && entity2.static))
                        && (!entity1.netData || !(entity1.netData.bugType === 'centipede' && entity2.netData.bugType === 'centipede'))) {
                        let check = entity1.radius + entity2.radius;
                        if (dist <= check) {
                            let angle = Math.angleBetween(entity2, entity1);
                            let anglePI = angle + Math.PI;
                            let diff = (check - dist) / 2;
                            if (!entity1.static) {
                                entity1.x += Math.cos(angle) * diff;
                                entity1.y += Math.sin(angle) * diff;
                            }
                            if (!entity2.static) {
                                entity2.x += Math.cos(anglePI) * diff;
                                entity2.y += Math.sin(anglePI) * diff;
                            }

                            if (!entity1.static) {
                                entity1.dx += Math.cos(angle) * diff;
                                entity1.dy += Math.sin(angle) * diff;
                            }
                            if (!entity2.static) {
                                entity2.dx += Math.cos(anglePI) * diff;
                                entity2.dy += Math.sin(anglePI) * diff;
                            }

                            if (entity1.onCollide) {
                                entity1.onCollide(entity2);
                            }

                            if (entity2.onCollide) {
                                entity2.onCollide(entity1);
                            }
                        }
                    }
                }
            }

            if (entity1.valid && entity1.z === 1) {
                for (let tox=-1; tox<=1; tox++) {
                    for (let toy=-1; toy<=1; toy++) {
                        let tx = parseInt(entity1.x/server.TILE_SIZE) + tox;
                        let ty = parseInt(entity1.y/server.TILE_SIZE) + toy;

                        let tile = server.getTile(tx, ty)[0];
                        if (tile) {
                            let padding = 6;
                            let tp = {x: tx*server.TILE_SIZE, y: ty*server.TILE_SIZE};
                            let tpcenter = {x: tp.x + (server.TILE_SIZE/2), y: tp.y + (server.TILE_SIZE/2)};

                            let cx = 0;
                            let cy = 0;
                            if (entity1.y >= tp.y - padding && entity1.y <= tp.y + server.TILE_SIZE + padding) {
                                if (entity1.x + entity1.radius >= tp.x - padding && entity1.x < tpcenter.x) {
                                    cx += ((tp.x - padding) - 0.1) - (entity1.x + entity1.radius);
                                    entity1.dx = 0;
                                } else if (entity1.x - entity1.radius <= tp.x + server.TILE_SIZE + padding && entity1.x > tpcenter.x) {
                                    cx += ((tp.x + server.TILE_SIZE + padding) + 0.1) - (entity1.x - entity1.radius);
                                    entity1.dx = 0;
                                }
                            }

                            if (entity1.x >= tp.x - padding && entity1.x <= tp.x + server.TILE_SIZE + padding) {
                                if (entity1.y + entity1.radius >= tp.y - padding && entity1.y < tpcenter.y) {
                                    cy += ((tp.y - padding) - 0.1) - (entity1.y + entity1.radius);
                                    entity1.dy = 0;
                                } else if (entity1.y - entity1.radius <= tp.y + server.TILE_SIZE + padding && entity1.y > tpcenter.y) {
                                    cy += ((tp.y + server.TILE_SIZE + padding) + 0.1) - (entity1.y - entity1.radius);
                                    entity1.dy = 0;
                                }
                            }

                            entity1.x = entity1.lastX;
                            entity1.y = entity1.lastY;
                            entity1.dx += cx;
                            entity1.dy += cy;

                            if (Math.abs(cx) > 0 || Math.abs(cy) > 0) {
                                let angle = Math.angleBetween(entity1, tpcenter) + Math.PI;
                                entity1.dx += Math.cos(angle) * 6;
                                entity1.dy += Math.sin(angle) * 6;

                                if (entity1.moveToPos) {
                                    let moveToDist = Math.distanceBetween(entity1.moveToPos, tpcenter);
                                    if (moveToDist <= server.TILE_SIZE) {
                                        if (entity1.moveToPos.action) {
                                            entity1.performAction();
                                        }
                                        entity1.moveToPos = null;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (entity1.subtype === 'spider' && entity1.valid) {
                spiderCount++;
            } else if (entity1.subtype === 'bug' && entity1.netData && entity1.netData.bugType === 'centipede' && entity1.netData.centipedeType === 'head' && entity1.valid) {
                centipedeCount++;
            } else if ((entity1.subtype === 'bug' || entity1.subtype === 'beetle') && entity1.valid) {
                bugCount++;
            }

            if (entity1.subtype === 'ant_worker' && server.teamData[entity1.team] && entity1.valid && entity1.netData.alive) {
                server.teamData[entity1.team].aliveAntCount++;
            } else if (entity1.subtype === 'brood' && server.teamData[entity1.team] && entity1.valid && entity1.netData && entity1.netData.broodStage >= 2 && server.teamData[entity1.team].aliveAntCount <= 0) {
                server.teamData[entity1.team].aliveAntCount = 1;
            }
        }

        if (spawnCheckTick <= 0) {
            spawnCheckTick = 100;

            let aliveTeamCount = 0;
            for (let i = 0; i < teamLength; i++) {
                let team = server.teamData[i];
                if (!config.isSandbox && team.aliveAntCount <= 0 && team.queen && team.queen.netData.alive && !team.queen.netData.newQueen && server.gamemode.type !== 'endless') {
                    team.queen.kill(team.lastAttacker);
                } else {
                    if (team.queen && team.queen.netData.alive) {
                        aliveTeamCount++;
                    }
                }
            }

            if (!config.isSandbox && server.currentSeason.type !== 'winter') {
                let maxSpiders = Math.ceil(aliveTeamCount * 0.6);
                if (maxSpiders < 2) {
                    maxSpiders = 2;
                }
                if (spiderCount < maxSpiders && Date.now() - server.roundStartTime > 6 * 60 * 1000) {
                    let pos = server.getEdgePosition();
                    server.createInsect('spider', pos.x, pos.y, 0, 120, 120, -1);
                }

                let maxCentipedes = Math.ceil(aliveTeamCount * 0.5);
                if (maxCentipedes < 2) {
                    maxCentipedes = 2;
                }
                if (centipedeCount < maxCentipedes && Date.now() - server.roundStartTime > 16 * 60 * 1000) {
                    let size = Math.round(80 + (Math.random() * 100));
                    let pos = server.getEdgePosition();
                    server.createInsect('bug', pos.x, pos.y, 0, size, size, -1, {
                        bugType: 'centipede',
                        centipedeType: 'head'
                    });
                }
            }

            if (server.currentSeason.type !== 'winter') {
                let maxBugs = Math.round(aliveTeamCount * 1.2);
                if (maxBugs < 4) {
                    maxBugs = 4;
                }
                if (bugCount < maxBugs) {
                    let pos = server.getEdgePosition();
                    if (Math.random() <= 0.5) {
                        server.createInsect('bug', pos.x, pos.y, 0, 100, 100, -1);
                    } else {
                        server.createInsect('beetle', pos.x, pos.y, 0, 145, 145, -1);
                    }
                }
            }
        } else {
            spawnCheckTick--;
        }

        server.tickTiles();

        server.tickEntities(delta);

        server.updateQuadtrees();

        server.tickSnapshot();
    };

    server.tickEntities = (delta) => {
        for (let i=0; i<server.entities.length; i++) {
            let entity = server.entities[i];
            if (entity.valid) {
                if (entity.tick) {
                    entity.tick(delta);
                }
            } else {
                server.entities.splice(i, 1);
                entity.onRemove();
                if (config.isSingleplayer || entity.static) {
                    server.sendMessage('removeEntity', entity.id);
                }
                i--;
            }
        }
    };

    server.updateQuadtrees = () => {
        server.quadtrees[-1].clear();
        server.quadtrees[0].clear();
        server.quadtrees[1].clear();
        server.quadtrees[2].clear();
        for (let i=0; i<server.entities.length; i++) {
            let entity = server.entities[i];
            if (entity.valid) {
                server.quadtrees[entity.z].insert(entity);
                if (entity.subtype === 'anthill') {
                    server.quadtrees[entity.z+1].insert(entity);
                }
            }
        }
    };

    server.onNightChange = () => {
        if (server.gamemode.type === 'coop' && night) {
            server.gamemode.wave++;
            server.gamemode.enemyCount = Math.round(server.gamemode.enemyCount * 1.4);
            if (!server.gamemode.enemyTeam) {
                server.gamemode.enemyTeam = server.createTeam();
                server.gamemode.enemyTeam.isAI = true;
                server.gamemode.enemyTeam.isFakeTeam = true;
                server.gamemode.enemyTeam.locked = true;
                server.gamemode.enemyTeam.anthill = server.teamData[0].anthill;
            }
            server.sendMessage('growl', 'WAVE ' + server.gamemode.wave + ' ENEMIES: ' + server.gamemode.enemyCount);

            for (let i=0; i<server.gamemode.enemyCount; i++) {
                let rand = Math.random();
                let pos = server.getEdgePosition(-50);
                let ent = null;
                if (rand < 0.6 || (server.getModifiedTime() - server.roundStartTime) < 8 * 60 * 1000) {
                    ent = server.createInsect('ant_worker', pos.x + Math.random(), pos.y + Math.random(), 0, 65, 65, server.gamemode.enemyTeam.id);
                } else if (rand >= 0.6 && rand < 0.9) {
                    ent = server.createInsect('ant_worker', pos.x + Math.random(), pos.y + Math.random(), 0, 80, 80, server.gamemode.enemyTeam.id, {soldier: true});
                } else {
                    ent = server.createInsect('ant_worker', pos.x + Math.random(), pos.y + Math.random(), 0, 110, 110, server.gamemode.enemyTeam.id, {soldier: true});
                }

                if (ent) {
                    ent.pathTo({
                        x: server.teamData[0].queen.x,
                        y: server.teamData[0].queen.y,
                        z: 1
                    }, 35);

                    if (!ent.path || !ent.path.length) {
                        ent.moveToPos = {
                            x: server.teamData[0].queen.x,
                            y: server.teamData[0].queen.y
                        };
                    }
                }
            }
        }
    };

    server.updateGamemode = (gm) => {
        server.gamemode = {
            type: gm.toLowerCase()
        };

        TIME_TIL_NIGHT = 2 * 60 * 1000;
        TIME_TIL_DAY = 1 * 60 * 1000;
        MAX_FOLLOWERS = null;

        if (server.gamemode.type === 'coop') {
            server.gamemode.wave = 0;
            server.gamemode.enemyCount = 3;
            MAX_TEAM_PLAYERS = 100;

            TIME_TIL_NIGHT = 2 * 60 * 1000;
            TIME_TIL_DAY = 0.8 * 60 * 1000;
            nextNightChange = Date.now() + TIME_TIL_NIGHT;

            server.teamData = {};
            teamCount = 0;
            server.createTeam();
            server.sendLobbyUpdate();
        } else if (server.gamemode.type === 'endless') {
            MAX_TEAM_PLAYERS = 100;
            MAX_FOLLOWERS = 5;
        } else {
            MAX_TEAM_PLAYERS = 4;
        }
    };

    server.getEdgePosition = (offset) => {
        let rand = Math.random();
        if (!offset) {
            offset = 10;
        }
        if (rand <= 0.25) {
            return {
                x: (server.MAP_SIZE * server.TILE_SIZE) * Math.random(),
                y: -offset
            };
        } else if (rand > 0.25 && rand <= 0.5) {
            return {
                x: -offset,
                y: (server.MAP_SIZE * server.TILE_SIZE) * Math.random()
            };
        } else if (rand > 0.5 && rand <= 0.75) {
            return {
                x: (server.MAP_SIZE * server.TILE_SIZE) * Math.random(),
                y: (server.MAP_SIZE * server.TILE_SIZE) + offset
            };
        }

        return {
            x: (server.MAP_SIZE * server.TILE_SIZE) + offset,
            y: (server.MAP_SIZE * server.TILE_SIZE) * Math.random()
        };
    };

    server.getPositionAwayFromEdge = (offset) => {
        if (!offset) {
            offset = 10;
        }

        return {
            x: (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - (offset*2))) + offset,
            y: (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - (offset*2))) + offset
        };
    };

    server.sendSnapshot = () => {
        let time = Date.now();
        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];

            if (config.isSingleplayer) {
                let buffer = Buffer.allocUnsafe(8);
                buffer.writeDoubleBE(time);
                for (let j = 0; j < server.entities.length; j++) {
                    let entity = server.entities[j];

                    if (entity.sendMoveUpdate) {
                        buffer = server.writePayloadBuffer(buffer, entity);
                    }
                }
                client.snapSocket.client.conn.write(buffer);
            } else {
                let viewPos = client.player;
                if (viewPos) {
                    let viewDistance = server.getClientViewDistance(client);
                    let candidates = server.quadtrees[viewPos.z].retrieve({
                        x: viewPos.x,
                        y: viewPos.y,
                        width: viewDistance + 50,
                        height: viewDistance + 50
                    });

                    if (viewPos.z <= -1) {
                        let addCandidates = server.quadtrees[0].retrieve({
                            x: viewPos.x,
                            y: viewPos.y,
                            width: viewDistance + 50,
                            height: viewDistance + 50
                        });
                        candidates = candidates.concat(addCandidates);
                    }

                    if (candidates.length >= 1) {
                        let entitiesToCreate = [];
                        for (let j = 0; j < candidates.length; j++) {
                            let entity = candidates[j];
                            if (!entity.static && !client.knownEntities[entity.id] && (entity === viewPos || entity.z !== -1)) {
                                let dist = Math.distanceBetween(entity, viewPos);
                                if (dist <= viewDistance) {
                                    entitiesToCreate.push(entity.getCreateData());
                                    client.knownEntities[entity.id] = entity;
                                }
                            }
                        }

                        if (entitiesToCreate.length >= 1) {
                            client.emit('createEntity', entitiesToCreate);
                        }
                    }

                    let knownEntityKeys = Object.keys(client.knownEntities);
                    if (knownEntityKeys.length >= 1) {
                        let entityIdsToRemove = [];
                        let buffer = Buffer.allocUnsafe(8);
                        buffer.writeDoubleBE(time);
                        for (let j = 0; j < knownEntityKeys.length; j++) {
                            let entity = client.knownEntities[knownEntityKeys[j]];

                            //if (entity.valid && (entity.z === viewPos.z || (entity.subtype === 'anthill' && entity.z === viewPos.z-1) || viewPos.z <= -1 && entity.z === viewPos.z+1) && Math.distanceBetween(entity, viewPos) <= viewDistance+50) {
                            if (entity.valid && Math.distanceBetween(entity, viewPos) <= viewDistance + 50) {
                                if (entity.sendMoveUpdate) {
                                    buffer = server.writePayloadBuffer(buffer, entity);
                                }
                            } else {
                                entityIdsToRemove.push(entity.id);
                                delete client.knownEntities[entity.id];
                            }
                        }
                        client.snapSocket.client.conn.write(buffer);

                        if (entityIdsToRemove.length >= 1) {
                            client.emit('removeEntity', entityIdsToRemove);
                        }
                    }
                }
            }
        }
    };

    server.writePayloadBuffer = (buffer, entity) => {
        let payloadBuffer = Buffer.allocUnsafe(17);
        payloadBuffer.writeUInt32BE(entity.id, 0);
        payloadBuffer.writeFloatBE(entity.x, 4);
        payloadBuffer.writeFloatBE(entity.y, 8);
        payloadBuffer.writeInt8(entity.z, 12);
        payloadBuffer.writeFloatBE(entity.rotation, 13);

        let length = buffer.length + payloadBuffer.length;
        return Buffer.concat([buffer, payloadBuffer], length);
    };

    let moistureDist = 0.15;
    server.setTileMoisture = (tx, ty, moisture) => {
        if (moisture > 1-moistureDist) {
            moisture = 1;
        } else if (moisture < moistureDist) {
            moisture = 0;
        } else {
            moisture = 0.5;
        }
        tiles[ty][tx][1] = moisture;
    };

    //Helper function for looping over an area of tiles, so we don't need to loop over the entire map.
    server.loopTileArea = (pos, radiusInTiles, fn) => {
        let radiusInTilesMax = Math.ceil(Math.abs(radiusInTiles));
        let tx = Math.floor(pos.x / server.TILE_SIZE) - radiusInTilesMax;
        let ty = Math.floor(pos.y / server.TILE_SIZE) - radiusInTilesMax;
        let maxTx = tx + (radiusInTilesMax*2);
        let maxTy = ty + (radiusInTilesMax*2);

        for (let y=ty; y<maxTy; y++) {
            for (let x=tx; x<maxTx; x++) {
                if (x > 0 && y > 0 && x < server.MAP_SIZE && y < server.MAP_SIZE) {
                    fn(x, y, pos.z);
                }
            }
        }
    };

    //Update all tiles in an area.
    server.updateTileArea = (pos, initCheckRadius) => {
        server.loopTileArea(pos, initCheckRadius/server.TILE_SIZE, (x, y, z) => {
            let tileWalkable = true;

            if (tileWalkable) {
                for (let i = 0; i < server.entities.length; i++) {
                    let entity = server.entities[i];
                    if ((entity.z === z || entity.subtype === 'anthill') && (entity.subtype === 'rock' || entity.subtype === 'object_solid' || entity.subtype === 'plant' || entity.subtype === 'anthill' || (entity.subtype === 'food_source' && entity.static))) {
                        let entDist = Math.distanceBetween(entity, {
                            x: (x * server.TILE_SIZE) + server.TILE_SIZE / 2,
                            y: (y * server.TILE_SIZE) + server.TILE_SIZE / 2
                        });

                        let checkRadius = entity.getTileCheckRadius();
                        if (entDist <= checkRadius) {
                            if (entity.subtype === 'anthill') {
                                if (entDist <= server.TILE_SIZE) {
                                    tileWalkable = true;
                                    break;
                                }
                            } else {
                                tileWalkable = false;
                            }
                        }
                    }
                }
            }

            if (z >= 1) {
                let tile = server.getTileOrNull(x, y);
                if (tile && tile[0] !== 0) {
                    tileWalkable = false;
                }
            }

            server.tileGrids[z].setWalkableAt(x, y, tileWalkable);
        });
    };

    server.createNewAnthill = (queen) => {
        let anthill = server.createObject('anthill', queen.x, queen.y, 0, 200, 200, queen.team);
        if (!anthill) {
            return null;
        }

        queen.anthill = anthill;
        queen.path = [];
        queen.moveTo = null;

        if (server.teamData[queen.team].isAI && config.isSingleplayer) {
            let naniticSize = 48;
            let worker = server.createInsect('ant_worker', anthill.x + ((Math.random() * 50) - 25), anthill.y + 60 + ((Math.random() * 50) - 25), 1, naniticSize, naniticSize, queen.team, {isNanitic: true});
            worker.queen = queen;
            if (queen.currentPlayer) {
                server.switchPlayer(queen.currentPlayer, worker);
            }

            let workerCount = 4;
            for (let i = 0; i < workerCount - 1; i++) {
                let worker = server.createInsect('ant_worker', anthill.x + ((Math.random() * 50) - 25), anthill.y + 60 + ((Math.random() * 50) - 25), 1, naniticSize, naniticSize, queen.team, {isNanitic: true});
                if (i === 0) {
                    worker.dataAI.role = 'digger';
                }
                worker.queen = queen;
            }
        }

        queen.netData.newQueen = false;
        queen.sendRPC('setNewQueen', false);
        queen.x -= 50;
        queen.y -= 20;
        queen.z = 1;

        let broodCount = 4;
        if (server.gamemode.type === 'coop') {
            broodCount = 8;
        }
        for (let i=0; i<broodCount; i++) {
            let brood = server.createObject('brood', anthill.x + ((Math.random() * 50)-25), anthill.y + 60 + ((Math.random() * 50)-25), queen.z, 39, 39, queen.team, {
                broodStage: 2
            });
            brood.freeBrood = true;
            brood.broodType = 'nanitic';
            brood.queen = queen;
        }

        server.teamData[queen.team].aliveAntCount = 1;

        server.updateTeamInfo(queen.team);

        return anthill;
    };

    let yearEndData;
    server.performNewYear = () => {
        server.currentYear++;
        for (let i = 0; i < server.entities.length; i++) {
            let entity = server.entities[i];

            if (entity.subtype === 'aphid' ||
                (entity.z <= 0 && (entity.type === 'insect' || entity.subtype === 'stick' || entity.subtype === 'plant' || entity.subtype === 'food' || entity.subtype === 'brood' || entity.subtype === 'food_source' || (entity.subtype === 'object_hide' && entity.netData.sprite === 'leaves')))
            ) {
                if (entity.kill) {
                    entity.kill();
                }
                entity.remove();
            }
        }

        server.tickEntities(fixedTimeStep);

        let teamLength = Object.keys(server.teamData).length;
        for (let i = 0; i < teamLength; i++) {
            let team = server.teamData[i];
            if ((!team.isAI || team.clients.length >= 1) && server.getModifiedTime() - team.nestCreationTime >= SEASON_CHANGE_INTERVAL) {
                let data = yearEndData[i];

                for (let j = 0; j < data.food.length; j++) {
                    let food = data.food[j];
                    if (data.usedFood > 0) {
                        if (food.carrier) {
                            food.carrier.changeGrabbedObject(null);
                        }
                        food.remove();
                        data.usedFood -= 2;
                    }
                    delete food.carrier;
                }

                if (data.usedFood > 0) {
                    for (let j = 0; j < data.specialFood.length; j++) {
                        let food = data.specialFood[j];
                        if (data.usedFood > 0) {
                            if (food.carrier) {
                                food.carrier.changeGrabbedObject(null);
                            }
                            food.remove();
                            data.usedFood -= 3;
                        }
                        delete food.carrier;
                    }
                }

                if (data.starvationCount > 0) {
                    for (let j = data.ants.length - 1; j >= 0; j--) {
                        let ant = data.ants[j];
                        if (data.starvationCount > 0) {
                            ant.kill();
                            data.starvationCount--;
                        } else {
                            ant.energy = 100;
                            ant.setHungry(false);
                        }
                    }
                }
            }
        }

        server.tickEntities(fixedTimeStep);

        for (let i = 0; i < teamLength; i++) {
            let team = server.teamData[i];
            if ((!team.isAI || team.clients.length >= 1) && server.getModifiedTime() - team.nestCreationTime >= SEASON_CHANGE_INTERVAL && !team.dead && team.aliveAntCount > 0) {
                server.recordXP({
                    team: team.id
                }, 200, 'survived_winter');
            }
        }

        yearEndData = null;

        server.resetEnvironment();

        server.generateMapObjects();

        server.sendMessage('newYear', {});
    };

    server.performYearEnd = () => {
        if (!server.paused) {
            server.paused = true;
            server.newYearTime = Date.now() + 20000;

            yearEndData = {};
            let teamLength = Object.keys(server.teamData).length;
            for (let i=0; i<teamLength; i++) {
                yearEndData[i] = {
                    antCount: 0,
                    antsFrozen: 0,
                    foodCount: 0,
                    starvationCount: 0,
                    usedFood: 0,
                    ants: [],
                    food: [],
                    specialFood: []
                };
            }

            for (let j = 0; j < server.entities.length; j++) {
                let entity = server.entities[j];
                if (entity.team !== null && entity.team !== undefined && yearEndData[entity.team]) {
                    let data = yearEndData[entity.team];
                    if (entity.z >= 1) {
                        if (entity.subtype === 'ant_worker' || entity.subtype === 'ant_queen') {
                            data.antCount++;
                            if (entity.socialFoodStorage > 0) {
                                data.foodCount += entity.socialFoodStorage;
                                entity.socialFoodStorage = 0;
                            }

                            if (entity.isAI) {
                                data.ants.push(entity);
                            } else {
                                data.ants.unshift(entity);
                            }
                        }

                        let food = entity;
                        if (entity.carriedObject && entity.carriedObject.subtype === 'food') {
                            food = entity.carriedObject;
                            food.carrier = entity;
                        }

                        if (food.subtype === 'food') {
                            if (food.netData.foodType === 'blue') {
                                data.foodCount += 3;
                                data.specialFood.push(food);
                            } else if (food.netData.foodType === 'red') {
                                data.foodCount += 4;
                                data.specialFood.push(food);
                            } else {
                                data.foodCount += 2;
                                data.food.push(food);
                            }
                        }
                    } else if (entity.z <= 0) {
                        if (entity.subtype === 'ant_worker' || entity.subtype === 'ant_queen') {
                            data.antsFrozen++;
                        }
                    }
                }
            }

            for (let i=0; i<teamLength; i++) {
                let data = yearEndData[i];
                data.usedFood = data.antCount;
                let foodDiff = data.foodCount - data.usedFood;
                if (foodDiff < 0) {
                    data.starvationCount = Math.abs(foodDiff);
                }
            }

            for (let i=0; i<server.clients.length; i++) {
                let client = server.clients[i];
                if (yearEndData[client.team]) {
                    let team = server.teamData[client.team];
                    let data = yearEndData[client.team];
                    if (team && server.getModifiedTime() - team.nestCreationTime >= SEASON_CHANGE_INTERVAL) {
                        client.emit('yearEnded', {
                            antCount: data.antCount,
                            antsFrozen: data.antsFrozen,
                            foodCount: data.foodCount,
                            usedFood: (data.usedFood >= data.foodCount) ? data.foodCount : data.usedFood,
                            starvationCount: data.starvationCount
                        });
                    } else {
                        client.emit('yearEnded', {});
                    }
                } else {
                    client.emit('yearEnded', {});
                }
            }
        }
    };

    server.generateMapObjects = (gameReset) => {
        let countMod = 1.25;

        let teamCount = 0;
        let teamLength = Object.keys(server.teamData).length;
        for (let i=0; i<teamLength; i++) {
            let team = server.teamData[i];
            if (team.clients.length > 0 || team.isAI) {
                teamCount++;
            }
        }

        let foodSourceCount = 0;
        for (let i=0; i<Math.round(25*countMod); i++) {
            let posBuffer = 500;
            let pos = {x: posBuffer + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - (posBuffer*2))), y: posBuffer + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - (posBuffer*2)))};
            let size = 600;

            let clear = true;
            for (let j=0; j<server.entities.length; j++) {
                let entity = server.entities[j];
                if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'object_hide' || entity.subtype === 'plant') {
                    let dist = Math.distanceBetween(pos, entity);
                    if (dist <= size) {
                        clear = false;
                        break;
                    }
                }
            }

            if (clear) {
                server.createObject('food_source', pos.x, pos.y, 0, 400, 400, -1, {
                    foodSourceType: 'meat'
                });
                foodSourceCount++;
            }

            if (foodSourceCount >= 3) {
                break;
            }
        }

        if (gameReset) {
            for (let i = 0; i < Math.round(2*countMod); i++) {
                let pos = {
                    x: Math.random() * server.MAP_SIZE * server.TILE_SIZE,
                    y: Math.random() * server.MAP_SIZE * server.TILE_SIZE
                };
                let size = 1200 + Math.round(Math.random() * 200);

                let clear = true;
                for (let j = 0; j < server.entities.length; j++) {
                    let entity = server.entities[j];
                    if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'object_hide' || entity.subtype === 'plant') {
                        let dist = Math.distanceBetween(pos, entity);
                        if (dist <= size) {
                            clear = false;
                            break;
                        }
                    }
                }

                if (clear) {
                    server.createObject('object_solid', pos.x, pos.y, 0, 800, 800, -1, {
                        sprite: 'tree_stump'
                    });
                }
            }

            for (let i = 0; i < Math.round(8*countMod); i++) {
                let pos = {
                    x: Math.random() * server.MAP_SIZE * server.TILE_SIZE,
                    y: Math.random() * server.MAP_SIZE * server.TILE_SIZE
                };
                let size = 400;

                let clear = true;
                for (let j = 0; j < server.entities.length; j++) {
                    let entity = server.entities[j];
                    if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'object_hide' || entity.subtype === 'plant') {
                        let dist = Math.distanceBetween(pos, entity);
                        if (dist <= size) {
                            clear = false;
                            break;
                        }
                    }
                }

                if (clear) {
                    if (Math.random() <= 0.5) {
                        server.createObject('object_hide', pos.x, pos.y, 0, 600 * 0.9, 368 * 0.9, -1, {
                            sprite: 'crushed_can'
                        });
                    } else {
                        server.createObject('object_hide', pos.x, pos.y, 0, 250, 580, -1, {
                            sprite: 'bottle'
                        });
                    }
                }
            }

            for (let i = 0; i < Math.round(35*countMod); i++) {
                let pos = {
                    x: Math.random() * server.MAP_SIZE * server.TILE_SIZE,
                    y: Math.random() * server.MAP_SIZE * server.TILE_SIZE
                };
                let size = 400 + Math.round(Math.random() * 200);

                let clear = true;
                for (let j = 0; j < server.entities.length; j++) {
                    let entity = server.entities[j];
                    if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'object_hide' || entity.subtype === 'plant') {
                        let dist = Math.distanceBetween(pos, entity);
                        if (dist <= size) {
                            clear = false;
                            break;
                        }
                    }
                }

                if (clear) {
                    server.createObject('rock', pos.x, pos.y, 0, size, size, -1);
                }
            }

        }

        for (let i=0; i<Math.round(100*countMod); i++) {
            let pos = {x: Math.random() * server.MAP_SIZE * server.TILE_SIZE, y: Math.random() * server.MAP_SIZE * server.TILE_SIZE};
            let size = 400;

            let clear = true;
            for (let j=0; j<server.entities.length; j++) {
                let entity = server.entities[j];
                if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'plant') {
                    let dist = Math.distanceBetween(pos, entity);
                    if (dist <= size) {
                        clear = false;
                        break;
                    }
                }
            }

            if (clear) {
                let sizeMod = 1 + (Math.random()*0.4);
                let sy = Math.floor(Math.random() * 3);
                let sx = Math.floor(Math.random() * 4);
                if (sy === 2) {
                    sx = Math.floor(Math.random() * 2);
                }
                server.createObject('object_hide', pos.x, pos.y, 0, Math.round(256 * sizeMod), Math.round(256 * sizeMod), -1, {
                    sprite: 'leaves',
                    sx: sx,
                    sy: sy,
                    sw: 256,
                    sh: 256
                });
            }
        }

        plants = [];
        for (let i=0; i<Math.round(60*countMod); i++) {
            let posBuffer = 300;
            let pos = {x: posBuffer + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - (posBuffer*2))), y: posBuffer + (Math.random() * ((server.MAP_SIZE * server.TILE_SIZE) - (posBuffer*2)))};
            let size = 150;

            let clear = true;
            for (let j=0; j<server.entities.length; j++) {
                let entity = server.entities[j];
                if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'object_hide' || entity.subtype === 'plant') {
                    let dist = Math.distanceBetween(pos, entity);
                    let checkMod = 25;
                    if (entity.subtype === 'object_hide') {
                        checkMod = 125;
                    }
                    if (dist <= size+entity.radius+checkMod) {
                        clear = false;
                        break;
                    }
                }
            }

            if (clear) {
                let count = Math.round(1 + (Math.random() * 12));
                for (let i=0; i<count; i++) {
                    let angle = Math.random()*Math.PI*2;
                    let ndist = 50 + (Math.random()*300);
                    let npos = {x: pos.x + Math.cos(angle)*ndist, y: pos.y + Math.sin(angle)*ndist};
                    let nsize = 110 + Math.round(Math.random() * 25);

                    let clear = true;
                    for (let j=0; j<server.entities.length; j++) {
                        let entity = server.entities[j];
                        if (entity.subtype === 'rock' || entity.subtype === 'food_source' || entity.subtype === 'anthill' || entity.subtype === 'object_solid' || entity.subtype === 'object_hide' || entity.subtype === 'plant') {
                            let dist = Math.distanceBetween(npos, entity);
                            let checkMod = 25;
                            if (entity.subtype === 'object_hide') {
                                checkMod = 125;
                            } else if (entity.subtype === 'plant') {
                                checkMod = -50;
                            }
                            if (dist <= nsize+entity.radius+checkMod) {
                                clear = false;
                                break;
                            }
                        }
                    }

                    if (clear) {
                        let plant = null;
                        if (Math.random() <= 0.06) {
                            plant = server.createObject('food_source', pos.x, pos.y, 0, nsize, nsize, -1, {
                                foodSourceType: 'plant'
                            });
                        } else {
                            plant = server.createObject('plant', npos.x, npos.y, 0, nsize, nsize, -1);
                        }
                        if (plant) {
                            plants.push(plant);
                        }
                    }
                }
            }
        }

        for (let i = 0; i < Math.round(50*countMod); i++) {
            let pos = {
                x: Math.random() * server.MAP_SIZE * server.TILE_SIZE,
                y: Math.random() * server.MAP_SIZE * server.TILE_SIZE
            };
            let size = 400 + Math.round(Math.random() * 200);

            let clear = true;
            for (let j = 0; j < server.entities.length; j++) {
                let entity = server.entities[j];
                if (entity.subtype === 'object_solid' || entity.subtype === 'anthill' || entity.subtype === 'plant') {
                    let dist = Math.distanceBetween(pos, entity);
                    if (dist <= size) {
                        clear = false;
                        break;
                    }
                }
            }

            if (clear) {
                server.createObject('stick', pos.x, pos.y, 0, size, size * 0.25, -1, {
                    stickType: Math.floor(Math.random() * 4)
                });
            }
        }

        let aphidCount = Math.round(teamCount*1.25);
        if (aphidCount < 4) {
            aphidCount = 4;
        }
        if (!config.isTutorial) {
            aphidCount *= countMod;
            for (let i = 0; i < Math.round(aphidCount); i++) {
                let angle = Math.PI * 2 * Math.random();
                let dist = 50 + (Math.random() * 50);
                let plant = plants[Math.floor(Math.random() * plants.length)];
                if (plant) {
                    server.createObject('aphid', plant.x + (Math.cos(angle) * dist), plant.y + (Math.sin(angle) * dist), 0, 45, 45, -1);
                }
            }
        }
    };

    server.isNight = () => {
        return night;
    };

    server.resetEnvironment = () => {
        night = false;
        nextNightChange = server.getModifiedTime() + TIME_TIL_NIGHT;
        server.sendMessage('updateNight', {
            night: night,
            force: true
        });

        server.updateWeather(null);
        nextWeatherChange = server.getModifiedTime() + WEATHER_CHANGE_INTERVAL;

        server.updateSeason({
            type: 'spring'
        }, true);
        nextSeasonChange = server.getModifiedTime() + SEASON_CHANGE_INTERVAL;
    };

    server.setWeather = (type) => {
        switch(type) {
            case 'clear':
                server.updateWeather(null);
                nextWeatherChange = server.getModifiedTime() + (5 * 60 * 1000);
                break;
            case 'rain':
            case 'thunderstorm':
                server.updateWeather({
                    type: 'rain',
                    thunderstorm: type === 'thunderstorm' || Math.random() >= 0.6
                });
                nextWeatherChange = server.getModifiedTime() + (2 * 60 * 1000) + Math.round((6 * 60 * 1000) * Math.random());
                break;
            case 'snow':
                if (server.currentSeason.type === 'winter') {
                    server.updateWeather({
                        type: 'snow'
                    });
                    nextWeatherChange = server.getModifiedTime() + (2 * 60 * 1000) + Math.round((6 * 60 * 1000) * Math.random());
                } else {
                    console.error('It can only snow in winter!');
                }
                break;
            default:
                console.error('Invalid weather type:', type);
                break;
        }
    }

    server.updateWeather = (newWeather) => {
        server.currentWeather = newWeather;
        server.sendMessage('updateWeather', server.currentWeather);
    };

    server.updateSeason = (newSeason, forceUpdate) => {
        server.currentSeason = newSeason;
        let season = JSON.parse(JSON.stringify(server.currentSeason));
        if (forceUpdate) {
            season.forceUpdate = true;
        }
        server.sendMessage('updateSeason', season);
    };

    server.resetGame = () => {
        server.worldData = {
            specialEvent: null
        };
        let now = new Date();
        if (now.getMonth()+1 === 12) {
            //server.worldData.specialEvent = 'christmas';
        }

        server.currentDay = 1;
        server.currentYear = 1;
        server.paused = false;
        server.newYearTime = null;

        let noise = new Noise.Noise(Math.random());
        let noise2 = new Noise.Noise(Math.random());
        gameEnded = false;

        for (let i=0; i<server.entities.length; i++) {
            let entity = server.entities[i];
            entity.remove();
        }

        server.teamData = {};
        teamCount = 0;

        server.tileGrids = [new PF.Grid(server.MAP_SIZE, server.MAP_SIZE), new PF.Grid(server.MAP_SIZE, server.MAP_SIZE)];
        tiles = [];
        tilesServer = [];
        for (let y=0; y<server.MAP_SIZE; y++) {
            tiles.push([]);
            tilesServer.push([]);
            for (let x=0; x<server.MAP_SIZE; x++) {
                let open = (noise2.simplex2(x / 7, y / 7)+1)/2;
                if (open < 0.3) {
                    open = 0;
                } else {
                    open = 1;
                }
                if (open) {
                    if (Math.random() > 0.95) {
                        open = 2;
                        if (x-1 >= 0) {
                            tiles[y][x-1] = [2, 0, 0];
                            server.tileGrids[1].setWalkableAt(x - 1, y, false);

                            if (tiles[y-1]) {
                                if (y-1 >= 0) {
                                    tiles[y - 1][x] = [2, 0, 0];
                                    server.tileGrids[1].setWalkableAt(x, y - 1, false);
                                    tiles[y - 1][x - 1] = [2, 0, 0];
                                    server.tileGrids[1].setWalkableAt(x - 1, y - 1, false);
                                }
                            }
                        }
                    }
                }
                tiles[y][x] = [open, 0, 0];
                tilesServer[y][x] = {
                    damage: 0,
                    usage: 0
                };
                let moisture = (noise.simplex2(x / 6.5, y / 6.5)+1)/2;
                server.setTileMoisture(x, y, moisture);
                server.tileGrids[1].setWalkableAt(x, y, tiles[y][x][0] === 0);
            }
        }

        for (let y=0; y<server.MAP_SIZE; y++) {
            for (let x=0; x<server.MAP_SIZE; x++) {
                if (tiles[y][x]) {
                    if (tiles[y][x][0] === 0 && tiles[y][x][1] === 0 && Math.random() >= 0.6) {
                        let count = 1 + Math.round(Math.random() * 2);
                        for (let i = 0; i < count; i++) {
                            server.createObject('food', (x * server.TILE_SIZE) + 10 + (Math.random() * (server.TILE_SIZE - 20)), (y * server.TILE_SIZE) + 10 + (Math.random() * (server.TILE_SIZE - 20)), 1, 45, 45, -1, {foodType: 'plant'});
                        }
                    } else if ((tiles[y][x][0] === 0 || tiles[y][x][0] === 1) && Math.random() >= 0.992) {
                        tiles[y][x][0] = 0;
                        server.tileGrids[1].setWalkableAt(x, y, tiles[y][x][0] === 0);
                        server.createInsect('grub', (x * server.TILE_SIZE) + (server.TILE_SIZE / 2) + Math.random(), (y * server.TILE_SIZE) + (server.TILE_SIZE / 2) + Math.random(), 1, 45, 45, -1);
                    }
                }
            }
        }

        server.generateMapObjects(true);

        if (process.env.NODE_ENV === 'local') {
            for (let i=0; i<5; i++) {
                let size = Math.round(80 + (Math.random() * 100));
                let pos = server.getEdgePosition();
                server.createInsect('bug', pos.x, pos.y, 0, size, size, -1, {
                    bugType: 'centipede',
                    centipedeType: 'head'
                });
            }
        }

        switch(server.worldData.specialEvent) {
            case 'christmas':
                server.createObject('wreath', Math.random() * server.MAP_SIZE * server.TILE_SIZE, Math.random() * server.MAP_SIZE * server.TILE_SIZE, 0, 64, 64, -1);
                break;
        }

        server.updateRoundState({
            type: 'lobby'
        });

        server.resetEnvironment();

        let createTeamCount = 8;
        if (server.gamemode.type === 'coop') {
            createTeamCount = 1;
        }
        for (let i=0; i<createTeamCount; i++) {
            server.createTeam();
        }

        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            client.ready = false;
            client.player = null;
            client.team = null;
            client.playStartTime = Date.now();
            client.hasSpawned = false;
            client.unawardedXP = 0;
            client.emit('worldData', server.worldData);
            client.emit('tileData', tiles);
        }

        server.sendLobbyUpdate();

        server.roundStartTime = Date.now();

        server.sendMessage('setAnnouncement', null);

        if (server.tutorial) {
            setTimeout(() => {
                server.tutorial.start();
            }, 1000);
        }
    };

    server.sendMessage = (name, data) => {
        gameMaster.sendGlobalMessage(name, data);
    };

    const MAX_VIEW_DISTANCE = 1500;
    server.getClientViewDistance = (client) => {
        let dist = MAX_VIEW_DISTANCE;

        if (client && client.player && client.player.z <= -1) {
            dist += 250;
        }

        return dist;
    };

    server.sendLocalMessage = (entity, event, data) => {
        if (config.isSingleplayer) {
            if (server.clients && server.clients.length) {
                server.clients[0].emit(event, data);
            }
        } else {
            for (let i = 0; i < server.clients.length; i++) {
                let client = server.clients[i];

                if (client.knownEntities && client.knownEntities[entity.id]) {
                    client.emit(event, data);
                }
            }
        }
    };

    server.startGame = () => {
        if (!server.running) {
            let gamemode = 'normal';
            if (gamemodeString) {
                gamemode = gamemodeString;
            }
            if (config.gamemodeOverride) {
                gamemode = config.gamemodeOverride;
            }

            server.updateGamemode(gamemode);

            server.resetGame();
        }
    };

    server.stopGame = () => {
        server.running = false;
    };

    server.stopServer = () => {
        server.stopGame();

        for (let i=0; i<server.clients.length; i++) {
            let client = server.clients[i];
            client.disconnect();
        }
    };

    server.startLoop = () => {
        server.running = true;
        setImmediate(server.gameLoop);
        console.info('Server game loop started.');
    };

    let lastLoop = Date.now();
    server.gameLoop = () => {
        if (!server.running) {
            console.info('Server game loop halted.');
            return;
        }

        let delta = Date.now() - lastLoop;
        if (delta < fixedTimeStep) {
            let time = fixedTimeStep - delta;
            if (time < 1) {
                time = 1;
            }
            setTimeout(server.gameLoop, time);
            return;
        }
        lastLoop = Date.now();

        server.tick(delta);

        setTimeout(server.gameLoop, 1);
    };
}

Math.angleBetween = function(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x);
};
Math.distanceBetween = function(p1, p2) {
    return Math.sqrt(Math.pow((p1.x-p2.x), 2) + Math.pow((p1.y-p2.y), 2));
};
Math.magnitude = function(p1) {
    return Math.hypot(p1.dx, p1.dy);
};
module.exports = Server;

global.antwarServer = {
    Server: Server
};

let singleplayerSocket = {
    connected: true,
    to: function() {
        return singleplayerSocket;
    },
    on: function (name, fn) {
        singleplayerSocket.socketEvents[name] = fn;
    },
    emit: function (name, data) {
        postMessage({
            type: name,
            data: data
        });
    },
    sendGlobalMessage: function (name, data) {
        this.emit(name, data);
    },
    snapSocket: {
        client: {
            conn: {
                write: function (data) {
                    postMessage({
                        type: 'snapshot',
                        data: data.buffer
                    });
                }
            }
        }
    },
    user: {
        name: 'Player',
        isDev: true
    },
    socketEvents: {},
    disconnect: function () {
        if (singleplayerSocket.connected) {
            console.info('Singleplayer socket disconnected.');
            singleplayerSocket.connected = false;
            postMessage({
                type: 'disconnect'
            });
        }
    }
};

let currentSingleplayerServer;
function handleServiceWorkerMessage(event) {
    switch(event.data.type) {
        case 'DESTROY':
            if (currentSingleplayerServer) {
                currentSingleplayerServer.stopServer();
                currentSingleplayerServer = null;
            }
            break;
        case 'startServer':
            currentSingleplayerServer = new Server(singleplayerSocket, 1, () => {}, {}, null, null, event.data.data, null);
            currentSingleplayerServer.startGame();

            currentSingleplayerServer.onClientConnected(singleplayerSocket);
            break;
        case 'playerEmit':
            let msgData = event.data.data;
            if (singleplayerSocket.socketEvents && singleplayerSocket.socketEvents[msgData.type]) {
                singleplayerSocket.socketEvents[msgData.type](msgData.data);
            }
            break;
    }
}

try {
    if (self.document === undefined) {
        console.info('Running server in service worker.');
        onmessage = function (event) {
            if (event.data && event.data.type) {
                handleServiceWorkerMessage(event);
            }
        };
    }
} catch (e) {}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],require("timers").setImmediate)
},{"./entities/entity":31,"./entities/insect":32,"./entities/object":33,"./quadtree":34,"./tutorial":37,"_process":4,"buffer":2,"noisejs":8,"pathfinding":9,"timers":5}],36:[function(require,module,exports){
const PF = require('pathfinding');
var Heap       = PF.Heap;
var Util       = PF.Util;
var Heuristic  = PF.Heuristic;
var DiagonalMovement = PF.DiagonalMovement;

/**
 * A* path-finder. Based upon https://github.com/bgrins/javascript-astar
 * @constructor
 * @param {Object} opt
 * @param {boolean} opt.allowDiagonal Whether diagonal movement is allowed.
 *     Deprecated, use diagonalMovement instead.
 * @param {boolean} opt.dontCrossCorners Disallow diagonal movement touching
 *     block corners. Deprecated, use diagonalMovement instead.
 * @param {DiagonalMovement} opt.diagonalMovement Allowed diagonal movement.
 * @param {function} opt.heuristic Heuristic function to estimate the distance
 *     (defaults to manhattan).
 * @param {number} opt.weight Weight to apply to the heuristic to allow for
 *     suboptimal paths, in order to speed up the search.
 */
function TileFinder(opt) {
    opt = opt || {};
    this.allowDiagonal = opt.allowDiagonal;
    this.dontCrossCorners = opt.dontCrossCorners;
    this.heuristic = opt.heuristic || Heuristic.manhattan;
    this.weight = opt.weight || 1;
    this.diagonalMovement = opt.diagonalMovement;

    if (!this.diagonalMovement) {
        if (!this.allowDiagonal) {
            this.diagonalMovement = DiagonalMovement.Never;
        } else {
            if (this.dontCrossCorners) {
                this.diagonalMovement = DiagonalMovement.OnlyWhenNoObstacles;
            } else {
                this.diagonalMovement = DiagonalMovement.IfAtMostOneObstacle;
            }
        }
    }

    // When diagonal movement is allowed the manhattan heuristic is not
    //admissible. It should be octile instead
    if (this.diagonalMovement === DiagonalMovement.Never) {
        this.heuristic = opt.heuristic || Heuristic.manhattan;
    } else {
        this.heuristic = opt.heuristic || Heuristic.octile;
    }
}

/**
 * Find and return the the path.
 * @return {Array<Array<number>>} The path, including both start and
 *     end positions.
 */
TileFinder.prototype.findTile = function(startX, startY, checkFunction, grid) {
    var openList = new Heap(function(nodeA, nodeB) {
            return nodeA.f - nodeB.f;
        }),
        startNode = grid.getNodeAt(startX, startY),
        heuristic = this.heuristic,
        diagonalMovement = this.diagonalMovement,
        weight = this.weight,
        abs = Math.abs, SQRT2 = Math.SQRT2,
        node, neighbors, neighbor, i, l, x, y, ng;

    // set the `g` and `f` value of the start node to be 0
    startNode.g = 0;
    startNode.f = 0;

    // push the start node into the open list
    openList.push(startNode);
    startNode.opened = true;

    // while the open list is not empty
    while (!openList.empty()) {
        // pop the position of node which has the minimum `f` value.
        node = openList.pop();
        node.closed = true;

        // if reached the end position, construct the path and return it
        if (checkFunction(node, startNode)) {
            //return Util.backtrace(node);
            return node;
        }

        // get neigbours of the current node
        neighbors = grid.getNeighbors(node, diagonalMovement);
        for (i = 0, l = neighbors.length; i < l; ++i) {
            neighbor = neighbors[i];

            if (neighbor.closed) {
                continue;
            }

            x = neighbor.x;
            y = neighbor.y;

            // get the distance between current node and the neighbor
            // and calculate the next g score
            ng = node.g + ((x - node.x === 0 || y - node.y === 0) ? 1 : SQRT2);

            // check if the neighbor has not been inspected yet, or
            // can be reached with smaller cost from the current node
            if (!neighbor.opened || ng < neighbor.g) {
                neighbor.g = ng;
                neighbor.h = neighbor.h || weight * heuristic(abs(x - startX), abs(y - startY));
                neighbor.f = neighbor.g + neighbor.h;
                neighbor.parent = node;

                if (!neighbor.opened) {
                    openList.push(neighbor);
                    neighbor.opened = true;
                } else {
                    // the neighbor can be reached with smaller cost.
                    // Since its f value has been updated, we have to
                    // update its position in the open list
                    openList.updateItem(neighbor);
                }
            }
        } // end for each neighbor
    } // end while not open list empty

    // fail to find the path
    return [];
};

module.exports = TileFinder;
},{"pathfinding":9}],37:[function(require,module,exports){

function Tutorial(server, window, config) {
    this.tutorialData = null;
    console.info('Tutorial loaded!');

    let isMobile = !!config.isMobile;
    
    let primaryAction = '<imp>Click</imp>';
    let secondaryAction = '<imp>Right Click(or double tap)</imp>';
    if (isMobile) {
        primaryAction = '<imp>Tap</imp>';
        secondaryAction = '<imp>Double Tap</imp>';
    }

    let tutorialStep = -1;
    let continuing = false;
    let tutorialSteps = [
        {
            text: `Welcome to AntWar.io!\n\nThis short tutorial will teach you a little bit about how to play the game and start a nest.`,
            pause: true
        },
        {
            text: `When a new game is started, the team leader on your team will become a new queen.\n\nYou are currently a queen flying above the ground! Nothing can see you up here so you are safe.`,
            pause: true
        },
        {
            text: `New queens can create nests, and once a nest is created you will be able to create eggs to grow your colony.`,
            pause: true
        },
        {
            text: `First you need to know how to move!\n\n${primaryAction} and hold anywhere to move there.`,
            wait: 2000,
            init: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0]) {
                    server.getClients()[0].player.moveToPos = null;
                }
            },
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.moveToPos) {
                    this.continue();
                }
            }
        },
        {
            text: `Great! Now that you can move, find a good spot to create a nest.`,
            pause: true
        },
        {
            text: `${secondaryAction} somewhere to land and then again to create a nest!\n\nPick a good spot for a nest, near dry patches(Cracked ground) so that food can be stored there.\n\nIt is also good to create your nest under something so it is hidden from enemies!`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.z >= 1) {
                    this.continue();
                }
            }
        },
        {
            text: `Great! You are now nice and safe underground.`,
            pause: true
        },
        {
            text: `You start with some brood, they will soon hatch into ants that you can switch to.`,
            pause: true
        },
        {
            text: `Now we wait for the brood to hatch.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.teamData[server.getClients()[0].player.team].aliveAntCount >= 3) {
                    this.continue();
                }
            }
        },
        {
            text: `Some ants have hatched, now you can switch to one of them.`,
            pause: true
        },
        {
            text: `${primaryAction} on your ant and select <imp>Switch</imp> from the command menu. Then select one of the other ants to become it.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.subtype === 'ant_worker') {
                    this.continue();
                }
            }
        },
        {
            text: `Great you are now a nanitic! They are weak but faster than other ant types.`,
            pause: true
        },
        {
            text: `You need to expand your nest!\n\nYou will need to uncover dark brown moist spots to put brood and dry cracked light brown spots to put food.`,
            pause: true
        },
        {
            text: `${secondaryAction} on dirt to start digging and pick up some dirt.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.carriedObject && server.getClients()[0].player.carriedObject.subtype === `dirt`) {
                    this.continue();
                }
            }
        },
        {
            text: `Now that you have dirt, you need to take it outside. ${secondaryAction} on the light in the middle of the nest to go outside.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.z === 0) {
                    this.continue();
                }
            }
        },
        {
            text: `${secondaryAction} to drop the dirt outside.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && !server.getClients()[0].player.carriedObject) {
                    this.continue();
                }
            }
        },
        {
            init: () => {
                try {
                    if (window && window.ga) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'Lobby',
                            eventAction: 'tutorialHalfComplete'
                        });
                    }
                } catch (e) {}
            },
            text: `Now ${secondaryAction} on your hole to go back underground. We have more work to do!`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.z > 0) {
                    this.continue();
                }
            }
        },
        {
            text: `Great! Now we need to get food to feed our queen and brood!`,
            pause: true
        },
        {
            text: `We can lead our fellow ants outside to help us search and gather more food.`,
            pause: true
        },
        {
            text: `${primaryAction} on your ant to open the command menu and select "+5 Follow".\n\nThis will get 5 of your fellow workers to follow you.`,
            wait: 1000,
            init: () => {
                if (server.getClients()[0] && server.getClients()[0].player) {
                    let angle = Math.random() * Math.PI * 2;
                    server.spawnFoodPile({
                        x: server.getClients()[0].player.x + (Math.cos(angle) * 450),
                        y: server.getClients()[0].player.y + (Math.sin(angle) * 450)
                    });
                }
            },
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.followers && server.getClients()[0].player.followers.length > 1) {
                    this.continue();
                }
            }
        },
        {
            text: `Great, now return outside and your workers will follow you!`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.z === 0) {
                    this.continue();
                }
            }
        },
        {
            text: `Now that you are outside you can search for food. Food will look like green pellets, these pellets can be found outside on the ground.\n\nYou can also kill bugs to get food!`,
            pause: true
        },
        {
            text: `Now find some food! Search around and once you find food ${secondaryAction} to pick it up!\n\nYou can also ${secondaryAction} on bugs to attack them and your workers will help you.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && (server.getClients()[0].player.socialFoodStorage >= 1 || (server.getClients()[0].player.carriedObject && server.getClients()[0].player.carriedObject.subtype === `food`))) {
                    this.continue();
                }
            }
        },
        {
            text: `Great, you found some food! The food you picked up was stored in your <imp>social stomach</imp>, you can carry up to two pieces of food this way.\n\nNow that you found food you need to release your workers and let them get the food as well.`,
            pause: true,
        },
        {
            text: `${primaryAction} your ant to open the command menu and then select "Dismiss".`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.followers && server.getClients()[0].player.followers.length <= 0) {
                    this.continue();
                }
            }
        },
        {
            text: `Great! Now your workers will grab the food as well and return to the nest. We should go back as well!`,
            pause: true
        },
        {
            text: `Return to your nest and go underground. (If you are lost, follow the white arrow back to your nest.)`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.z === 1) {
                    this.continue();
                }
            }
        },
        {
            text: `Food needs to be on the dry cracked light brown dirt or else it will spoil! Place your food there if you have one uncovered.\n\nIf you don\`t have any uncovered, dig out some more tiles!`,
            pause: true
        },
        {
            text: `Food is used to create and feed brood, yourself, and the queen. You will know something needs to be fed because a hunger icon will appear over it!`,
            pause: true
        },
        {
            text: `Now we will wait for the queen to get hungry,`,
            wait: 1000,
            init: () => {
                setTimeout(() => {
                    if (server.getClients()[0].player.queen) {
                        server.getClients()[0].player.queen.setHungry(true);
                    }
                }, 6000);
            },
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.queen && server.getClients()[0].player.queen.netData && server.getClients()[0].player.queen.netData.hungry) {
                    this.continue();
                }
            }
        },
        {
            text: `The queen is hungry! A worker must feed her, if she goes too long with out food she will die.`,
            pause: true
        },
        {
            text: `If there are workers in the nest they will feed the queen as long as there is food nearby.`,
            pause: true
        },
        {
            text: `You can feed the queen by picking up food and dropping it on her.\n\nIf you have food stored in your <imp>social stomach</imp> you can also use that to feed the queen.`,
            pause: true
        },
        {
            text: `Feed the queen or wait for another worker to feed her.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.queen && server.getClients()[0].player.queen.netData && !server.getClients()[0].player.queen.netData.hungry) {
                    this.continue();
                }
            }
        },
        {
            text: `Great the queen is happy! You will need to do the same for brood eventually as well, as new ants will not grow unless the larvae is fed.`,
            pause: true
        },
        {
            text: `Now lets create a new egg, press the Queen button in the top left to open the queen menu and select <imp>"+ Nanitic"</imp> to queue brood.`,
            wait: 1000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.queen && server.getClients()[0].player.queen.broodQueue.length >= 1) {
                    this.continue();
                }
            }
        },
        {
            text: `Now that egg is queued, feed the queen the required food for her to lay the egg. Other ants will also help feed the queen.`,
            pause: true
        },
        {
            text: `Now that egg is queued, feed the queen the required food for her to lay the egg. Other ants will also help feed the queen.\n\nA nanitic worker requires two green food, as shown over the queen.`,
            wait: 2000,
            objective: () => {
                if (server.getClients()[0] && server.getClients()[0].player && server.getClients()[0].player.queen && server.getClients()[0].player.queen.broodQueue.length >= 1 && Object.keys(server.getClients()[0].player.queen.broodQueue[0].cost).length <= 0) {
                    this.continue();
                }
            }
        },
        {
            text: `Now that the queen has the right food, she will soon lay an egg that will mature and become an ant.\n\nFor an egg to grow the quickest you must put it on dark brown soil, you can create this with rain drops or find it underground.`,
            pause: true
        },
        {
            text: `That is the basics of how to get a nest started!`,
            pause: true
        },
        {
            text: `There are many things that weren\`t covered here, but with this knowledge you can feed and grow your colony.`,
            pause: true
        },
        {
            text: `The goal of AntWar.io is to kill all other enemy queens. You can invade their nests with your ants to kill them and steal their brood!`,
            pause: true
        },
        {
            text: `It is recommended that after this you play the singleplayer skirmish to fight computer controlled colonies and get used to attacking enemy nests.`,
            pause: true
        },
        {
            text: `For now you can continue this game without any enemies. When you are ready you can leave the tutorial by tapping the menu in the top right and selecting disconnect.\n\nGood luck out there! (Also watch out for spiders and centipedes!)`,
            pause: true,
            init: () => {
                try {
                    if (window && window.ga) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'Lobby',
                            eventAction: 'tutorialComplete'
                        });
                    }
                } catch (e) {}
            }
        }
    ];

    this.start = () => {
        this.continue();
    };

    this.continue = () => {
        if (!continuing) {
            continuing = true;
            setTimeout(() => {
                tutorialStep++;
                if (tutorialSteps[tutorialStep] && tutorialSteps[tutorialStep].init) {
                    tutorialSteps[tutorialStep].init();
                }
                this.updateTutorial(tutorialSteps[tutorialStep]);
            }, (tutorialSteps[tutorialStep] && tutorialSteps[tutorialStep].wait) ? tutorialSteps[tutorialStep].wait : 0)
        }
    };

    this.tick = () => {
        if (tutorialSteps && tutorialSteps[tutorialStep] && tutorialSteps[tutorialStep].objective) {
            tutorialSteps[tutorialStep].objective();
        }
    };

    this.updateTutorial = (data) => {
        continuing = false;
        if (data && data.pause) {
            if (isMobile) {
                data.text += '\n\n<imp>Double Tap to Continue >>></imp>';
            } else {
                data.text += '\n\n<imp>Press Spacebar to Continue >>></imp>';
            }
        }
        this.tutorialData = data;
        if (this.tutorialData) {
            server.sendMessage('tutorialData', JSON.parse(JSON.stringify(this.tutorialData)));
        } else {
            server.sendMessage('tutorialData', null);
        }
    };
}
module.exports = Tutorial;
},{}]},{},[35]);
